var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-a-whole-year",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes wind{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}75%{transform:rotate(-1deg)}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}svg#freepik_stories-a-whole-year:not(.animated) .animable{opacity:0}svg#freepik_stories-a-whole-year.animated #freepik--speech-bubble--inject-103{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-103",
    className: "animable",
    style: {
      transformOrigin: "250px 359.25px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-103",
    cx: 250,
    cy: 359.25,
    rx: 218.84,
    ry: 126.35,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 359.25px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-103",
    className: "animable",
    style: {
      transformOrigin: "239.724px 382.899px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-103",
    d: "m177.76 461.57-74.32-42.9c-1.91-1.11-1.91-2.9 0-4l191.3-110.45a7.69 7.69 0 0 1 6.93 0L376 347.13c1.92 1.1 1.92 2.89 0 4L184.69 461.57a7.63 7.63 0 0 1-6.93 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "239.724px 382.899px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-103",
    className: "animable",
    style: {
      transformOrigin: "249.825px 157.816px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hearts--inject-103",
    className: "animable",
    style: {
      transformOrigin: "150.023px 130.658px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.51 123.3a6.07 6.07 0 0 0-4.55 6.58 6.06 6.06 0 0 0-11.5 3.73c1.57 6.14 8.79 8.53 11.5 9.42l3.66 1.21 2.64-2.81c2-2.09 7.16-7.63 5.59-13.77a6 6 0 0 0-7.34-4.36Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "140.212px 133.673px"
    },
    id: "el03mf5fy4c5bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.28 119.6a3.61 3.61 0 0 0-4.37 1.88 3.61 3.61 0 0 0-7-1.76c-1.15 3.59 1.73 7.08 2.82 8.39l1.46 1.77 2.23-.58c1.64-.44 6-1.59 7.17-5.18a3.59 3.59 0 0 0-2.31-4.52Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "164.704px 123.478px"
    },
    id: "elvx9js3umlb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Snowflake--inject-103",
    className: "animable",
    style: {
      transformOrigin: "63.1686px 52.5426px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.71 40.67a.68.68 0 0 0 .75.16l.82.87h-1.34a.24.24 0 0 0-.26.25.25.25 0 0 0 .25.25h1.83l.77.81h-2.21a.26.26 0 0 0 0 .51h2.71l.54.57-1.15 3.83-.76.18-2.29-1.45h-.06a.26.26 0 0 0-.21.46l1.9 1.18-1.08.25-1.55-1h-.06a.26.26 0 0 0-.29.11.25.25 0 0 0 .08.35l1.13.72L62 49a.68.68 0 0 0-.72-.27.69.69 0 1 0 .84.77l1.15-.27-.68 1.14a.26.26 0 0 0 .09.35.24.24 0 0 0 .35-.09L64 49l1.08-.26-1.13 1.9A.25.25 0 0 0 64 51a.26.26 0 0 0 .35-.09l1.39-2.32.76-.18 2.74 2.9-.22.76-2.4 1.25a.25.25 0 0 0-.11.34.25.25 0 0 0 .34.11l2-1-.32 1.07-1.62.85a.24.24 0 0 0-.11.34.25.25 0 0 0 .34.11l1.19-.62-.33 1.15a.69.69 0 1 0 .72.88.7.7 0 0 0-.23-.74l.34-1.13.65 1.16a.25.25 0 0 0 .35.1.24.24 0 0 0 .09-.34L69 54l.32-1.06 1.07 1.93a.26.26 0 0 0 .35.09.25.25 0 0 0 .1-.34l-1.31-2.37.22-.75 3.89-.92.54.57-.12 2.7a.27.27 0 0 0 .25.27.24.24 0 0 0 .26-.25l.1-2.2.76.81-.08 1.83a.27.27 0 0 0 .25.27.26.26 0 0 0 .26-.25l.07-1.33.82.86a.67.67 0 0 0 .12.76.69.69 0 1 0 .25-1.11l-.82-.86h1.34a.26.26 0 0 0 .26-.25.26.26 0 0 0-.18-.25H75.81l-.76-.81h2.21a.24.24 0 0 0 .25-.25.25.25 0 0 0-.18-.25h-2.77l-.56-.62 1.14-3.83.77-.18 2.28 1.45a.26.26 0 0 0 .36-.08.26.26 0 0 0-.08-.35l-1.87-1.18 1.09-.26 1.55 1a.25.25 0 0 0 .35-.08.26.26 0 0 0-.08-.35l-1.13-.72 1.16-.27a.68.68 0 0 0 .72.27.67.67 0 0 0 .51-.82.7.7 0 0 0-.83-.52.69.69 0 0 0-.52.57l-1.16.28L79 44a.26.26 0 0 0-.09-.35h-.06a.25.25 0 0 0-.29.11l-.94 1.57-1.08.26 1.13-1.9a.26.26 0 0 0-.09-.35h-.06a.26.26 0 0 0-.29.11l-1.39 2.32-.76.19L72.31 43l.22-.75 2.4-1.25a.26.26 0 0 0 .11-.34.29.29 0 0 0-.16-.13.25.25 0 0 0-.19 0l-2 1 .32-1.06 1.62-.85a.27.27 0 0 0 .11-.35.24.24 0 0 0-.16-.12.25.25 0 0 0-.19 0l-1.18.62.34-1.13a.71.71 0 0 0 .6-.49.69.69 0 0 0-1.32-.4.7.7 0 0 0 .23.74l-.34 1.14-.65-1.17a.26.26 0 0 0-.15-.12.28.28 0 0 0-.2 0 .27.27 0 0 0-.1.35l.9 1.6-.32 1.07-1.08-1.93a.26.26 0 0 0-.15-.12.21.21 0 0 0-.19 0 .25.25 0 0 0-.1.35L72 42.09l-.22.75-3.89.93-.54-.58.11-2.7a.26.26 0 0 0-.18-.26h-.06a.27.27 0 0 0-.27.25l-.09 2.2-.76-.81.11-1.87a.24.24 0 0 0-.18-.25H66a.26.26 0 0 0-.27.24v1.34l-.82-.87a.67.67 0 0 0-.12-.76.68.68 0 0 0-1 0 .69.69 0 0 0-.08.97Zm9.53 9.46-3.31.78 1-3.25Zm1.34-3.6-1 3.25-2.33-2.47Zm-2.45-3L74.46 46l-3.3.79Zm-3.79.63 3.3-.78-1 3.25ZM67 47.8l1-3.25L70.3 47Zm2.45 3-2.33-2.5 3.3-.78Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "70.7688px 47.1645px"
    },
    id: "el7w2xmdlkh6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.53 56.26a.5.5 0 0 0 .53.11l.57.61h-.94a.17.17 0 0 0-.18.17.19.19 0 0 0 .18.19h1.29l.53.57h-1.55a.18.18 0 0 0-.18.18.18.18 0 0 0 .17.18h1.91l.38.4-.81 2.7-.54.13-1.6-1a.18.18 0 0 0-.2.08.18.18 0 0 0 .05.25l1.32.83-.77.18-1.09-.69a.2.2 0 0 0-.21.08.18.18 0 0 0 .06.24l.79.51-.81.19a.48.48 0 0 0-.51-.19.48.48 0 0 0-.36.58.49.49 0 0 0 .59.36.47.47 0 0 0 .36-.4l.82-.19-.49.81a.17.17 0 0 0 .07.24.17.17 0 0 0 .24-.06l.67-1.11.76-.18-.8 1.33a.18.18 0 0 0 .31.19l1-1.63.54-.13 1.93 2-.16.53-1.69.89a.18.18 0 0 0-.08.24.17.17 0 0 0 .24.07l1.38-.72-.22.76-1.15.59a.19.19 0 0 0-.07.25.18.18 0 0 0 .24.07l.83-.43-.23.8a.48.48 0 0 0-.1.94.47.47 0 0 0 .6-.32.48.48 0 0 0-.16-.52l.24-.8.46.82a.17.17 0 0 0 .24.07.17.17 0 0 0 .07-.24l-.63-1.13.23-.75.75 1.36a.2.2 0 0 0 .25.07.19.19 0 0 0 .07-.25l-.93-1.66.16-.53 2.74-.65.38.4-.08 1.9a.17.17 0 0 0 .17.19.19.19 0 0 0 .19-.17L55.25 64l.54.57-.06 1.29a.19.19 0 0 0 .18.18.17.17 0 0 0 .18-.17v-.94l.58.61a.48.48 0 0 0 .77.55.48.48 0 0 0-.51-.8l-.58-.61h1a.18.18 0 0 0 .18-.18.17.17 0 0 0-.13-.17h-1.29l-.54-.57h1.56a.17.17 0 0 0 .18-.17.17.17 0 0 0-.13-.18h-1.9l-.38-.4.8-2.69.54-.13 1.61 1a.18.18 0 0 0 .25-.06.17.17 0 0 0-.06-.24L56.62 60l.76-.18 1.09.69a.18.18 0 0 0 .25 0 .18.18 0 0 0 0-.25l-.8-.5.82-.2a.48.48 0 0 0 .86-.39.48.48 0 0 0-.6-.37.49.49 0 0 0-.37.4l-.81.2.48-.81a.18.18 0 0 0-.06-.25.2.2 0 0 0-.21.08l-.66 1.11-.76.18.8-1.33a.18.18 0 0 0-.07-.25.16.16 0 0 0-.2.08l-1 1.63-.54.13-1.93-2 .16-.53 1.69-.88a.17.17 0 0 0 .07-.24.15.15 0 0 0-.1-.09.23.23 0 0 0-.14 0l-1.38.72.23-.75 1.14-.6a.17.17 0 0 0 .08-.24.14.14 0 0 0-.11-.09.2.2 0 0 0-.13 0l-.84.44.24-.8a.49.49 0 0 0 .42-.35.48.48 0 1 0-.93-.27.51.51 0 0 0 .17.52l-.24.8-.46-.83a.16.16 0 0 0-.1-.08.17.17 0 0 0-.14 0 .18.18 0 0 0-.07.25l.53 1.05-.22.75-.76-1.36a.22.22 0 0 0-.1-.09.17.17 0 0 0-.14 0 .17.17 0 0 0-.07.24l.93 1.67-.16.53-2.74.65-.38-.39.08-1.9a.19.19 0 0 0-.13-.18.19.19 0 0 0-.19.18l-.06 1.55-.54-.57v-1.29a.17.17 0 0 0-.13-.18.19.19 0 0 0-.19.17v.94l-.57-.6a.49.49 0 0 0-.09-.54.49.49 0 0 0-.68 0 .48.48 0 0 0-.09.68Zm6.71 6.66-2.33.55.69-2.29Zm.94-2.54-.68 2.29-1.64-1.74Zm-1.72-2.08L55.1 60l-2.33.56Zm-2.67.45 2.33-.56-.69 2.29Zm-.95 2.53.69-2.28 1.64 1.74Zm1.73 2.09-1.64-1.74 2.32-.55Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "52.5805px 60.8722px"
    },
    id: "ely578zomwxk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flowers--inject-103",
    className: "animable",
    style: {
      transformOrigin: "40.4746px 152.981px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.65 144.17c-3.16.68-11.94-4.19-7.3-8.29s8.38 5.23 7.3 8.29Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "40.4307px 139.545px"
    },
    id: "eltjs6kx3mha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35 144.27c-.68-3.16 4.19-11.94 8.29-7.3s-5.23 8.38-8.29 7.3Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "50.9751px 140.051px"
    },
    id: "elh8g3e8twprg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.25 146c3.16-.68 11.94 4.19 7.3 8.29s-8.38-5.29-7.3-8.29Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "50.4693px 150.623px"
    },
    id: "el0tlb6vglek1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.55 145.87c.68 3.16-4.19 11.94-8.29 7.3s5.23-8.38 8.29-7.3Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "39.9249px 150.089px"
    },
    id: "el6bhgl4e7i1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.51 144c-2.72-1.75-3.76-11.3.69-11s2.23 9.57-.69 11Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "45.943px 138.497px"
    },
    id: "eljondkvsu03",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61 145c1.75-2.72 11.3-3.76 11 .69s-9.61 2.22-11-.69Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "52.1135px 145.432px"
    },
    id: "el6f6ruc43tt2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.58 146.08c2.73 1.76 3.76 11.3-.69 11s-2.23-9.6.69-11Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "45.1488px 151.583px"
    },
    id: "elw3fxsmsbbci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.49 145.06c-1.75 2.73-11.3 3.76-11-.69s9.6-2.23 11 .69Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "38.9865px 144.629px"
    },
    id: "elcj5ks1foowv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.13 142.71a3.57 3.57 0 1 0-.32 5 3.57 3.57 0 0 0 .32-5Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "45.4317px 145.048px"
    },
    id: "elsimlceb33k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.71 172.24a1.1 1.1 0 0 0 1.25-.41 1.11 1.11 0 0 0 .76 1.08 1.09 1.09 0 0 0 1.39-.69 7.55 7.55 0 0 0 .24-2.27 7.74 7.74 0 0 0 1.07 1.92A1.11 1.11 0 0 0 33 172a1.09 1.09 0 0 0 .27-1.29 1.1 1.1 0 0 0 1.39-1.71 7.63 7.63 0 0 0-1.84-1.34 7.67 7.67 0 0 0 2.2 0 1.1 1.1 0 0 0 .86-1.3 1.11 1.11 0 0 0-1-.88 1.1 1.1 0 0 0-.74-2.05 7.64 7.64 0 0 0-2.08.93 8 8 0 0 0 1.13-1.89 1.11 1.11 0 0 0-.7-1.4 1.1 1.1 0 0 0-1.25.41 1.1 1.1 0 0 0-2.15-.39 7.85 7.85 0 0 0-.24 2.27 7.55 7.55 0 0 0-1.07-1.92 1.1 1.1 0 0 0-1.78 1.23 1.1 1.1 0 0 0-1.41 1.66 7.64 7.64 0 0 0 1.85 1.35 7.78 7.78 0 0 0-2.2 0 1.1 1.1 0 0 0 .11 2.18 1.11 1.11 0 0 0 .74 2.06 7.66 7.66 0 0 0 2.09-.93 7.48 7.48 0 0 0-1.18 1.85 1.1 1.1 0 0 0 .71 1.4Zm3.34-3.71a1.27 1.27 0 0 0-.74-.7 1.33 1.33 0 0 0-1.09.15 1.28 1.28 0 0 0 .24-1 1.36 1.36 0 0 0-.67-.87 1.24 1.24 0 0 0 1-.29 1.32 1.32 0 0 0 .42-1 1.32 1.32 0 0 0 .73.7 1.36 1.36 0 0 0 1.09-.15 1.27 1.27 0 0 0-.24 1 1.36 1.36 0 0 0 .67.86 1.22 1.22 0 0 0-1.38 1.31Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "29.6174px 166.64px"
    },
    id: "elra7c6g7jv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 165.41a1.91 1.91 0 1 0-.17 2.69 1.91 1.91 0 0 0 .17-2.69Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "29.5642px 166.67px"
    },
    id: "elger37t4n1ql",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lemon--inject-103",
    className: "animable",
    style: {
      transformOrigin: "125.23px 227.815px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lemon--inject-103",
    className: "animable",
    style: {
      transformOrigin: "118.9px 231.29px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.91 241.25a10 10 0 1 1 10-10 10 10 0 0 1-10 10Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "118.91px 231.25px"
    },
    id: "el84eixct4i95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91 221.94a9.34 9.34 0 1 1-9.34 9.34 9.35 9.35 0 0 1 9.34-9.34m0-1.24a10.59 10.59 0 1 0 10.58 10.58 10.59 10.59 0 0 0-10.58-10.58Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "118.9px 231.29px"
    },
    id: "elv5cd1ddnsto",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.36 223.22a.64.64 0 0 1 .64-.64.57.57 0 0 1 .22 0l3.28 1.2a.63.63 0 0 1 .27 1l-4.41 5.26Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "121.639px 226.305px"
    },
    id: "elp3qfbjary4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05 224.83a.62.62 0 0 1-.13-.58.65.65 0 0 1 .4-.44l3.28-1.19a.57.57 0 0 1 .22 0 .64.64 0 0 1 .64.64v6.87Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "116.178px 226.37px"
    },
    id: "elfewyjcsxg6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 229.47a.62.62 0 0 1-.47-.36.65.65 0 0 1 0-.59l1.75-3a.64.64 0 0 1 .56-.32.65.65 0 0 1 .49.23l4.41 5.25Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "114.1px 227.94px"
    },
    id: "elmrc1qrz92t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35 235.07a.64.64 0 0 1-.64-.53l-.6-3.44a.58.58 0 0 1 .14-.52.62.62 0 0 1 .48-.23h.12l6.76 1.19-6 3.43a.59.59 0 0 1-.26.1Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "113.853px 232.71px"
    },
    id: "elq4xtaf7tzws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11 239.21a.66.66 0 0 1-.41-.15l-2.7-2.25a.62.62 0 0 1-.22-.55.59.59 0 0 1 .31-.49l6-3.46-2.38 6.47a.63.63 0 0 1-.6.43Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "114.933px 235.76px"
    },
    id: "elc2jz289ugdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.16 240a.66.66 0 0 1-.53-.27.62.62 0 0 1-.07-.59l2.35-6.45 2.34 6.45a.62.62 0 0 1-.07.59.66.66 0 0 1-.53.27Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "118.905px 236.345px"
    },
    id: "elxoev0r5tlgq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.71 239.21a.64.64 0 0 1-.61-.42l-2.35-6.47 6 3.45a.64.64 0 0 1 .32.5.68.68 0 0 1-.23.55l-2.68 2.24a.59.59 0 0 1-.45.15Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "122.911px 235.766px"
    },
    id: "eljv1p8xt291n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47 235.08a.62.62 0 0 1-.32-.09l-6-3.43 6.77-1.2h.11a.65.65 0 0 1 .49.23.67.67 0 0 1 .14.53l-.61 3.44a.64.64 0 0 1-.58.52Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "123.909px 232.72px"
    },
    id: "elambqw18v0t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46 225.41a.64.64 0 0 1 1.05.09l1.75 3a.65.65 0 0 1-.45.95l-6.76 1.19Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "123.695px 227.908px"
    },
    id: "elc8az4a0nfw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.52 228.52s6.71-.52 7.93-6-.26-8.77-.26-8.77-5.55 2.22-7.05 4.16-2.78 5.4-.62 10.61Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "134.152px 221.135px"
    },
    id: "elvyy0rmsqxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 229.93s.74 4.54 4.76 5.53a8.45 8.45 0 0 0 6.39-.58 9.89 9.89 0 0 0-3.35-5c-1.42-1-4.05-1.76-7.8.05Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "136.575px 232.335px"
    },
    id: "elycmdgf9w4zj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Umbrella--inject-103",
    className: "animable",
    style: {
      transformOrigin: "28.5465px 268.43px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.23 281.7a3.76 3.76 0 0 1-4.47-2.88l-3.31-15.15a.53.53 0 1 1 1-.23l3.35 15.16a2.69 2.69 0 0 0 5.26-1.15.54.54 0 0 1 1-.23 3.77 3.77 0 0 1-2.83 4.48Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "32.7689px 272.34px"
    },
    id: "el3osyxnefan4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.07 263.29a.62.62 0 0 1-.76.84 2.8 2.8 0 0 0-1.65-.14 2.84 2.84 0 0 0-2 1.7.6.6 0 0 1-1 .21 2.84 2.84 0 0 0-4.57 1 .59.59 0 0 1-1 .21 2.85 2.85 0 0 0-4.57 1 .59.59 0 0 1-1 .21 2.84 2.84 0 0 0-4.56 1 .6.6 0 0 1-1 .21 2.79 2.79 0 0 0-2.54-.7 2.94 2.94 0 0 0-1.45.81.62.62 0 0 1-1-.44 14.15 14.15 0 0 1 27-5.9Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "28.5465px 262.423px"
    },
    id: "elivoylwnqwic",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sun-glasses--inject-103",
    className: "animable",
    style: {
      transformOrigin: "443.161px 48.3226px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.23 50.19s-6.8-6.55-15.24-2.6c0 0 .48 7.69 4.68 9.07 7.86 2.57 10.73-4.55 10.56-6.47Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "429.614px 51.768px"
    },
    id: "elev1nhf0apd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.77 49.92s-1-9.38 7.23-13.67c0 0 5.8 5.08 4.33 9.25-2.75 7.79-10.15 5.73-11.56 4.42Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "443.65px 43.7166px"
    },
    id: "elw3f1bdlcwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.31 48.72a.85.85 0 0 1-1.13-.39l-2-4c-.2-.41 1.31-1.16 1.51-.74l2 4a.84.84 0 0 1-.38 1.13Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "421.97px 46.1349px"
    },
    id: "el4tzands4jkx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.18 37.94a.84.84 0 0 1-1.13-.38l-2-4c-.2-.42 1.3-1.16 1.51-.74l2 4a.84.84 0 0 1-.38 1.12Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "443.838px 35.3621px"
    },
    id: "elziydqb4nds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.75,
    y: 48.71,
    width: 3.41,
    height: 2.73,
    rx: 0.53,
    style: {
      fill: "#f0f0f0",
      transformOrigin: "437.455px 50.075px",
      transform: "rotate(-26.98deg)"
    },
    className: "animable",
    id: "elqaygo9jqjik"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.64,
    y: 48.92,
    width: 1.62,
    height: 2.3,
    rx: 0.14,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "437.45px 50.07px",
      transform: "rotate(63.02deg)"
    },
    className: "animable",
    id: "el3bcmx67mn4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.28 63a5.21 5.21 0 0 0 1.61-1.49c.17-6.93 3.27-15.16 3.27-15.16l-1.2-1s-4.15 6.11-9.18 9.51c-5 3.4-12.24 5-12.24 5l.47 1.49s8.78.19 15.29 2.6a5.37 5.37 0 0 0 2-.93Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "454.85px 54.65px"
    },
    id: "elfspzaeopd8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "346.362px 127.516px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347 123.13a3.45 3.45 0 0 0-2.38.12c-.15-1.46-1.4-3.66-7.33-5.49-5.76-1.78-8.06-.78-9.05.32l-1.14-.35a.92.92 0 0 0-1.15.67l-.33 1.08a.87.87 0 0 0 .59 1.15l.81.25c-.68 3-.71 8.31 6.16 10.43H333c5.32 1.64 8.32-.7 9.91-3.1.76-1.2 1.67-3.62 3.43-3.07s1.14 3.05 1.1 4.47c0 2.88 1.12 6.5 6.44 8.14l-.12-.06c6.88 2.12 9.86-2.32 11-5.15l.81.25a.94.94 0 0 0 1.22-.59l.33-1.08a1 1 0 0 0-.65-1.23l-1.14-.35c-.2-1.47-1.53-3.58-7.3-5.36-5.93-1.83-8.19-.72-9.14.41a3.45 3.45 0 0 0-1.91-1.45",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "346.362px 127.516px"
    },
    id: "el5rp4gjf32qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62 129.43c6.43 2 8.33-3.47 8.59-4.78.13-.65 1-3.05-5.51-5.06s-7.14.47-7.4 1.08c-.53 1.22-2 6.8 4.41 8.78Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "335.546px 124.342px"
    },
    id: "el7v6i0peej8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.46 135.86c-6.43-2-4.93-7.57-4.41-8.79.26-.61.87-3.09 7.41-1.08s5.63 4.42 5.5 5.07c-.25 1.3-2.16 6.75-8.59 4.77Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "356.298px 130.738px"
    },
    id: "eloozbl5kowy",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pumpking--inject-103",
    className: "animable",
    style: {
      transformOrigin: "467.177px 157.31px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.79 152s-.05-.1-.08-.14c-2.26-4.17-6.9-5.42-9.68-4.56-2.44.76-2.13 2.09-1.92 2.56a10.9 10.9 0 0 0-2.07-2.28 8.31 8.31 0 0 0-3.36-1.54c-.8-.08-1.58-.1-2.08.64s-.36 1.17-.71 1.23-1 .26-1 .26a2.48 2.48 0 0 0 .72 1.6 3.63 3.63 0 0 1 0-1.14c.13-.18.58.37.9.23s.22-1 .81-1a1.79 1.79 0 0 1 1.49 1.72 3 3 0 0 1-.78 1.95c-.28-.56-.66-1.5-3.2-.71-2.78.86-5.89 4.52-5.39 9.24v.15a9.45 9.45 0 0 0 .4 1.82c1.56 5 5.58 6.33 7.27 5.72 2.35 1.26 5 1.05 6.13 0a5.21 5.21 0 0 0 2.94-.1 5.27 5.27 0 0 0 2.49-1.59c1.58.23 3.84-1.07 5.06-3.44 1.75-.45 4.32-3.8 2.75-8.84a9.41 9.41 0 0 0-.69-1.78Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "467.177px 157.31px"
    },
    id: "elow7jg3ji59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 158.86a4.57 4.57 0 0 1-3.28-.33 14.92 14.92 0 0 1-.48 2.44l-2-1.48a27.9 27.9 0 0 1-1.07 2.68 12.16 12.16 0 0 1-1.66-1.61l-1.44 2.19s-.82-1.39-1.18-2.1a14.69 14.69 0 0 1-3.79 1.48 4.49 4.49 0 0 0 3.07 0l1.86 2.44 1.77-2.25 1.81 1.86 1.2-2.68 2.75 1.14v-2.7a3 3 0 0 0 2.44-1.08Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "467.55px 161.55px"
    },
    id: "eldpxo3jlwww6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.35 154.85s3.91 3.06 5.81 3.21c0 0-2.58 1.92-4.68 1.39-1-1.18-1.13-4.6-1.13-4.6Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "462.255px 157.196px"
    },
    id: "elqzhvjubwg9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89 151s-1.09 4.84-2.47 6.16c0 0 3.21-.15 4.51-1.89.07-1.54-2.04-4.27-2.04-4.27Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "471.676px 154.08px"
    },
    id: "el7hclwfa9tns",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Bat--inject-103",
    d: "M392.43 224.08c.21.21-.57.93-1.09 2s0 1.5.9 1.17a5.08 5.08 0 0 0 2.15-2.7c.56-1.24.57-2 5.64-.49s6.6-.25 7.42-.93 1.35-.68.57 1.42-1.82 2.77-4.48 3.34-2.42 3.74-2.42 3.74-3.89-2.94-5.19 1.59c0 0-2.22-2.72-4.79-2.62-3.15.12-4.78 3.42-5.49 3s1.2-3.54-.39-6.26c-1.3-2.22-4.79-2.62-4.79-2.62 3.12-3.54-1.45-5.24-1.45-5.24s2.79-1.49 1.85-4-.95-3.79.4-5.58 1.65-1.32 1.52-.28-.83 3.31 3.2 6.75 3.36 3.88 2.62 5a5.08 5.08 0 0 0-1.12 3.28c.19.9.85 1.14 1.47.13s.83-2.11 1.1-2-.4 1.41.5 1.9 1.72-.74 1.87-.6Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.711px 221.167px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xmas-tree--inject-103",
    className: "animable",
    style: {
      transformOrigin: "473.34px 268.272px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.34 278.49h2.41v3.75a.55.55 0 0 1-.55.55h-1.32a.55.55 0 0 1-.55-.55v-3.75h.01Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "473.54px 280.64px",
      transform: "rotate(-7.9deg)"
    },
    className: "animable",
    id: "elsz0mgmizqiq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.39 276.55a3.29 3.29 0 0 0 4.29.37l-6.06-7.81-13.19 2-3.43 8.38a4.13 4.13 0 0 0 3.92-.93 1.73 1.73 0 0 0 1.64 1.9c1.6.11 2.73-1.74 2.73-1.74a3.55 3.55 0 0 0 3.21 1.49 3 3 0 0 0 2.34-2.48 3 3 0 0 0 3.39 1.11c1.43-.45 1.16-2.29 1.16-2.29Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "473.34px 274.787px"
    },
    id: "el1ptxrv4efc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.76 263.25-5 10a4.2 4.2 0 0 0 4.49-.4s.34 1.68 1.56 1.86c2.18.31 3.4-1.86 3.4-1.86s1.66 1.55 3.23 1a1.82 1.82 0 0 0 1.06-2.28s3.19 1.13 5.41-.75l-7.38-8.54Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "472.335px 268.51px"
    },
    id: "ell3zbr2lcllf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.05 255.87s-5.19 10.05-5.79 10.68 2.91.63 3.65-.5a1.46 1.46 0 0 0 1.31 1.47c1.33.16 2.18-1.67 2.18-1.67s1.43 1.4 2.76 1 .87-2.17.87-2.17a3.65 3.65 0 0 0 3.73.12Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "471.476px 261.7px"
    },
    id: "el7aacbpv50d3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.58 257c.4-.21 1.26-.49 1.26-.87 0-.34-1.15-.64-1.4-.72a.57.57 0 0 1-.29-.16.28.28 0 0 1-.1-.16c-.06-.35.06-1.4-.43-1.48-.46-.06-.95 1-1.09 1.2a.43.43 0 0 1-.12.14c-.09.05-.19 0-.41 0-.55-.12-1.29-.34-1.48 0s.68 1.27.76 1.37a.56.56 0 0 1 .09.21.43.43 0 0 1 0 .24c-.12.23-.86 1.2-.53 1.5s1.21-.17 1.53-.27a.8.8 0 0 1 .37-.06.65.65 0 0 1 .31.21c.41.42.77 1 1.05.88h.07c.21-.15.23-.83.2-1.38a.62.62 0 0 1 .07-.42.35.35 0 0 1 .14-.23Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "470.166px 256.327px"
    },
    id: "el70wc6mx1yzm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Months--inject-103",
    className: "animable animator-active",
    style: {
      transformOrigin: "251.871px 198.362px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,1.5s Infinite linear wind",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--months--inject-103",
    className: "animable",
    style: {
      transformOrigin: "125.733px 82.5859px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.83 105.72-19.05-43.47a.63.63 0 0 0-.84-.3l-58.1 25.5a.63.63 0 0 0-.35.82l12.66 28.89c1.16 2.63 3.11 3.82 5.91 4.79l.59.2 1 .31.59.18c1.25.36 2.63.73 4.15 1.19s2.67.78 3.75 1l.64.15a11.18 11.18 0 0 0 7.31-.37l.55-.24 40.75-17.89a.63.63 0 0 0 .44-.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "101.647px 93.6568px"
    },
    id: "elxljhelu638d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.83 105.72-19.05-43.47a.63.63 0 0 0-.84-.3l-58.1 25.5a.63.63 0 0 0-.35.82l12.66 28.89c1.16 2.63 3.11 3.82 5.91 4.79l.59.2 1 .31.59.18c1.25.36 2.63.73 4.15 1.19s2.67.78 3.75 1l.64.15a11.18 11.18 0 0 0 7.31-.37l.55-.24 40.75-17.89a.63.63 0 0 0 .44-.76Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "101.647px 93.6568px"
    },
    className: "animable",
    id: "elukkgxqym1bl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.51 68.48-59.29 26-2.73-6.23a.61.61 0 0 1 0-.46.72.72 0 0 1 .35-.36L120.94 62a.64.64 0 0 1 .79.19v.06l.18.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "93.4775px 78.2079px"
    },
    id: "elfspqd216vt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.51 68.48-59.29 26-2.73-6.23a.61.61 0 0 1 0-.46.72.72 0 0 1 .35-.36L120.94 62a.64.64 0 0 1 .79.19v.06l.18.41Z",
    style: {
      opacity: 0.2,
      transformOrigin: "93.4775px 78.2079px"
    },
    className: "animable",
    id: "elvm19k0pphwb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.48 88.36a1.23 1.23 0 1 1 1.54.48 1.14 1.14 0 0 1-1.54-.48Z",
    style: {
      fill: "#263238",
      transformOrigin: "69.5263px 87.7271px"
    },
    id: "elbn1jofs2qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.31 84.92a1.23 1.23 0 1 1 1.55.48 1.16 1.16 0 0 1-1.55-.48Z",
    style: {
      fill: "#263238",
      transformOrigin: "77.3585px 84.2875px"
    },
    id: "el6m4hso9zwum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.14 81.49a1.23 1.23 0 1 1 1.54.48 1.14 1.14 0 0 1-1.54-.48Z",
    style: {
      fill: "#263238",
      transformOrigin: "85.1863px 80.8571px"
    },
    id: "elyj274gu02ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8 74.62a1.23 1.23 0 1 1 1.54.47 1.14 1.14 0 0 1-1.54-.47Z",
    style: {
      fill: "#263238",
      transformOrigin: "100.841px 73.9793px"
    },
    id: "eld11oiuowrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64 71.18a1.23 1.23 0 1 1 1.54.48 1.14 1.14 0 0 1-1.54-.48Z",
    style: {
      fill: "#263238",
      transformOrigin: "108.686px 70.5471px"
    },
    id: "elj3sfec966qb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 67.85a1.23 1.23 0 1 1 1.54.47 1.14 1.14 0 0 1-1.54-.47Z",
    style: {
      fill: "#263238",
      transformOrigin: "116.461px 67.2093px"
    },
    id: "el2l959ovsxum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "96.47px 85.15px",
      transform: "rotate(-23.68deg)"
    },
    className: "animable",
    d: "M64.1 81.14h64.74v8.02H64.1z",
    id: "elde4xwtxo05"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "96.47px 85.15px"
    },
    className: "animable",
    id: "el5vg2k0bnqke"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "96.47px 85.15px",
      transform: "rotate(-23.68deg)"
    },
    className: "animable",
    d: "M64.1 81.14h64.74v8.02H64.1z",
    id: "el7a8n6eixst2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84 88.28a.29.29 0 0 1 .13 0 .2.2 0 0 1 .09.09l.18.4a.15.15 0 0 1 0 .13.2.2 0 0 1-.09.09l-1.8.79.48 1.1 1.69-.74a.19.19 0 0 1 .13 0 .2.2 0 0 1 .09.09l.18.4a.19.19 0 0 1 0 .13.2.2 0 0 1-.09.09l-1.69.74.57 1.3a.15.15 0 0 1 0 .13.14.14 0 0 1-.08.09l-.46.2a.15.15 0 0 1-.13 0 .2.2 0 0 1-.09-.09l-1.6-3.65a.19.19 0 0 1 0-.13.2.2 0 0 1 .09-.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "83.295px 90.7987px"
    },
    id: "el98qpneijiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.91 90H89a.18.18 0 0 1 .1.09l.17.4a.15.15 0 0 1 0 .13.14.14 0 0 1-.08.09l-2.48 1.09a.15.15 0 0 1-.13 0 .2.2 0 0 1-.09-.09l-1.6-3.65a.19.19 0 0 1 0-.13.2.2 0 0 1 .09-.09l2.44-1.07a.24.24 0 0 1 .12 0 .13.13 0 0 1 .09.09l.18.4a.15.15 0 0 1 0 .13.14.14 0 0 1-.08.09l-1.83.8.4.9 1.7-.75a.24.24 0 0 1 .12 0 .18.18 0 0 1 .1.09l.17.4a.15.15 0 0 1 0 .13.14.14 0 0 1-.08.09l-1.7.75.41.93Z",
    style: {
      fill: "#455a64",
      transformOrigin: "87.0817px 89.2886px"
    },
    id: "ellzrnjan7gd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.22 90.29a.13.13 0 0 1-.12 0 .13.13 0 0 1-.1-.09l-1.6-3.65a.13.13 0 0 1 0-.12.15.15 0 0 1 .09-.1l1.66-.73a1.55 1.55 0 0 1 .65-.15 1.29 1.29 0 0 1 .51.1 1.19 1.19 0 0 1 .38.27 1.31 1.31 0 0 1 .22.34 1 1 0 0 1 .09.32 1.17 1.17 0 0 1 0 .27 2.18 2.18 0 0 1-.06.22l-.07.13a1.41 1.41 0 0 1 .47.19 1.15 1.15 0 0 1 .39.49 1.19 1.19 0 0 1 .1.46 1.27 1.27 0 0 1-.06.48 1.29 1.29 0 0 1-.26.45 1.46 1.46 0 0 1-.48.33Zm.94-3.77a.4.4 0 0 0-.28-.26.7.7 0 0 0-.47.07l-1 .44.38.87 1-.44a.75.75 0 0 0 .38-.29.45.45 0 0 0-.01-.39Zm-.64 2.8 1-.46a.7.7 0 0 0 .39-.33.48.48 0 0 0 0-.42.49.49 0 0 0-.3-.28.68.68 0 0 0-.51.06l-1 .46Z",
    style: {
      fill: "#455a64",
      transformOrigin: "90.6091px 87.8773px"
    },
    id: "el0z1pefogy7zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.82 84a1.73 1.73 0 0 1 1.18-.15 1.26 1.26 0 0 1 .77.75 1.41 1.41 0 0 1 .12.79 1.16 1.16 0 0 1-.37.67l1.39 1.06a.21.21 0 0 1 0 .11.12.12 0 0 1-.07.07l-.48.21a.27.27 0 0 1-.19 0l-.12-.06-1.32-1-.75.33.58 1.32a.15.15 0 0 1 0 .13.16.16 0 0 1-.09.09l-.45.2a.15.15 0 0 1-.13 0 .13.13 0 0 1-.09-.09l-1.61-3.65a.24.24 0 0 1 0-.12.18.18 0 0 1 .09-.1Zm-.07 2.16.82-.36a1.15 1.15 0 0 0 .46-.34.5.5 0 0 0 0-.52c-.1-.21-.22-.32-.38-.34a1.26 1.26 0 0 0-.56.12l-.82.36Z",
    style: {
      fill: "#455a64",
      transformOrigin: "94.5499px 86.1707px"
    },
    id: "elwf67zil4zip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 81.7a.15.15 0 0 1 .13 0 .12.12 0 0 1 .09.08l1 2.32a2.29 2.29 0 0 1 .18.68 1.42 1.42 0 0 1-.1.62 1.5 1.5 0 0 1-.36.54 2.49 2.49 0 0 1-.66.42 2.39 2.39 0 0 1-.76.2 1.66 1.66 0 0 1-.64-.09 1.43 1.43 0 0 1-.52-.36 1.92 1.92 0 0 1-.37-.59L96 83.2a.13.13 0 0 1 0-.12.11.11 0 0 1 .08-.09l.46-.21a.28.28 0 0 1 .13 0 .2.2 0 0 1 .09.09l1 2.29a1.11 1.11 0 0 0 .23.37.85.85 0 0 0 .29.19.65.65 0 0 0 .34 0 1.36 1.36 0 0 0 .37-.1 1.16 1.16 0 0 0 .32-.2.66.66 0 0 0 .21-.27.68.68 0 0 0 .06-.35 1 1 0 0 0-.11-.42l-1-2.29a.15.15 0 0 1 0-.13.14.14 0 0 1 .08-.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "98.1941px 84.1239px"
    },
    id: "elvjwodzkcphc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.82 80.48a.2.2 0 0 1 .15 0 .48.48 0 0 1 .15.11l2.95 3a.15.15 0 0 1 0 .13.14.14 0 0 1-.08.09l-.41.18a.24.24 0 0 1-.18 0 .29.29 0 0 1-.1-.06l-.52-.52-1.78.79v.73a.27.27 0 0 1 0 .12s-.06.09-.13.12l-.41.18a.15.15 0 0 1-.13 0 .2.2 0 0 1-.09-.09l-.17-4.26a.35.35 0 0 1 0-.18.2.2 0 0 1 .12-.1Zm1.4 2.35-1.33-1.34.08 1.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "103.072px 82.9151px"
    },
    id: "els3xapkgpn7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54 78.85a1.71 1.71 0 0 1 1.22-.15 1.32 1.32 0 0 1 .77.75 1.41 1.41 0 0 1 .12.79 1.28 1.28 0 0 1-.37.68l1.39 1a.21.21 0 0 1 0 .11.16.16 0 0 1-.07.07l-.48.21a.22.22 0 0 1-.19 0 .33.33 0 0 1-.12-.06l-1.32-1-.75.33.58 1.31a.19.19 0 0 1 0 .13.2.2 0 0 1-.09.09l-.46.2a.13.13 0 0 1-.12 0 .14.14 0 0 1-.1-.08L104 79.71a.15.15 0 0 1 0-.13.16.16 0 0 1 .09-.09Zm-.06 2.15.82-.36a1.06 1.06 0 0 0 .46-.34.48.48 0 0 0 0-.51c-.1-.21-.22-.33-.38-.34a1.08 1.08 0 0 0-.57.12l-.81.36Z",
    style: {
      fill: "#455a64",
      transformOrigin: "106.331px 80.9867px"
    },
    id: "elamzpwxygqki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57 76.64a.15.15 0 0 1 .13 0 .12.12 0 0 1 .09.08.14.14 0 0 1 0 .06l-.31 2.94.55 1.25a.13.13 0 0 1 0 .12.18.18 0 0 1-.09.1l-.45.2a.28.28 0 0 1-.13 0 .2.2 0 0 1-.09-.09l-.55-1.24-2.37-1.77v-.05a.15.15 0 0 1 0-.13.14.14 0 0 1 .08-.09l.43-.18a.22.22 0 0 1 .19 0l.11.05 1.61 1.2.22-2a.36.36 0 0 1 0-.11.27.27 0 0 1 .14-.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "109.19px 79.0114px"
    },
    id: "elyspm7xlb63f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.07 103.72a.91.91 0 0 0 1.23.34l4.45-2a.82.82 0 1 0-.65-1.47l-4.44 2a.92.92 0 0 0-.59 1.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "77.2136px 102.307px"
    },
    id: "eltcm8devbqcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58 100.43a.91.91 0 0 0 1.22.34l4.45-2a.81.81 0 1 0-.64-1.46l-4.45 2a.9.9 0 0 0-.58 1.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.7061px 99.0263px"
    },
    id: "elpxq9dt72mjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.08 97.13a.91.91 0 0 0 1.23.34l4.45-2a.82.82 0 1 0-.65-1.47l-4.45 2a.92.92 0 0 0-.58 1.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "92.2231px 95.7169px"
    },
    id: "el1w33ehtewmgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59 93.84a.89.89 0 0 0 1.22.34l4.45-2a.91.91 0 0 0 .58-1.13.89.89 0 0 0-1.22-.34l-4.45 1.95a.91.91 0 0 0-.58 1.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "99.7074px 92.445px"
    },
    id: "elhb5ng3n8dy5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09 90.55a.92.92 0 0 0 1.23.33l4.45-1.95a.9.9 0 0 0 .58-1.13.92.92 0 0 0-1.23-.33l-4.45 2a.9.9 0 0 0-.58 1.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "107.227px 89.175px"
    },
    id: "el6r4dfklal2u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 87.25a.89.89 0 0 0 1.22.34l4.45-2a.91.91 0 0 0 .58-1.13.9.9 0 0 0-1.22-.34l-4.45 2a.91.91 0 0 0-.58 1.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "114.725px 85.8568px"
    },
    id: "elr6czelntqxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1 84a.92.92 0 0 0 1.23.34l4.44-2a.93.93 0 0 0 .59-1.14.92.92 0 0 0-1.23-.33l-4.45 2a.9.9 0 0 0-.58 1.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "122.227px 82.6038px"
    },
    id: "elwhtmzbugivb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "105.868px 104.744px"
    },
    className: "animable",
    id: "elcmmunhbarch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.69 105.32a.34.34 0 0 1-.31-.16l-9-20.55c0-.09.05-.16.18-.16a.36.36 0 0 1 .32.16l9 20.55c.03.09-.05.16-.19.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "132.133px 94.885px"
    },
    id: "el0hxpysl73d56",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19 108.61a.38.38 0 0 1-.32-.15l-9-20.56c0-.08 0-.15.18-.15s.28.06.31.15l9 20.56c.04.08-.04.15-.17.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "124.62px 98.1802px"
    },
    id: "elmfscx5f65vs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68 111.91a.36.36 0 0 1-.32-.16l-9-20.55c0-.09 0-.16.18-.16a.36.36 0 0 1 .32.16l9 20.55c.04.09-.05.16-.18.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "117.115px 101.475px"
    },
    id: "elni8f7pgvuw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.17 115.2a.38.38 0 0 1-.32-.15l-9-20.56c0-.08 0-.15.18-.15a.36.36 0 0 1 .32.15l9 20.56c.04.08-.04.15-.18.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "109.605px 104.77px"
    },
    id: "elpov9pehd0al",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66 118.5a.34.34 0 0 1-.31-.16l-9-20.55c0-.09.05-.16.18-.16a.36.36 0 0 1 .32.16l9 20.55c.03.09-.05.16-.19.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "102.103px 108.065px"
    },
    id: "elff6jtlnonzr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.15 121.79a.37.37 0 0 1-.31-.15l-9-20.56c0-.08 0-.15.18-.15a.35.35 0 0 1 .31.15l9 20.56c.04.08-.04.15-.18.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "94.5902px 111.36px"
    },
    id: "el3l1q6nqa5no",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.83 124.93a.14.14 0 0 1 0 .11l-.48-.11-3-6.72-6.07-13.82c0-.09 0-.16.18-.16a.36.36 0 0 1 .31.15l6 13.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "87.0606px 114.635px"
    },
    id: "ele0lxtj2rcev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.66 122.17-.59-.2-.93-2.12-5.34-12.18a.14.14 0 0 1 0-.06h.2a.36.36 0 0 1 .32.16v.09l5.33 12.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "78.2284px 114.89px"
    },
    id: "ely4z4qgvd0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37 113a.46.46 0 0 1-.25-.08c-.1-.07-.1-.17 0-.21l52.55-23.07a.42.42 0 0 1 .37.06c.1.07.1.17 0 .21L77.49 113Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "103.58px 101.311px"
    },
    id: "el79vyjamz0sb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.63 118.11a.44.44 0 0 1-.25-.08c-.1-.08-.1-.17 0-.22l52.55-23.06a.4.4 0 0 1 .36.06c.11.07.11.17 0 .21l-52.55 23.06a.2.2 0 0 1-.11.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "105.839px 106.421px"
    },
    id: "elahu30327l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.55 100.16-.31.14-42.86 18.8-8.1 3.56-.59-.18 8.49-3.72 42.9-18.82h.1a.41.41 0 0 1 .37 0 .13.13 0 0 1 0 .06c.09.06.07.12 0 .16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "108.65px 111.278px"
    },
    id: "eloh045lhfn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.87 105.16-2.25-5.1V100l-6.77-15.4a.29.29 0 0 0-.18-.13.36.36 0 0 0-.25 0l-52.51 23a.14.14 0 0 0 0 .06l5.34 12.18.93 2.12.59.2-1-2.26-5.33-12.15 52.13-22.88 6.61 15.06.16.36 2.09 4.77-42 18.45-3.12 1.37.64.15 2.87-1.26 42.12-18.49a.09.09 0 0 0-.07.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "105.923px 104.674px"
    },
    id: "elg3bax12w306",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "105.868px 104.744px"
    },
    className: "animable",
    id: "elotot0kfyfo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.69 105.32a.34.34 0 0 1-.31-.16l-9-20.55c0-.09.05-.16.18-.16a.36.36 0 0 1 .32.16l9 20.55c.03.09-.05.16-.19.16Z",
    id: "eletvjwzr8ftu",
    className: "animable",
    style: {
      transformOrigin: "132.133px 94.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19 108.61a.38.38 0 0 1-.32-.15l-9-20.56c0-.08 0-.15.18-.15s.28.06.31.15l9 20.56c.04.08-.04.15-.17.15Z",
    id: "el4mkivhtyesq",
    className: "animable",
    style: {
      transformOrigin: "124.62px 98.1802px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68 111.91a.36.36 0 0 1-.32-.16l-9-20.55c0-.09 0-.16.18-.16a.36.36 0 0 1 .32.16l9 20.55c.04.09-.05.16-.18.16Z",
    id: "elt9dsohfojxc",
    className: "animable",
    style: {
      transformOrigin: "117.115px 101.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.17 115.2a.38.38 0 0 1-.32-.15l-9-20.56c0-.08 0-.15.18-.15a.36.36 0 0 1 .32.15l9 20.56c.04.08-.04.15-.18.15Z",
    id: "eln9wl98ps9se",
    className: "animable",
    style: {
      transformOrigin: "109.605px 104.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66 118.5a.34.34 0 0 1-.31-.16l-9-20.55c0-.09.05-.16.18-.16a.36.36 0 0 1 .32.16l9 20.55c.03.09-.05.16-.19.16Z",
    id: "eloqmgf5b5pmi",
    className: "animable",
    style: {
      transformOrigin: "102.103px 108.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.15 121.79a.37.37 0 0 1-.31-.15l-9-20.56c0-.08 0-.15.18-.15a.35.35 0 0 1 .31.15l9 20.56c.04.08-.04.15-.18.15Z",
    id: "elnjkjgb9bjln",
    className: "animable",
    style: {
      transformOrigin: "94.5902px 111.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.83 124.93a.14.14 0 0 1 0 .11l-.48-.11-3-6.72-6.07-13.82c0-.09 0-.16.18-.16a.36.36 0 0 1 .31.15l6 13.67Z",
    id: "elrb0vh0sxbge",
    className: "animable",
    style: {
      transformOrigin: "87.0606px 114.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.66 122.17-.59-.2-.93-2.12-5.34-12.18a.14.14 0 0 1 0-.06h.2a.36.36 0 0 1 .32.16v.09l5.33 12.15Z",
    id: "ele8eflacmjgc",
    className: "animable",
    style: {
      transformOrigin: "78.2284px 114.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37 113a.46.46 0 0 1-.25-.08c-.1-.07-.1-.17 0-.21l52.55-23.07a.42.42 0 0 1 .37.06c.1.07.1.17 0 .21L77.49 113Z",
    id: "ellznj891gjrm",
    className: "animable",
    style: {
      transformOrigin: "103.58px 101.311px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.63 118.11a.44.44 0 0 1-.25-.08c-.1-.08-.1-.17 0-.22l52.55-23.06a.4.4 0 0 1 .36.06c.11.07.11.17 0 .21l-52.55 23.06a.2.2 0 0 1-.11.03Z",
    id: "elikkk60rm2cn",
    className: "animable",
    style: {
      transformOrigin: "105.839px 106.421px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.55 100.16-.31.14-42.86 18.8-8.1 3.56-.59-.18 8.49-3.72 42.9-18.82h.1a.41.41 0 0 1 .37 0 .13.13 0 0 1 0 .06c.09.06.07.12 0 .16Z",
    id: "el210dje699v6",
    className: "animable",
    style: {
      transformOrigin: "108.65px 111.278px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.87 105.16-2.25-5.1V100l-6.77-15.4a.29.29 0 0 0-.18-.13.36.36 0 0 0-.25 0l-52.51 23a.14.14 0 0 0 0 .06l5.34 12.18.93 2.12.59.2-1-2.26-5.33-12.15 52.13-22.88 6.61 15.06.16.36 2.09 4.77-42 18.45-3.12 1.37.64.15 2.87-1.26 42.12-18.49a.09.09 0 0 0-.07.01Z",
    id: "elzhl86j1wl3p",
    className: "animable",
    style: {
      transformOrigin: "105.923px 104.674px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.67 118.59c2.09 1.18 6.77.83 9-.28s3.62-1.78 4.41-1.56 1.31 1 1.72 2.32.59 2.73 2 4.1c0 0-1.19.64-6-.51s-9.71-1.96-11.13-4.07Z",
    style: {
      opacity: 0.2,
      transformOrigin: "85.235px 120.028px"
    },
    className: "animable",
    id: "el7jgo5t15f1k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15 117.16c2.6 3.36 7.44 3.09 10.19 2.24s3.73-1.89 4.93-1.45c1.51.55 1.52 3.55 3.79 5.4s5.66 1.07 5.66 1.07c-3.61 1.59-5.91 1.36-12.29-.57s-10.43-2.37-12.28-6.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "87.435px 121.316px"
    },
    id: "elaw7bzyom7fc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15 117.16c2.6 3.36 7.44 3.09 10.19 2.24s3.73-1.89 4.93-1.45c1.51.55 1.52 3.55 3.79 5.4s5.66 1.07 5.66 1.07c-3.61 1.59-5.91 1.36-12.29-.57s-10.43-2.37-12.28-6.69Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "87.435px 121.316px"
    },
    className: "animable",
    id: "el3sg54kr7jrd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 62.78 114.72 88a.63.63 0 0 0 .46.76l20.87 6Z",
    style: {
      opacity: 0.2,
      transformOrigin: "125.376px 78.77px"
    },
    className: "animable",
    id: "el901ih9v3zoo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189 58.06-10.9 37.7v.06a1.55 1.55 0 0 1-.06.23s0 0 0 .06c-.44 1.45-1.05 2.65-4.65 3.83l-.51.16h-.08l-.2.06-.72.21c-4.94 1.4-6.1 1-8.23.34l-49.6-14.22a.64.64 0 0 1-.46-.76l13.17-45.6a.63.63 0 0 1 .79-.4l61 17.57a.62.62 0 0 1 .45.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "151.297px 70.5063px"
    },
    id: "elvncbr7ssku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189 58.06-10.9 37.7v.06a1.55 1.55 0 0 1-.06.23s0 0 0 .06c-.44 1.45-1.05 2.65-4.65 3.83l-.51.16h-.08l-.2.06-.72.21c-4.94 1.4-6.1 1-8.23.34l-49.6-14.22a.64.64 0 0 1-.46-.76l13.17-45.6a.63.63 0 0 1 .79-.4l61 17.57a.62.62 0 0 1 .45.76Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "151.297px 70.5063px"
    },
    className: "animable",
    id: "elmdo044fq2xs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.1 64.6-62.23-17.93 1.89-6.53a.61.61 0 0 1 .29-.36.71.71 0 0 1 .5 0l61 17.56a.63.63 0 0 1 .45.66.17.17 0 0 1 0 .07l-.12.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "156.937px 52.1673px"
    },
    id: "elxy5ss2815df",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.1 64.6-62.23-17.93 1.89-6.53a.61.61 0 0 1 .29-.36.71.71 0 0 1 .5 0l61 17.56a.63.63 0 0 1 .45.66.17.17 0 0 1 0 .07l-.12.43Z",
    style: {
      opacity: 0.2,
      transformOrigin: "156.937px 52.1673px"
    },
    className: "animable",
    id: "elr12a39getm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 44a1.23 1.23 0 1 1 .88 1.35 1.14 1.14 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "132.512px 44.1675px"
    },
    id: "elpxi0firx9vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.53 46.41a1.23 1.23 0 1 1 .88 1.35 1.14 1.14 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "140.742px 46.5775px"
    },
    id: "el9y7fnds2p2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.74 48.77a1.24 1.24 0 1 1 .88 1.35 1.14 1.14 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "148.963px 48.9303px"
    },
    id: "elj0yyxquwvlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17 53.5a1.24 1.24 0 0 1 2.35.68 1.24 1.24 0 0 1-2.35-.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "165.345px 53.84px"
    },
    id: "elnmwa28qfdw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4 55.87a1.23 1.23 0 0 1 2.34.68 1.23 1.23 0 0 1-2.34-.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "173.57px 56.21px"
    },
    id: "elwl1107xd2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.51 58.29a1.24 1.24 0 1 1 .88 1.36 1.16 1.16 0 0 1-.88-1.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "181.733px 58.4599px"
    },
    id: "eldcg5ar6zjxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "154.88px 59.47px",
      transform: "rotate(-73.91deg)"
    },
    className: "animable",
    d: "M150.87 27.1h8.02v64.74h-8.02z",
    id: "elptsybzkej6n"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "154.88px 59.47px"
    },
    className: "animable",
    id: "elzfl7za3e0t"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "154.88px 59.47px",
      transform: "rotate(-73.91deg)"
    },
    className: "animable",
    d: "M150.87 27.1h8.02v64.74h-8.02z",
    id: "elofk41vvbi7m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m144.08 55-1.94-.56a.16.16 0 0 1-.1-.08.19.19 0 0 1 0-.13l.13-.42a.19.19 0 0 1 .08-.1.17.17 0 0 1 .12 0l2.59.74a.18.18 0 0 1 .09.08.15.15 0 0 1 0 .13l-.72 2.51a1.56 1.56 0 0 1-.76 1 1.77 1.77 0 0 1-1.33 0 2.27 2.27 0 0 1-.7-.31 1.52 1.52 0 0 1-.42-.42 1.2 1.2 0 0 1-.18-.51 1.65 1.65 0 0 1 0-.54.13.13 0 0 1 .07-.1.15.15 0 0 1 .13 0l.48.13.09.06a.14.14 0 0 1 0 .1.76.76 0 0 0 0 .26.56.56 0 0 0 .1.24.7.7 0 0 0 .21.21 1.2 1.2 0 0 0 .34.15.9.9 0 0 0 .69 0 .87.87 0 0 0 .4-.56Z",
    style: {
      fill: "#455a64",
      transformOrigin: "142.991px 55.9994px"
    },
    id: "elg29n3k9r4xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85 55.26a.19.19 0 0 1 .12.09.4.4 0 0 1 0 .18l.37 4.16v.05a.16.16 0 0 1-.21.11l-.43-.12a.36.36 0 0 1-.15-.1.27.27 0 0 1 0-.12l-.07-.73-1.87-.54-.45.59a.36.36 0 0 1-.09.08.27.27 0 0 1-.18 0l-.42-.12a.16.16 0 0 1-.1-.08.15.15 0 0 1 0-.13l2.53-3.33a.4.4 0 0 1 .13-.13.19.19 0 0 1 .15 0Zm-.43 2.7-.16-1.88-1.14 1.5Z",
    style: {
      fill: "#455a64",
      transformOrigin: "146.348px 57.4822px"
    },
    id: "elayhcqn1g1ut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56 60.83a.26.26 0 0 1-.14-.1v-.11l-1-2.94-.7 2.44a.16.16 0 0 1-.08.1.2.2 0 0 1-.13 0l-.51-.12a.16.16 0 0 1-.1-.08.19.19 0 0 1 0-.13l1.1-3.83a.16.16 0 0 1 .08-.1.15.15 0 0 1 .13 0l.41.12a.21.21 0 0 1 .14.09.48.48 0 0 1 .05.11l.95 2.94.71-2.44a.13.13 0 0 1 .08-.1.13.13 0 0 1 .12 0l.48.13a.2.2 0 0 1 .1.08.21.21 0 0 1 0 .13l-1.11 3.83a.14.14 0 0 1-.08.1.17.17 0 0 1-.12 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "151.074px 58.4531px"
    },
    id: "el81kyp25ah78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46 58a.14.14 0 0 1 .1.08.19.19 0 0 1 0 .13l-.7 2.43a2.63 2.63 0 0 1-.3.63 1.44 1.44 0 0 1-.47.42 1.55 1.55 0 0 1-.63.18 2.43 2.43 0 0 1-.77-.1 2.13 2.13 0 0 1-.71-.33 1.53 1.53 0 0 1-.44-.48 1.43 1.43 0 0 1-.17-.61 2.18 2.18 0 0 1 .09-.69l.7-2.43a.16.16 0 0 1 .08-.1.19.19 0 0 1 .13 0l.48.14a.25.25 0 0 1 .1.08.19.19 0 0 1 0 .13l-.69 2.4a1.19 1.19 0 0 0-.06.44.76.76 0 0 0 .11.33.59.59 0 0 0 .23.24 1.39 1.39 0 0 0 .35.16 1.73 1.73 0 0 0 .38 0 .73.73 0 0 0 .33-.08.8.8 0 0 0 .27-.22 1.35 1.35 0 0 0 .19-.4l.69-2.4a.14.14 0 0 1 .08-.1.19.19 0 0 1 .13 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "155.47px 59.4949px"
    },
    id: "el34z9metz3sy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37 58.87a.22.22 0 0 1 .13.09.61.61 0 0 1 0 .17l.37 4.17a.11.11 0 0 1 0 .05.14.14 0 0 1-.08.09.13.13 0 0 1-.12 0l-.43-.12a.26.26 0 0 1-.15-.1.84.84 0 0 1 0-.12l-.06-.73-1.87-.54-.45.59a.35.35 0 0 1-.09.07.21.21 0 0 1-.18 0l-.43-.13a.16.16 0 0 1-.1-.08.13.13 0 0 1 0-.12l2.54-3.33a.38.38 0 0 1 .12-.13.21.21 0 0 1 .16 0Zm-.42 2.7-.17-1.88-1.14 1.5Z",
    style: {
      fill: "#455a64",
      transformOrigin: "158.884px 61.0694px"
    },
    id: "elu0gjj7otsmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28 60a1.78 1.78 0 0 1 1 .67 1.27 1.27 0 0 1 .11 1.07 1.37 1.37 0 0 1-.41.68 1.23 1.23 0 0 1-.72.29l.4 1.7v.07a.18.18 0 0 1-.07.08.11.11 0 0 1-.1 0l-.5-.15c-.08 0-.14 0-.16-.1a.27.27 0 0 1-.05-.13l-.38-1.6-.79-.23-.4 1.38a.16.16 0 0 1-.08.1.13.13 0 0 1-.12 0l-.48-.13a.16.16 0 0 1-.1-.08.2.2 0 0 1 0-.13l1.11-3.83a.14.14 0 0 1 .08-.1.17.17 0 0 1 .12 0Zm-1.43 1.62.86.24a1.08 1.08 0 0 0 .58 0 .5.5 0 0 0 .33-.39.49.49 0 0 0-.07-.5 1.12 1.12 0 0 0-.51-.27l-.86-.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "163.44px 62.0605px"
    },
    id: "el9u1e0hm6x7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56 61.52a.16.16 0 0 1 .1.08.17.17 0 0 1 0 .12v.05l-2.12 2.07-.37 1.31a.18.18 0 0 1-.08.09.16.16 0 0 1-.13 0l-.47-.14a.14.14 0 0 1-.1-.08.13.13 0 0 1 0-.12l.38-1.31-.69-2.88a.14.14 0 0 1 .08-.1.19.19 0 0 1 .13 0l.44.13a.24.24 0 0 1 .16.11.8.8 0 0 1 0 .11l.47 2 1.45-1.41a.26.26 0 0 1 .09-.06.23.23 0 0 1 .2 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "167.875px 62.9262px"
    },
    id: "elmofe8fqnigs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78 59.42a.91.91 0 0 0 .73 1l4.67 1.34a.82.82 0 1 0 .44-1.54L127 58.93a.91.91 0 0 0-1.22.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "129.082px 60.3537px"
    },
    id: "el74okrmv0deq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.66 61.69a.91.91 0 0 0 .72 1.05l4.67 1.34a.82.82 0 1 0 .45-1.54l-4.67-1.34a.9.9 0 0 0-1.17.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "136.952px 62.6558px"
    },
    id: "els3ksbf1lu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.53 64a.9.9 0 0 0 .73 1l4.67 1.35a.82.82 0 1 0 .44-1.54l-4.67-1.35a.92.92 0 0 0-1.17.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "144.831px 64.9274px"
    },
    id: "el7sg235gleta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.41 66.23a.9.9 0 0 0 .72 1l4.67 1.35a.82.82 0 1 0 .45-1.54l-4.67-1.35a.9.9 0 0 0-1.17.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "152.705px 67.1541px"
    },
    id: "ele9k0zvy2f9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28 68.5a.91.91 0 0 0 .73 1l4.67 1.35a.92.92 0 0 0 1.17-.5.91.91 0 0 0-.73-1L158.45 68a.91.91 0 0 0-1.17.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "160.565px 69.4236px"
    },
    id: "el97bb3twzhq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.16 70.76a.91.91 0 0 0 .72 1l4.67 1.34a.82.82 0 1 0 .45-1.54l-4.67-1.34a.91.91 0 0 0-1.17.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "168.456px 71.6806px"
    },
    id: "el5c8k78i7w74",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 73a.92.92 0 0 0 .73 1l4.67 1.34a.82.82 0 1 0 .44-1.54l-4.67-1.34A.92.92 0 0 0 173 73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "176.302px 73.9224px"
    },
    id: "el329svk2tkzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "148.497px 81.6365px"
    },
    className: "animable",
    id: "eluio3jdtp8i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m179.35 79.13-5.1 17.67-.91 3.16-.51.16 1-3.48L179 78.81c0-.09.13-.09.24 0a.38.38 0 0 1 .11.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "176.092px 89.4313px"
    },
    id: "eltyk1dkj8t4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 98.43a.36.36 0 0 1-.15-.32l6.21-21.57c0-.09.14-.09.24 0a.36.36 0 0 1 .15.32l-6.21 21.57c-.01.09-.12.09-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "168.15px 87.485px"
    },
    id: "elde3j5tbeqbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.14 96.17a.39.39 0 0 1-.15-.33l6.22-21.57c0-.09.13-.09.23 0a.34.34 0 0 1 .15.32l-6.21 21.57c-.03.09-.14.09-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "160.291px 85.2157px"
    },
    id: "elfzflbn9dh9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26 93.9a.39.39 0 0 1-.15-.33L155.33 72c0-.09.13-.09.24 0a.35.35 0 0 1 .14.32l-6.21 21.57c-.03.11-.14.11-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "152.411px 82.9531px"
    },
    id: "el2wfni109eqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38 91.63a.34.34 0 0 1-.14-.33l6.21-21.57c0-.09.13-.09.24 0a.35.35 0 0 1 .14.32l-6.21 21.57c-.03.09-.13.09-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "144.534px 80.6757px"
    },
    id: "elc6kxxecf88k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 89.36a.36.36 0 0 1-.14-.32l6.21-21.58c0-.09.13-.09.24 0a.36.36 0 0 1 .14.32l-6.21 21.57c-.03.09-.13.09-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "136.655px 78.4057px"
    },
    id: "el6iaxdf1uvr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62 87.09a.36.36 0 0 1-.14-.32l6.21-21.57c0-.1.13-.1.24 0a.34.34 0 0 1 .14.32l-6.21 21.57c-.02.08-.13.09-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "128.776px 76.1394px"
    },
    id: "elmikttci63of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.74 84.82a.36.36 0 0 1-.14-.32l6.21-21.57c0-.09.14-.1.24 0a.37.37 0 0 1 .15.32L118 84.81c0 .09-.15.1-.26.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "120.9px 73.8707px"
    },
    id: "eljlybwzskdz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4 68.64a.46.46 0 0 1-.14-.22c0-.12 0-.19.14-.16l55.15 15.88a.4.4 0 0 1 .24.28c0 .12 0 .19-.13.16L122.51 68.7a.3.3 0 0 1-.11-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "150.025px 76.42px"
    },
    id: "elwjdylyvrkdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85 74a.37.37 0 0 1-.14-.22c0-.12 0-.19.13-.16L176 89.53a.41.41 0 0 1 .25.28c0 .12 0 .2-.14.17L121 74.09a.27.27 0 0 1-.15-.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "148.48px 81.7997px"
    },
    id: "el8rqnt7sc8n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3 79.43a.44.44 0 0 1-.14-.22c0-.13 0-.2.13-.17l55.15 15.89a.39.39 0 0 1 .24.27c0 .12 0 .2-.13.17L119.4 79.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "146.92px 87.2047px"
    },
    id: "elgumgp9dnw8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.31 78.94a.12.12 0 0 0 0-.05H179.16L124 62.86a.11.11 0 0 0-.14.06l-6.26 21.57a.3.3 0 0 0 .05.23l.09.1.11.05 49.42 14.24 4.55 1.31.72-.21-5-1.43-49.48-14.25 6.11-21.2 54.71 15.76-5 17.55-1 3.48.51-.16.91-3.16 5.1-17.67a.23.23 0 0 0-.09-.19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "148.497px 81.6365px"
    },
    id: "el1wrbcycruuj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "148.497px 81.6365px"
    },
    className: "animable",
    id: "elsw19e3ut7g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m179.35 79.08-5.1 17.67-.91 3.16-.51.16 1-3.48 5-17.55.08-.28a.09.09 0 0 1 .09-.07h.07a.12.12 0 0 1 .08 0 .15.15 0 0 1 .07.09.23.23 0 0 1 .13.3Z",
    id: "elxb44m4en1zg",
    className: "animable",
    style: {
      transformOrigin: "176.098px 89.3766px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 98.43a.36.36 0 0 1-.15-.32l6.21-21.57c0-.09.14-.09.24 0a.36.36 0 0 1 .15.32l-6.21 21.57c-.01.09-.12.09-.24 0Z",
    id: "elpglkc231e5i",
    className: "animable",
    style: {
      transformOrigin: "168.15px 87.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.14 96.17a.39.39 0 0 1-.15-.33l6.22-21.57c0-.09.13-.09.23 0a.34.34 0 0 1 .15.32l-6.21 21.57c-.03.09-.14.09-.24.01Z",
    id: "elgv6r6gkpa45",
    className: "animable",
    style: {
      transformOrigin: "160.291px 85.2157px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26 93.9a.39.39 0 0 1-.15-.33L155.33 72c0-.09.13-.09.24 0a.35.35 0 0 1 .14.32l-6.21 21.57c-.03.11-.14.11-.24.01Z",
    id: "elzi0vdflbmi",
    className: "animable",
    style: {
      transformOrigin: "152.411px 82.9531px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38 91.63a.34.34 0 0 1-.14-.33l6.21-21.57c0-.09.13-.09.24 0a.35.35 0 0 1 .14.32l-6.21 21.57c-.03.09-.13.09-.24.01Z",
    id: "eld32rjxyht6h",
    className: "animable",
    style: {
      transformOrigin: "144.534px 80.6757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 89.36a.36.36 0 0 1-.14-.32l6.21-21.58c0-.09.13-.09.24 0a.36.36 0 0 1 .14.32l-6.21 21.57c-.03.09-.13.09-.24.01Z",
    id: "elrk409vg59i",
    className: "animable",
    style: {
      transformOrigin: "136.655px 78.4057px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62 87.09a.36.36 0 0 1-.14-.32l6.21-21.57c0-.1.13-.1.24 0a.34.34 0 0 1 .14.32l-6.21 21.57c-.02.08-.13.09-.24 0Z",
    id: "elwjmvia2hy7",
    className: "animable",
    style: {
      transformOrigin: "128.776px 76.1394px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.74 84.82a.36.36 0 0 1-.14-.32l6.21-21.57c0-.09.14-.1.24 0a.37.37 0 0 1 .15.32L118 84.81c0 .09-.15.1-.26.01Z",
    id: "elhwbf36o1q5w",
    className: "animable",
    style: {
      transformOrigin: "120.9px 73.8707px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4 68.64a.46.46 0 0 1-.14-.22c0-.12 0-.19.14-.16l55.15 15.88a.4.4 0 0 1 .24.28c0 .12 0 .19-.13.16L122.51 68.7a.3.3 0 0 1-.11-.06Z",
    id: "el5ldsbf08c1u",
    className: "animable",
    style: {
      transformOrigin: "150.025px 76.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85 74a.37.37 0 0 1-.14-.22c0-.12 0-.19.13-.16L176 89.53a.41.41 0 0 1 .25.28c0 .12 0 .2-.14.17L121 74.09a.27.27 0 0 1-.15-.09Z",
    id: "elckc1e3dsfrc",
    className: "animable",
    style: {
      transformOrigin: "148.48px 81.7997px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3 79.43a.44.44 0 0 1-.14-.22c0-.13 0-.2.13-.17l55.15 15.89a.39.39 0 0 1 .24.27c0 .12 0 .2-.13.17L119.4 79.48Z",
    id: "el6sfmcvfrmvy",
    className: "animable",
    style: {
      transformOrigin: "146.92px 87.2047px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.31 78.94a.12.12 0 0 0 0-.05H179.16L124 62.86a.11.11 0 0 0-.14.06l-6.26 21.57a.3.3 0 0 0 .05.23l.09.1.11.05 49.42 14.24 4.55 1.31.72-.21-5-1.43-49.48-14.25 6.11-21.2 54.71 15.76-5 17.55-1 3.48.51-.16.91-3.16 5.1-17.67a.23.23 0 0 0-.09-.19Z",
    id: "elii1krasurs",
    className: "animable",
    style: {
      transformOrigin: "148.497px 81.6365px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.69 97.58c-3.57-1-3.72-2.29-5.34-1.9s-3.53 5.42-6.94 4.74c1.57.46 3.34 1.43 6.14-.55a14.2 14.2 0 0 1 6.14-2.29Z",
    style: {
      opacity: 0.2,
      transformOrigin: "168.55px 98.3376px"
    },
    className: "animable",
    id: "el7hjqpmnlod6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.59 100.77c2.94.84 5.42-4.49 6.9-5s3.74 1.67 5.56 1.23 2-1.23 2-1.23c-.49 1.69-.88 3-5.36 4.4-5.69 1.7-6.84 1.25-9.1.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "170.82px 98.5222px"
    },
    id: "elxucyysolwop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.59 100.77c2.94.84 5.42-4.49 6.9-5s3.74 1.67 5.56 1.23 2-1.23 2-1.23c-.49 1.69-.88 3-5.36 4.4-5.69 1.7-6.84 1.25-9.1.6Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "170.82px 98.5222px"
    },
    className: "animable",
    id: "el7v0dh1ys19e"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "76.013px 193.955px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.16 166-11.38 39.3c-.44 1.51-2.2 2.56-5.87 3.53-3.24.86-6 .51-9.58-.52L61.2 194.4a.64.64 0 0 1-.46-.76L74 148.05a.63.63 0 0 1 .8-.4l60.95 17.62a.64.64 0 0 1 .41.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "98.4485px 178.466px"
    },
    id: "elzyu7qwufby",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.16 166-11.38 39.3c-.44 1.51-2.2 2.56-5.87 3.53-3.24.86-6 .51-9.58-.52L61.2 194.4a.64.64 0 0 1-.46-.76L74 148.05a.63.63 0 0 1 .8-.4l60.95 17.62a.64.64 0 0 1 .41.73Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "98.4485px 178.466px"
    },
    className: "animable",
    id: "elik6ryvu35v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.26 172.57-62.2-18 1.94-6.52a.59.59 0 0 1 .29-.35.69.69 0 0 1 .51 0l60.95 17.62a.65.65 0 0 1 .48.66s0 0 0 .07l-.13.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "104.145px 160.111px"
    },
    id: "elilumj7x6r5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.26 172.57-62.2-18 1.94-6.52a.59.59 0 0 1 .29-.35.69.69 0 0 1 .51 0l60.95 17.62a.65.65 0 0 1 .48.66s0 0 0 .07l-.13.43Z",
    style: {
      opacity: 0.2,
      transformOrigin: "104.145px 160.111px"
    },
    className: "animable",
    id: "eld681uu0nid"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49 152a1.24 1.24 0 1 1 .88 1.35 1.15 1.15 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "79.7135px 152.16px"
    },
    id: "elupg79qnmaag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71 154.34a1.23 1.23 0 1 1 .88 1.35 1.15 1.15 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "87.923px 154.508px"
    },
    id: "elw0ky1ftc0v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.92 156.71a1.24 1.24 0 1 1 .88 1.35 1.14 1.14 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "96.1426px 156.87px"
    },
    id: "elvjd4d4hm8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35 161.46a1.23 1.23 0 1 1 .88 1.35 1.15 1.15 0 0 1-.88-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "112.563px 161.628px"
    },
    id: "el5xqino7q4nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57 163.83a1.24 1.24 0 1 1 .88 1.36 1.15 1.15 0 0 1-.88-1.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "120.792px 164px"
    },
    id: "elx444ruwiwcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69 166.26a1.23 1.23 0 1 1 .87 1.36 1.15 1.15 0 0 1-.87-1.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.901px 166.44px"
    },
    id: "el3lbazot4e4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "102.05px 167.42px",
      transform: "rotate(-73.86deg)"
    },
    className: "animable",
    d: "M98.04 135.05h8.02v64.74h-8.02z",
    id: "elywzqe1m6fzd"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "102.05px 167.42px"
    },
    className: "animable",
    id: "elfrajcaxbbib"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "102.05px 167.42px",
      transform: "rotate(-73.86deg)"
    },
    className: "animable",
    d: "M98.04 135.05h8.02v64.74h-8.02z",
    id: "elqj7a35hcdyn"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m94 165.19 1.69-1.63.11-.07a.24.24 0 0 1 .19 0l.41.12a.14.14 0 0 1 .09.08.15.15 0 0 1 0 .13l-1.11 3.83a.16.16 0 0 1-.21.11l-.47-.14a.14.14 0 0 1-.1-.08.13.13 0 0 1 0-.12l.67-2.32-1.15 1.11a.35.35 0 0 1-.12.07.16.16 0 0 1-.15 0l-.3-.08a.25.25 0 0 1-.13-.09 1.12 1.12 0 0 1 0-.13l-.42-1.56-.67 2.32a.12.12 0 0 1-.08.09.13.13 0 0 1-.12 0l-.48-.14a.16.16 0 0 1-.1-.08.15.15 0 0 1 0-.13l1.1-3.83a.25.25 0 0 1 .08-.1.2.2 0 0 1 .13 0l.4.12a.24.24 0 0 1 .16.11.87.87 0 0 0 0 .12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "94.02px 165.154px"
    },
    id: "el9gydw9n3xgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.47 164.47a.25.25 0 0 1 .13.09.4.4 0 0 1 0 .17l.37 4.17a.16.16 0 0 1-.08.1.15.15 0 0 1-.13 0l-.43-.12a.26.26 0 0 1-.15-.1.3.3 0 0 1 0-.12l-.07-.73-1.87-.54-.45.58a.24.24 0 0 1-.09.08.19.19 0 0 1-.18 0l-.43-.12a.14.14 0 0 1-.09-.08.15.15 0 0 1 0-.13l2.53-3.32a.52.52 0 0 1 .13-.13.17.17 0 0 1 .16 0Zm-.43 2.7-.16-1.88-1.14 1.5Z",
    style: {
      fill: "#455a64",
      transformOrigin: "97.9776px 166.632px"
    },
    id: "elii9g6wukjp7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38 165.6a1.66 1.66 0 0 1 1 .67 1.25 1.25 0 0 1 .11 1.06 1.33 1.33 0 0 1-.41.68 1.23 1.23 0 0 1-.71.29l.39 1.7v.07a.11.11 0 0 1-.07.08.11.11 0 0 1-.1 0l-.5-.14a.29.29 0 0 1-.16-.11.43.43 0 0 1 0-.13l-.38-1.6-.79-.23-.39 1.38a.16.16 0 0 1-.08.1.21.21 0 0 1-.13 0l-.48-.14a.2.2 0 0 1-.1-.08.15.15 0 0 1 0-.13l1.1-3.83a.2.2 0 0 1 .08-.1.15.15 0 0 1 .13 0Zm-1.38 1.61.86.25a1.13 1.13 0 0 0 .57 0 .48.48 0 0 0 .33-.39.47.47 0 0 0-.07-.5 1.11 1.11 0 0 0-.51-.27l-.86-.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "102.563px 167.644px"
    },
    id: "el0tzhl2bsjek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.39 169.83a.18.18 0 0 1 .09-.1.17.17 0 0 1 .12 0l.48.14a.18.18 0 0 1 .11.08.19.19 0 0 1 0 .13 1.5 1.5 0 0 1-.27.45 1.29 1.29 0 0 1-.44.35 1.72 1.72 0 0 1-.63.16 2.32 2.32 0 0 1-.83-.1 2.05 2.05 0 0 1-.68-.33 1.61 1.61 0 0 1-.44-.5 1.56 1.56 0 0 1-.19-.61 2.09 2.09 0 0 1 0-.7c0-.15.08-.32.13-.5s.1-.35.15-.5a2.24 2.24 0 0 1 .34-.61 1.67 1.67 0 0 1 .49-.43 1.64 1.64 0 0 1 .63-.18 2.08 2.08 0 0 1 .76.09 2.18 2.18 0 0 1 .75.35 2 2 0 0 1 .45.48 1.36 1.36 0 0 1 .19.53 1.79 1.79 0 0 1 0 .52.14.14 0 0 1-.08.1.19.19 0 0 1-.13 0l-.48-.14a.17.17 0 0 1-.1-.07.14.14 0 0 1 0-.13.78.78 0 0 0 0-.26.72.72 0 0 0-.12-.25.88.88 0 0 0-.24-.23 1.18 1.18 0 0 0-.39-.17 1.05 1.05 0 0 0-.42-.05.91.91 0 0 0-.34.11 1 1 0 0 0-.26.23 1.74 1.74 0 0 0-.18.33c0 .15-.1.32-.15.5s-.1.35-.13.5a1.18 1.18 0 0 0 0 .37 1 1 0 0 0 .09.34 1 1 0 0 0 .24.27 1.23 1.23 0 0 0 .38.19 1.64 1.64 0 0 0 .42.06 1.14 1.14 0 0 0 .33-.07.72.72 0 0 0 .24-.14 1.37 1.37 0 0 0 .11-.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "106.65px 168.81px"
    },
    id: "ell9tp1hnlk99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.94 168.36a.16.16 0 0 1 .11.21l-1.11 3.83a.13.13 0 0 1-.08.1.17.17 0 0 1-.12 0l-.48-.14a.16.16 0 0 1-.1-.08.13.13 0 0 1 0-.12l.45-1.57-1.79-.52-.45 1.57a.2.2 0 0 1-.08.1.15.15 0 0 1-.13 0l-.48-.13a.2.2 0 0 1-.1-.08.15.15 0 0 1 0-.13l1.1-3.83a.2.2 0 0 1 .08-.1.15.15 0 0 1 .13 0l.48.13a.2.2 0 0 1 .1.08.15.15 0 0 1 0 .13l-.44 1.52 1.79.52.44-1.52a.16.16 0 0 1 .08-.1.2.2 0 0 1 .13 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "110.812px 169.983px"
    },
    id: "el96pzshp5en4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 167.34a.9.9 0 0 0 .72 1l4.67 1.35a.9.9 0 0 0 1.17-.49.92.92 0 0 0-.73-1.05l-4.66-1.35a.91.91 0 0 0-1.17.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "76.2821px 168.25px"
    },
    id: "elal1gp8bj29c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83 169.62a.91.91 0 0 0 .72 1l4.67 1.38a.82.82 0 1 0 .45-1.54L82 169.12a.91.91 0 0 0-1.17.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.1258px 170.578px"
    },
    id: "elzu6u3jlc2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7 171.89a.92.92 0 0 0 .73 1.05l4.66 1.35a.82.82 0 1 0 .45-1.54l-4.67-1.35a.91.91 0 0 0-1.17.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "91.9931px 172.862px"
    },
    id: "el6nr2dfdiujc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.58 174.17a.9.9 0 0 0 .72 1l4.67 1.35a.82.82 0 1 0 .44-1.54l-4.66-1.35a.9.9 0 0 0-1.17.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "99.876px 175.095px"
    },
    id: "elg1i42wdsxp4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45 176.44a.91.91 0 0 0 .72 1.05l4.67 1.35a.82.82 0 1 0 .45-1.54l-4.67-1.3a.91.91 0 0 0-1.17.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "107.742px 177.433px"
    },
    id: "elmvcmpqzm9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.32 178.72a.91.91 0 0 0 .73 1l4.66 1.35a.82.82 0 1 0 .45-1.54l-4.67-1.35a.91.91 0 0 0-1.17.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "115.616px 179.646px"
    },
    id: "elgd6a53u2r97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19 181a.92.92 0 0 0 .73 1l4.67 1.35a.82.82 0 1 0 .44-1.54l-4.66-1.35a.92.92 0 0 0-1.18.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "123.492px 181.926px"
    },
    id: "el74b00zq4yc2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "95.6141px 189.686px"
    },
    className: "animable",
    id: "elk3ocz3swfy9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.5 187.09 121 206l-.69 2.38-.41.13a.27.27 0 0 1-.05-.2l.64-2.21 5.6-19.35c0-.09.13-.1.24 0a.36.36 0 0 1 .17.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "123.174px 197.594px"
    },
    id: "el2tvng8rwg89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15 206.39a.36.36 0 0 1-.14-.32l6.23-21.57c0-.09.14-.09.24 0a.36.36 0 0 1 .15.32l-6.24 21.56c-.02.09-.13.1-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "115.32px 195.443px"
    },
    id: "elijhxbj7cafo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.28 204.11a.37.37 0 0 1-.15-.32l6.24-21.57c0-.09.13-.09.23 0a.35.35 0 0 1 .15.32l-6.23 21.57c-.03.09-.14.09-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "107.44px 193.165px"
    },
    id: "el4xs50cnfs1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4 201.83a.33.33 0 0 1-.14-.32l6.23-21.51c0-.09.13-.1.24 0a.36.36 0 0 1 .14.32l-6.23 21.57c-.03.03-.13.03-.24-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "99.5641px 190.918px"
    },
    id: "elp6n8vvd0cve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52 199.56a.36.36 0 0 1-.14-.32l6.23-21.57c0-.09.14-.09.24 0a.39.39 0 0 1 .15.33l-6.24 21.56c-.02.08-.13.09-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "91.6895px 188.613px"
    },
    id: "el9dyekb2ajwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65 197.28a.37.37 0 0 1-.15-.32l6.24-21.57c0-.09.13-.09.24 0a.36.36 0 0 1 .14.32l-6.23 21.56c-.03.1-.14.1-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "83.8105px 186.334px"
    },
    id: "elrg9t0x50n0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.77 195a.35.35 0 0 1-.14-.32l6.23-21.56c0-.09.13-.1.24 0a.34.34 0 0 1 .14.32L73 195c0 .09-.12.09-.23 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "75.9353px 184.058px"
    },
    id: "elaswe0xqa6ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 192.73a.35.35 0 0 1-.15-.32L71 170.84c0-.09.14-.09.24 0a.39.39 0 0 1 .15.33l-6.24 21.56c-.04.08-.15.09-.25 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "68.0696px 181.783px"
    },
    id: "elv0gumz7p95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.57 176.55a.38.38 0 0 1-.14-.21c0-.13 0-.2.13-.17l55.14 15.94a.41.41 0 0 1 .24.27c0 .12 0 .2-.13.17l-55.14-15.94a.27.27 0 0 1-.1-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "97.185px 184.36px"
    },
    id: "elrqipfiu7es",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 181.94a.43.43 0 0 1-.14-.21c0-.13 0-.2.13-.17l55.14 15.94a.41.41 0 0 1 .24.27c0 .13 0 .2-.13.17L68.11 182a.27.27 0 0 1-.11-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "95.615px 189.75px"
    },
    id: "elpoj0qv2jfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.45 187.34a.52.52 0 0 1-.14-.22c0-.13 0-.2.14-.17l55.13 15.94a.41.41 0 0 1 .24.27c0 .13 0 .2-.13.17l-55.13-15.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "94.065px 195.14px"
    },
    id: "el8czd7m1bs0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45 186.87a.38.38 0 0 0-.2-.16l-55.13-15.93c-.07 0-.12 0-.14.06l-6.23 21.56a.27.27 0 0 0 0 .22l.09.11.11.05 49.94 14.44 4.78 1.38.61-.19.72-2.41 5.47-18.94a.27.27 0 0 0-.02-.19Zm-5.93 19.26-.61 2.12-4.14-1.2-50.56-14.61 6.13-21.19L126 187.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "95.6027px 189.69px"
    },
    id: "elun8rwp92m9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "95.6141px 189.686px"
    },
    className: "animable",
    id: "el8fvukjrwn6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.5 187.09 121 206l-.69 2.38-.41.13a.27.27 0 0 1-.05-.2l.64-2.21 5.6-19.35c0-.09.13-.1.24 0a.36.36 0 0 1 .17.34Z",
    id: "elqtep1alfaen",
    className: "animable",
    style: {
      transformOrigin: "123.174px 197.594px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15 206.39a.36.36 0 0 1-.14-.32l6.23-21.57c0-.09.14-.09.24 0a.36.36 0 0 1 .15.32l-6.24 21.56c-.02.09-.13.1-.24.01Z",
    id: "el0gf9wq6fncf",
    className: "animable",
    style: {
      transformOrigin: "115.32px 195.443px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.28 204.11a.37.37 0 0 1-.15-.32l6.24-21.57c0-.09.13-.09.23 0a.35.35 0 0 1 .15.32l-6.23 21.57c-.03.09-.14.09-.24 0Z",
    id: "elssp6274l7n",
    className: "animable",
    style: {
      transformOrigin: "107.44px 193.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4 201.83a.33.33 0 0 1-.14-.32l6.23-21.51c0-.09.13-.1.24 0a.36.36 0 0 1 .14.32l-6.23 21.57c-.03.03-.13.03-.24-.06Z",
    id: "el9g1jk670xsg",
    className: "animable",
    style: {
      transformOrigin: "99.5641px 190.918px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52 199.56a.36.36 0 0 1-.14-.32l6.23-21.57c0-.09.14-.09.24 0a.39.39 0 0 1 .15.33l-6.24 21.56c-.02.08-.13.09-.24 0Z",
    id: "elgvaqar2bnco",
    className: "animable",
    style: {
      transformOrigin: "91.6895px 188.613px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65 197.28a.37.37 0 0 1-.15-.32l6.24-21.57c0-.09.13-.09.24 0a.36.36 0 0 1 .14.32l-6.23 21.56c-.03.1-.14.1-.24.01Z",
    id: "elxm31l4dvua",
    className: "animable",
    style: {
      transformOrigin: "83.8105px 186.334px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.77 195a.35.35 0 0 1-.14-.32l6.23-21.56c0-.09.13-.1.24 0a.34.34 0 0 1 .14.32L73 195c0 .09-.12.09-.23 0Z",
    id: "elag3jnxd73eh",
    className: "animable",
    style: {
      transformOrigin: "75.9353px 184.058px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 192.73a.35.35 0 0 1-.15-.32L71 170.84c0-.09.14-.09.24 0a.39.39 0 0 1 .15.33l-6.24 21.56c-.04.08-.15.09-.25 0Z",
    id: "elcdsk845xxic",
    className: "animable",
    style: {
      transformOrigin: "68.0696px 181.783px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.57 176.55a.38.38 0 0 1-.14-.21c0-.13 0-.2.13-.17l55.14 15.94a.41.41 0 0 1 .24.27c0 .12 0 .2-.13.17l-55.14-15.94a.27.27 0 0 1-.1-.06Z",
    id: "elrnac7gtgl9c",
    className: "animable",
    style: {
      transformOrigin: "97.185px 184.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 181.94a.43.43 0 0 1-.14-.21c0-.13 0-.2.13-.17l55.14 15.94a.41.41 0 0 1 .24.27c0 .13 0 .2-.13.17L68.11 182a.27.27 0 0 1-.11-.06Z",
    id: "elubo1s42wzf",
    className: "animable",
    style: {
      transformOrigin: "95.615px 189.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.45 187.34a.52.52 0 0 1-.14-.22c0-.13 0-.2.14-.17l55.13 15.94a.41.41 0 0 1 .24.27c0 .13 0 .2-.13.17l-55.13-15.94Z",
    id: "elljsgaw72i3c",
    className: "animable",
    style: {
      transformOrigin: "94.065px 195.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45 186.87a.38.38 0 0 0-.2-.16l-55.13-15.93c-.07 0-.12 0-.14.06l-6.23 21.56a.27.27 0 0 0 0 .22l.09.11.11.05 49.94 14.44 4.79 1.38.61-.19.71-2.41 5.47-18.94a.27.27 0 0 0-.02-.19Zm-5.93 19.26-.61 2.12-4.14-1.2-50.56-14.61 6.13-21.19L126 187.06Z",
    id: "eli69jpxgawcg",
    className: "animable",
    style: {
      transformOrigin: "95.6027px 189.69px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.39 205.94a4.86 4.86 0 0 1-2.56-.25c-.84-.32-1.53-.82-2.2-.62-.84.25-1.15 1.1-2.76 2.14a7.47 7.47 0 0 1-4.65 1.39c1.51.45 8.54.15 12.17-2.66Z",
    style: {
      opacity: 0.2,
      transformOrigin: "117.305px 206.897px"
    },
    className: "animable",
    id: "eldq06zvqek3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.65 208.41a10.27 10.27 0 0 0 8.34-2c1.08-1 1.74-1.79 3.06-1s3.51.69 3.71 0c-.44 1.5-2.18 2.47-5.85 3.44-3.24.84-5.69.59-9.26-.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "117.205px 207.221px"
    },
    id: "elxovu4aqum6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.65 208.41a10.27 10.27 0 0 0 8.34-2c1.08-1 1.74-1.79 3.06-1s3.51.69 3.71 0c-.44 1.5-2.18 2.47-5.85 3.44-3.24.84-5.69.59-9.26-.44Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "117.205px 207.221px"
    },
    className: "animable",
    id: "elcdz0uwlh4sv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.33 188-.46-1.37-1.55-4.65-.15-.43v-.12l-.06-.07-.11-.08h-.3a.83.83 0 0 0-.22 0l-16.61 5.57-2 6.92a.62.62 0 0 0 .45.76L87 201.85l-2.11-6.29Z",
    style: {
      opacity: 0.2,
      transformOrigin: "73.9247px 191.561px"
    },
    className: "animable",
    id: "el41w86y5iylk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.28 225.89-15.07-45a.63.63 0 0 0-.81-.36l-60.15 20.18a.63.63 0 0 0-.43.78l7.36 22a20.73 20.73 0 0 0 6.94 9.71 7.38 7.38 0 0 0 .64.5 25 25 0 0 0 4.16 2.49 59.1 59.1 0 0 0 5.65 2.41l.55.19a28.33 28.33 0 0 0 2.79.83c.25.07.5.12.74.17a16.44 16.44 0 0 0 8.82-.21l38.38-12.88a.63.63 0 0 0 .43-.81Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "54.0543px 210.391px"
    },
    id: "elnpw5ceb28ml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.28 225.89-15.07-45a.63.63 0 0 0-.81-.36l-60.15 20.18a.63.63 0 0 0-.43.78l7.36 22a20.73 20.73 0 0 0 6.94 9.71 7.38 7.38 0 0 0 .64.5 25 25 0 0 0 4.16 2.49 59.1 59.1 0 0 0 5.65 2.41l.55.19a28.33 28.33 0 0 0 2.79.83c.25.07.5.12.74.17a16.44 16.44 0 0 0 8.82-.21l38.38-12.88a.63.63 0 0 0 .43-.81Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "54.0543px 210.391px"
    },
    className: "animable",
    id: "elt9guyo3lpe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.37 187.34 18 207.94l-2.16-6.45a.59.59 0 0 1 0-.45.71.71 0 0 1 .39-.33l60.17-20.19a.63.63 0 0 1 .76.27v.07l.14.42Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "47.5827px 194.211px"
    },
    id: "elvu2i5vsr7bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.37 187.34 18 207.94l-2.16-6.45a.59.59 0 0 1 0-.45.71.71 0 0 1 .39-.33l60.17-20.19a.63.63 0 0 1 .76.27v.07l.14.42Z",
    style: {
      opacity: 0.2,
      transformOrigin: "47.5827px 194.211px"
    },
    className: "animable",
    id: "elxt7w71gqiq"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.93,
    cy: 201.73,
    rx: 1.22,
    ry: 1.06,
    style: {
      fill: "#263238",
      transformOrigin: "22.93px 201.73px",
      transform: "rotate(-18.71deg)"
    },
    className: "animable",
    id: "el97h4zr4kez5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89 199.4a1.24 1.24 0 1 1 1.49.61 1.15 1.15 0 0 1-1.49-.61Z",
    style: {
      fill: "#263238",
      transformOrigin: "30.9923px 198.844px"
    },
    id: "elh858fy94blb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 196.68a1.24 1.24 0 1 1 1.5.61 1.16 1.16 0 0 1-1.5-.61Z",
    style: {
      fill: "#263238",
      transformOrigin: "39.1038px 196.125px"
    },
    id: "elcafvm2vgkoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2 191.24a1.24 1.24 0 0 1 2.32-.78 1.24 1.24 0 0 1-2.32.78Z",
    style: {
      fill: "#263238",
      transformOrigin: "55.36px 190.85px"
    },
    id: "el8g8gisr2hci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32 188.51a1.23 1.23 0 1 1 1.49.62 1.14 1.14 0 0 1-1.49-.62Z",
    style: {
      fill: "#263238",
      transformOrigin: "63.4216px 187.975px"
    },
    id: "el1hbl7vfzd91",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37 185.89a1.23 1.23 0 1 1 1.49.62 1.14 1.14 0 0 1-1.49-.62Z",
    style: {
      fill: "#263238",
      transformOrigin: "71.4716px 185.355px"
    },
    id: "elpstarwj0fcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "49.95px 201.43px",
      transform: "rotate(-18.54deg)"
    },
    className: "animable",
    d: "M17.58 197.42h64.74v8.02H17.58z",
    id: "elo13e5fidh"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "49.95px 201.43px"
    },
    className: "animable",
    id: "elgwr33ynv5fl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "49.95px 201.43px",
      transform: "rotate(-18.54deg)"
    },
    className: "animable",
    d: "M17.58 197.42h64.74v8.02H17.58z",
    id: "elylfp48z77o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.44 201.39a.16.16 0 0 1 .15 0 .37.37 0 0 1 .14.12l2.67 3.21a.19.19 0 0 1 0 .13.14.14 0 0 1-.1.08l-.42.15a.28.28 0 0 1-.18 0 .35.35 0 0 1-.09-.07l-.47-.57-1.85.62v.73a.28.28 0 0 1 0 .12s-.06.08-.14.11l-.42.14a.19.19 0 0 1-.13 0 .14.14 0 0 1-.08-.1l.19-4.18a.48.48 0 0 1 0-.18.19.19 0 0 1 .12-.09Zm1.18 2.46-1.2-1.45-.08 1.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "44.4657px 203.771px"
    },
    id: "elh6baspssa07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.35 200.08a1.75 1.75 0 0 1 1.21 0 1.28 1.28 0 0 1 .72.85 1.25 1.25 0 0 1-.06 1.11 1.67 1.67 0 0 1-1 .71l-.94.31.44 1.31a.2.2 0 0 1 0 .13.14.14 0 0 1-.09.08l-.48.16a.17.17 0 0 1-.12 0 .15.15 0 0 1-.09-.1l-1.27-3.78a.17.17 0 0 1 0-.12.18.18 0 0 1 .1-.09Zm-.29 2.21.9-.3a1 1 0 0 0 .49-.31.54.54 0 0 0 0-.53.49.49 0 0 0-.35-.38 1 1 0 0 0-.57 0l-.91.3Z",
    style: {
      fill: "#455a64",
      transformOrigin: "47.5205px 202.362px"
    },
    id: "el7ov0n4buqlu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.15 198.8a1.72 1.72 0 0 1 1.22 0 1.27 1.27 0 0 1 .7.82 1.44 1.44 0 0 1 0 .79 1.28 1.28 0 0 1-.43.64l1.36 1.14v.06a.21.21 0 0 1 0 .11.27.27 0 0 1-.08.07l-.5.16a.21.21 0 0 1-.19 0 .35.35 0 0 1-.11-.07l-1.23-1.11-.77.26.45 1.37a.13.13 0 0 1 0 .12.2.2 0 0 1-.09.09l-.48.16a.17.17 0 0 1-.12 0 .22.22 0 0 1-.09-.1l-1.27-3.78a.2.2 0 0 1 0-.13.16.16 0 0 1 .1-.08Zm-.26 2.14.85-.28a1.21 1.21 0 0 0 .49-.3.49.49 0 0 0 .05-.51.47.47 0 0 0-.35-.37 1.11 1.11 0 0 0-.57.07l-.84.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "51.7582px 201.055px"
    },
    id: "elmze0t0vq52",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93 202.09a.15.15 0 0 1-.13 0 .14.14 0 0 1-.08-.09l-1.27-3.78a.19.19 0 0 1 0-.13.18.18 0 0 1 .1-.09l.47-.15a.12.12 0 0 1 .13 0 .14.14 0 0 1 .08.09l1.27 3.78a.2.2 0 0 1 0 .13.14.14 0 0 1-.1.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "54.4747px 199.968px"
    },
    id: "ele8jedpj8mkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 199.93a.13.13 0 0 1 .12 0 .16.16 0 0 1 .09.09l.14.42a.2.2 0 0 1 0 .13.16.16 0 0 1-.1.08l-2.56.86a.17.17 0 0 1-.12 0 .16.16 0 0 1-.09-.09l-1.27-3.79a.17.17 0 0 1 0-.12.18.18 0 0 1 .1-.09l.47-.15a.15.15 0 0 1 .13 0 .19.19 0 0 1 .08.1l1.01 3.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "57.28px 199.388px"
    },
    id: "els3fk1g947uj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 217.92a.91.91 0 0 0 1.19.45l4.6-1.55a.9.9 0 0 0 .68-1.07.91.91 0 0 0-1.19-.45l-4.6 1.55a.9.9 0 0 0-.68 1.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "29.235px 216.835px"
    },
    id: "elkstf7esxi6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 215.31a.91.91 0 0 0 1.19.45l4.6-1.55a.9.9 0 0 0 .68-1.07.91.91 0 0 0-1.19-.45l-4.6 1.55a.89.89 0 0 0-.68 1.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "36.984px 214.225px"
    },
    id: "elrw5gier4c7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.51 212.7a.92.92 0 0 0 1.19.45l4.61-1.55a.9.9 0 0 0 .68-1.07.91.91 0 0 0-1.19-.45l-4.6 1.55a.91.91 0 0 0-.69 1.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "44.7511px 211.613px"
    },
    id: "elyz0svte2a3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.28 210.09a.91.91 0 0 0 1.19.45l4.61-1.54a.92.92 0 0 0 .68-1.08.9.9 0 0 0-1.19-.44L50 209a.91.91 0 0 0-.72 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "52.5189px 209.008px"
    },
    id: "el32ddytsn1en",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.05 207.49a.9.9 0 0 0 1.19.44l4.61-1.54a.92.92 0 0 0 .68-1.08.9.9 0 0 0-1.19-.44l-4.61 1.54a.92.92 0 0 0-.68 1.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "60.29px 206.4px"
    },
    id: "elaxuo8ae6zjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.82 204.88a.9.9 0 0 0 1.19.44l4.61-1.54a.82.82 0 1 0-.51-1.52l-4.61 1.54a.92.92 0 0 0-.68 1.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "68.0747px 203.773px"
    },
    id: "elv6r025xmtpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.59 202.27a.91.91 0 0 0 1.19.45l4.61-1.55a.9.9 0 0 0 .68-1.07.91.91 0 0 0-1.19-.45l-4.61 1.55a.91.91 0 0 0-.68 1.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "75.8309px 201.185px"
    },
    id: "el0d2jtjh2ji3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "57.3771px 221.635px"
    },
    className: "animable",
    id: "el8mjbhvvcocj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2 225.12a.37.37 0 0 1-.3-.18l-7.14-21.28c0-.09 0-.16.19-.15a.37.37 0 0 1 .3.19l7.14 21.3c.03.07-.05.13-.19.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.5781px 214.315px"
    },
    id: "el8bcd5uurcdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.43 227.73a.35.35 0 0 1-.3-.19L73 206.27c0-.09.06-.16.2-.15a.39.39 0 0 1 .3.19l7.14 21.28c.01.09-.07.15-.21.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "76.8204px 216.925px"
    },
    id: "el3h15dx8yfvu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66 230.34a.37.37 0 0 1-.31-.19l-7.14-21.28c0-.09.06-.15.19-.14a.35.35 0 0 1 .3.19l7.15 21.28c.03.09-.06.15-.19.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "69.0329px 219.535px"
    },
    id: "elwwnqeo7a0rf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88 233a.39.39 0 0 1-.3-.19l-7.14-21.28c0-.09.05-.15.19-.14a.35.35 0 0 1 .3.19l7.15 21.28c.03.03-.08.14-.2.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.2625px 222.194px"
    },
    id: "elsocu2ib5ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.11 235.56a.37.37 0 0 1-.3-.19l-7.15-21.28c0-.09.06-.15.2-.14a.36.36 0 0 1 .3.18l7.14 21.28c.03.09-.05.16-.19.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "53.4831px 224.755px"
    },
    id: "els95xsu217n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.34 238.16A.35.35 0 0 1 49 238l-7.11-21.3c0-.09.06-.15.2-.14a.36.36 0 0 1 .3.18L49.53 238c.03.11-.06.18-.19.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "45.7129px 227.361px"
    },
    id: "elcyffgs9zful",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.79 231.79 2.34 7-.55-.19-2.26-6.73-4.11-12.25-.09-.28a.09.09 0 0 1 .09-.13h.1a.35.35 0 0 1 .3.18v.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "37.6202px 229px"
    },
    id: "elsi15gc66bsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.77 233.67a7.38 7.38 0 0 1-.64-.5l-.49-1.46-.46-1.39-2.81-8.39a.08.08 0 0 1 0-.11.28.28 0 0 1 .15 0 .36.36 0 0 1 .3.18v.09l.13.38.79 2.36 2 5.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "28.559px 227.74px"
    },
    id: "elr3jp1vrasla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.43 227.42a.39.39 0 0 1-.24-.1c-.09-.08-.08-.17 0-.21l54.41-18.26a.41.41 0 0 1 .36.08c.09.09.08.18 0 .22l-54.41 18.26a.23.23 0 0 1-.12.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "55.575px 218.131px"
    },
    id: "elnvs9p7u9bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22 232.74a.37.37 0 0 1-.24-.1c-.1-.08-.09-.17 0-.21l54.42-18.26a.4.4 0 0 1 .36.08c.1.09.09.18 0 .22l-54.4 18.26a.25.25 0 0 1-.14.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "57.37px 223.451px"
    },
    id: "elr4l8fwa7zqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.53 219.79-42 14.09-8.43 2.83-.51-.24 8.79-2.95 41.81-14a.45.45 0 0 1 .36.09c.09.05.08.14-.02.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.1008px 228.111px"
    },
    id: "elsci9fh94rs8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.79 224.79 2 5.86Zm53.46-21.09a.29.29 0 0 0-.17-.15.38.38 0 0 0-.25 0l-46.62 15.63h-.07l-7.72 2.58a.08.08 0 0 0 0 .11l2.81 8.39.47 1.39.49 1.46a7.38 7.38 0 0 0 .64.5l-1-3-2-5.86-.83-2.32-.13-.38 7.34-2.46.43-.15 46.21-15.51 7 20.91-40 13.44-3.92 1.31c.25.07.5.12.74.17l3.59-1.2 40.07-13.45c.06 0 .09-.08.07-.13Zm-53.46 21.09 2 5.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "57.4021px 221.644px"
    },
    id: "elygyjqr4o5lj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "57.3771px 221.635px"
    },
    className: "animable",
    id: "elbk8hwrvz09r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2 225.12a.37.37 0 0 1-.3-.18l-7.14-21.28c0-.09 0-.16.19-.15a.37.37 0 0 1 .3.19l7.14 21.3c.03.07-.05.13-.19.12Z",
    id: "el25lk5rc719c",
    className: "animable",
    style: {
      transformOrigin: "84.5781px 214.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.43 227.73a.35.35 0 0 1-.3-.19L73 206.27c0-.09.06-.16.2-.15a.39.39 0 0 1 .3.19l7.14 21.28c.01.09-.07.15-.21.14Z",
    id: "el1dp5pnaxmgv",
    className: "animable",
    style: {
      transformOrigin: "76.8204px 216.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66 230.34a.37.37 0 0 1-.31-.19l-7.14-21.28c0-.09.06-.15.19-.14a.35.35 0 0 1 .3.19l7.15 21.28c.03.09-.06.15-.19.14Z",
    id: "elxki6hjs73h9",
    className: "animable",
    style: {
      transformOrigin: "69.0329px 219.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88 233a.39.39 0 0 1-.3-.19l-7.14-21.28c0-.09.05-.15.19-.14a.35.35 0 0 1 .3.19l7.15 21.28c.03.03-.08.14-.2.14Z",
    id: "el5abiy5kp4ji",
    className: "animable",
    style: {
      transformOrigin: "61.2625px 222.194px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.11 235.56a.37.37 0 0 1-.3-.19l-7.15-21.28c0-.09.06-.15.2-.14a.36.36 0 0 1 .3.18l7.14 21.28c.03.09-.05.16-.19.15Z",
    id: "el7x6g8t7b50m",
    className: "animable",
    style: {
      transformOrigin: "53.4831px 224.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.34 238.16A.35.35 0 0 1 49 238l-7.11-21.3c0-.09.06-.15.2-.14a.36.36 0 0 1 .3.18L49.53 238c.03.11-.06.18-.19.16Z",
    id: "el0v2o1kob4geo",
    className: "animable",
    style: {
      transformOrigin: "45.7129px 227.361px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.79 231.79 2.34 7-.55-.19-2.26-6.73-4.11-12.25-.09-.28a.09.09 0 0 1 .09-.13h.1a.35.35 0 0 1 .3.18v.09Z",
    id: "elt3kl94pyta",
    className: "animable",
    style: {
      transformOrigin: "37.6202px 229px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.77 233.67a7.38 7.38 0 0 1-.64-.5l-.49-1.46-.46-1.39-2.81-8.39a.08.08 0 0 1 0-.11.28.28 0 0 1 .15 0 .36.36 0 0 1 .3.18v.09l.13.38.79 2.36 2 5.86Z",
    id: "eloe3201ed76g",
    className: "animable",
    style: {
      transformOrigin: "28.559px 227.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.43 227.42a.39.39 0 0 1-.24-.1c-.09-.08-.08-.17 0-.21l54.41-18.26a.41.41 0 0 1 .36.08c.09.09.08.18 0 .22l-54.41 18.26a.23.23 0 0 1-.12.01Z",
    id: "elhrbv5dse8wo",
    className: "animable",
    style: {
      transformOrigin: "55.575px 218.131px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22 232.74a.37.37 0 0 1-.24-.1c-.1-.08-.09-.17 0-.21l54.42-18.26a.4.4 0 0 1 .36.08c.1.09.09.18 0 .22l-54.4 18.26a.25.25 0 0 1-.14.01Z",
    id: "el27xh7i74xpp",
    className: "animable",
    style: {
      transformOrigin: "57.37px 223.451px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.53 219.79-42 14.09-8.43 2.83-.51-.24 8.79-2.95 41.81-14a.45.45 0 0 1 .36.09c.09.05.08.14-.02.18Z",
    id: "els3qlfgxkiy9",
    className: "animable",
    style: {
      transformOrigin: "61.1008px 228.111px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.79 224.79 2 5.86Zm53.46-21.09a.29.29 0 0 0-.17-.15.38.38 0 0 0-.25 0l-46.62 15.63h-.07l-7.72 2.58a.08.08 0 0 0 0 .11l2.81 8.39.47 1.39.49 1.46a7.38 7.38 0 0 0 .64.5l-1-3-2-5.86-.83-2.32-.13-.38 7.34-2.46.43-.15 46.21-15.51 7 20.91-40 13.44-3.92 1.31c.25.07.5.12.74.17l3.59-1.2 40.07-13.45c.06 0 .09-.08.07-.13Zm-53.46 21.09 2 5.86Z",
    id: "elb8h3qlp91ai",
    className: "animable",
    style: {
      transformOrigin: "57.4021px 221.644px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55 239.05c-3.31 1.11-6.57-1.24-7.87-3.32s-1-3-2-3.51-2.06.29-6.57.73-6.29-.73-8-1.9l-.65 1.95.21.17a7.38 7.38 0 0 0 .64.5 25 25 0 0 0 4.16 2.49 59.1 59.1 0 0 0 5.65 2.41l.55.19a28.33 28.33 0 0 0 2.79.83c.25.07.5.12.74.17a16.44 16.44 0 0 0 8.82-.21l1.51-.5Z",
    style: {
      opacity: 0.2,
      transformOrigin: "42.455px 235.656px"
    },
    className: "animable",
    id: "eluba6mtm6cok"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.18 223.45c1.38 3.18 5.89 8.7 11.75 8.57s6.59-.92 7.91-.46 1.3 1.89 2.5 4c1.06 1.86 4.56 5.19 8.14 4-5.66 1.9-12.09-.29-18.55-3.38s-10.14-7.91-11.75-12.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "38.33px 231.859px"
    },
    id: "ely4t7o70c3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.18 223.45c1.38 3.18 5.89 8.7 11.75 8.57s6.59-.92 7.91-.46 1.3 1.89 2.5 4c1.06 1.86 4.56 5.19 8.14 4-5.66 1.9-12.09-.29-18.55-3.38s-10.14-7.91-11.75-12.73Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "38.33px 231.859px"
    },
    className: "animable",
    id: "elml8rug4afb9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "75.2607px 306.162px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.76 265.8 7.29 46.89a.62.62 0 0 0 .73.5l62.69-9.79a.61.61 0 0 0 .55-.69l-7.29-46.9a.63.63 0 0 0-.73-.5l-62.69 9.79a.62.62 0 0 0-.55.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "86.39px 284.251px"
    },
    id: "elfvwyv9t8xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.76 265.8 7.29 46.89a.62.62 0 0 0 .73.5l62.69-9.79a.61.61 0 0 0 .55-.69l-7.29-46.9a.63.63 0 0 0-.73-.5l-62.69 9.79a.62.62 0 0 0-.55.7Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "86.39px 284.251px"
    },
    className: "animable",
    id: "el0uqdd5fpfvp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.78 262.53-64 10-1-6.72a.57.57 0 0 1 .11-.44.67.67 0 0 1 .44-.26l62.67-9.8a.63.63 0 0 1 .7.39s0 0 0 .07l.07.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "83.2762px 263.915px"
    },
    id: "elfovbi8bm9bk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.78 262.53-64 10-1-6.72a.57.57 0 0 1 .11-.44.67.67 0 0 1 .44-.26l62.67-9.8a.63.63 0 0 1 .7.39s0 0 0 .07l.07.45Z",
    style: {
      opacity: 0.2,
      transformOrigin: "83.2762px 263.915px"
    },
    className: "animable",
    id: "el3w6ilg5nd8n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52 267.42a1.23 1.23 0 1 1 1.37.86 1.16 1.16 0 0 1-1.37-.86Z",
    style: {
      fill: "#263238",
      transformOrigin: "57.6977px 267.07px"
    },
    id: "el39lm6du96ey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 266.1a1.23 1.23 0 1 1 1.37.86 1.15 1.15 0 0 1-1.37-.86Z",
    style: {
      fill: "#263238",
      transformOrigin: "66.1777px 265.751px"
    },
    id: "elpuj34msycys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42 264.78a1.23 1.23 0 0 1 2.41-.38 1.23 1.23 0 0 1-2.41.38Z",
    style: {
      fill: "#263238",
      transformOrigin: "74.625px 264.59px"
    },
    id: "eldtkovd67n7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32 262.14a1.14 1.14 0 0 1 1-1.23 1.07 1.07 0 1 1-1 1.23Z",
    style: {
      fill: "#263238",
      transformOrigin: "91.3818px 261.978px"
    },
    id: "elkri6i5b4k3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.77 260.82a1.15 1.15 0 0 1 1-1.23 1.07 1.07 0 1 1 .32 2.09 1.15 1.15 0 0 1-1.32-.86Z",
    style: {
      fill: "#263238",
      transformOrigin: "99.9649px 260.619px"
    },
    id: "el0b2vzix2udt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15 259.59a1.23 1.23 0 1 1 1.37.86 1.15 1.15 0 0 1-1.37-.86Z",
    style: {
      fill: "#263238",
      transformOrigin: "108.328px 259.241px"
    },
    id: "elr5k2zj6bbz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.4px 271.48px",
      transform: "rotate(-8.85deg)"
    },
    className: "animable",
    d: "M52.03 267.47h64.74v8.02H52.03z",
    id: "elnpfqz7ge97s"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "84.4px 271.48px"
    },
    className: "animable",
    id: "el938hynbu3iw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "84.4px 271.48px",
      transform: "rotate(-8.85deg)"
    },
    className: "animable",
    d: "M52.03 267.47h64.74v8.02H52.03z",
    id: "el94zw8i7dn7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.83 272.1.84-2.19a.38.38 0 0 1 .07-.11.26.26 0 0 1 .17-.1l.41-.06a.13.13 0 0 1 .12 0 .16.16 0 0 1 .07.11l.62 3.94a.27.27 0 0 1 0 .12.19.19 0 0 1-.11.07l-.5.07a.14.14 0 0 1-.12 0 .14.14 0 0 1-.07-.11l-.37-2.38-.58 1.5a.49.49 0 0 1-.07.11.19.19 0 0 1-.13.07l-.32.05a.17.17 0 0 1-.14 0 .3.3 0 0 1-.1-.09l-1-1.24.37 2.38a.12.12 0 0 1 0 .12.14.14 0 0 1-.11.07l-.49.08a.12.12 0 0 1-.12 0 .16.16 0 0 1-.07-.11l-.62-3.94a.27.27 0 0 1 0-.12.19.19 0 0 1 .11-.07l.42-.06a.24.24 0 0 1 .19 0l.09.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "80.855px 272.076px"
    },
    id: "elk5e7n3yicms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44 269.15a.18.18 0 0 1 .15 0 .4.4 0 0 1 .11.14l2.1 3.62a.15.15 0 0 1 0 .13.13.13 0 0 1-.11.06l-.44.07a.21.21 0 0 1-.18 0l-.08-.09-.37-.64-1.92.3-.16.72a.18.18 0 0 1 0 .11.22.22 0 0 1-.16.08l-.44.07a.17.17 0 0 1-.12 0 .19.19 0 0 1-.07-.11l.89-4.09a.38.38 0 0 1 .06-.17.19.19 0 0 1 .14-.07Zm.75 2.62-.94-1.63-.4 1.84Z",
    style: {
      fill: "#455a64",
      transformOrigin: "85.7824px 271.432px"
    },
    id: "el4mo5m4oj0l4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5 268.36a.14.14 0 0 1 .12 0 .19.19 0 0 1 .07.11.13.13 0 0 1 0 .06l-1 2.76.21 1.35a.27.27 0 0 1 0 .12.19.19 0 0 1-.11.07l-.49.07a.13.13 0 0 1-.12 0 .14.14 0 0 1-.07-.11l-.21-1.34-1.9-2.31a.14.14 0 0 1 0-.06.14.14 0 0 1 0-.12.16.16 0 0 1 .11-.07l.45-.07a.3.3 0 0 1 .2 0l.08.08 1.26 1.57.72-1.87s0-.06.06-.11a.3.3 0 0 1 .17-.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "88.84px 270.631px"
    },
    id: "elg9u7b50moj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 283.7a.91.91 0 0 0 1.1.64l4.8-.75a.82.82 0 1 0-.25-1.58l-4.8.75a.9.9 0 0 0-.85.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.3863px 283.16px"
    },
    id: "elieyjtwshfnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1 282.43a.9.9 0 0 0 1.1.64l4.8-.74a.82.82 0 1 0-.25-1.59l-4.8.75a.9.9 0 0 0-.85.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "69.4747px 281.895px"
    },
    id: "elvfuqp6r63je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2 281.17a.9.9 0 0 0 1.09.64l4.81-.75a.82.82 0 1 0-.25-1.58l-4.8.75a.9.9 0 0 0-.85.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "77.5863px 280.63px"
    },
    id: "elayqpm9ngkvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.29 279.91a.92.92 0 0 0 1.1.64l4.8-.75a.82.82 0 1 0-.24-1.59l-4.8.75a.93.93 0 0 0-.86.95Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "85.6695px 279.368px"
    },
    id: "els58ijp4l0af",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39 278.64a.91.91 0 0 0 1.1.64l4.8-.75A.82.82 0 1 0 96 277l-4.8.75a.9.9 0 0 0-.81.89Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "93.8038px 278.102px"
    },
    id: "el5ew7t7euq32",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.49 277.38a.92.92 0 0 0 1.1.64l4.8-.75a.82.82 0 1 0-.25-1.59l-4.8.75a.91.91 0 0 0-.85.95Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "101.865px 276.838px"
    },
    id: "elslm2n6g7qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.59 276.11a.89.89 0 0 0 1.09.64l4.8-.75a.82.82 0 1 0-.24-1.58l-4.8.75a.9.9 0 0 0-.85.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "109.976px 275.571px"
    },
    id: "elvuy8jjsw1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "88.0163px 294.431px"
    },
    className: "animable",
    id: "el8bbuconpor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.13 301.26a.38.38 0 0 1-.27-.23l-3.46-22.18c0-.09.08-.14.21-.1a.33.33 0 0 1 .27.23l3.46 22.17c.02.1-.08.15-.21.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "116.371px 290.005px"
    },
    id: "el9j7slyi1h9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 302.53a.39.39 0 0 1-.27-.24l-3.46-22.17c0-.1.08-.14.21-.11a.36.36 0 0 1 .27.23l3.46 22.18c.05.09-.05.14-.21.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "108.246px 291.269px"
    },
    id: "el6ioa3j2hpyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93 303.79a.36.36 0 0 1-.27-.23l-3.46-22.18c0-.09.08-.14.21-.11a.39.39 0 0 1 .27.24l3.46 22.17c.02.1-.08.14-.21.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "100.171px 292.531px"
    },
    id: "elhpgw0pfx8tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.83 305.06c-.14 0-.26-.14-.27-.24l-3.46-22.17c0-.1.08-.15.21-.11a.38.38 0 0 1 .27.23L94 305c.06 0 0 .09-.17.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "92.0613px 293.796px"
    },
    id: "el9blek8k805i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73 306.32a.34.34 0 0 1-.27-.23L82 283.91c0-.09.08-.14.21-.11a.4.4 0 0 1 .27.23l3.46 22.18c.06.1-.08.14-.21.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "83.9772px 295.061px"
    },
    id: "elpevg7e7922s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.63 307.58a.33.33 0 0 1-.27-.23l-3.46-22.17c0-.1.08-.15.21-.11a.38.38 0 0 1 .27.23l3.46 22.18c.01.09-.08.14-.21.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "75.8704px 296.325px"
    },
    id: "el0rnp0oo6c8gl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 308.85a.34.34 0 0 1-.26-.23l-3.47-22.18c0-.09.09-.14.22-.11a.4.4 0 0 1 .27.23l3.46 22.18c.01.1-.08.14-.22.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "67.7654px 297.591px"
    },
    id: "elvaopsojlhvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.42 310.11a.33.33 0 0 1-.26-.23l-3.47-22.18c0-.09.08-.14.22-.1a.34.34 0 0 1 .26.23L61.64 310c.01.1-.08.15-.22.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "59.6654px 298.855px"
    },
    id: "eli0wjzrpubz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83 293.48a.37.37 0 0 1-.22-.14c-.08-.1-.06-.19 0-.21l56.7-8.85a.4.4 0 0 1 .34.15c.08.1.06.19 0 .21l-56.71 8.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "87.13px 288.885px"
    },
    id: "el4i9yawt0mcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69 299a.55.55 0 0 1-.22-.14c-.08-.1-.06-.19.05-.21l56.71-8.85a.4.4 0 0 1 .34.14c.08.1.05.19-.06.21L59.81 299a.24.24 0 0 1-.12 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "88.0183px 294.403px"
    },
    id: "elnrkc0dn18xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.56 304.57a.4.4 0 0 1-.22-.14c-.08-.1-.06-.19 0-.21l56.7-8.85a.4.4 0 0 1 .34.15c.08.1.06.19-.05.2l-56.71 8.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "88.8579px 299.975px"
    },
    id: "elx1kh3rg7z3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.42 310.11a.31.31 0 0 1-.12-.05.29.29 0 0 1-.14-.18l-3.47-22.18c0-.06 0-.1.1-.11l56.71-8.85a.37.37 0 0 1 .24.06.29.29 0 0 1 .14.18l3.46 22.17a.1.1 0 0 1-.09.12l-56.71 8.85a.17.17 0 0 1-.12-.01Zm-3.23-22.18 3.4 21.79 56.26-8.79-3.4-21.79Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "88.016px 294.432px"
    },
    id: "el89xtefrih98",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "88.0163px 294.431px"
    },
    className: "animable",
    id: "eli27xiao18z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.13 301.26a.38.38 0 0 1-.27-.23l-3.46-22.18c0-.09.08-.14.21-.1a.33.33 0 0 1 .27.23l3.46 22.17c.02.1-.08.15-.21.11Z",
    id: "el1fjvhqzce2a",
    className: "animable",
    style: {
      transformOrigin: "116.371px 290.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 302.53a.39.39 0 0 1-.27-.24l-3.46-22.17c0-.1.08-.14.21-.11a.36.36 0 0 1 .27.23l3.46 22.18c.05.09-.05.14-.21.11Z",
    id: "el0xw694jpl63",
    className: "animable",
    style: {
      transformOrigin: "108.246px 291.269px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93 303.79a.36.36 0 0 1-.27-.23l-3.46-22.18c0-.09.08-.14.21-.11a.39.39 0 0 1 .27.24l3.46 22.17c.02.1-.08.14-.21.11Z",
    id: "elvj26xolvd8i",
    className: "animable",
    style: {
      transformOrigin: "100.171px 292.531px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.83 305.06c-.14 0-.26-.14-.27-.24l-3.46-22.17c0-.1.08-.15.21-.11a.38.38 0 0 1 .27.23L94 305c.06 0 0 .09-.17.06Z",
    id: "el7vv6ibrvsw5",
    className: "animable",
    style: {
      transformOrigin: "92.0613px 293.796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73 306.32a.34.34 0 0 1-.27-.23L82 283.91c0-.09.08-.14.21-.11a.4.4 0 0 1 .27.23l3.46 22.18c.06.1-.08.14-.21.11Z",
    id: "el29nwiys7k89",
    className: "animable",
    style: {
      transformOrigin: "83.9772px 295.061px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.63 307.58a.33.33 0 0 1-.27-.23l-3.46-22.17c0-.1.08-.15.21-.11a.38.38 0 0 1 .27.23l3.46 22.18c.01.09-.08.14-.21.1Z",
    id: "elx1otjzrwbp",
    className: "animable",
    style: {
      transformOrigin: "75.8704px 296.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 308.85a.34.34 0 0 1-.26-.23l-3.47-22.18c0-.09.09-.14.22-.11a.4.4 0 0 1 .27.23l3.46 22.18c.01.1-.08.14-.22.11Z",
    id: "el3i4hxs508c3",
    className: "animable",
    style: {
      transformOrigin: "67.7654px 297.591px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.42 310.11a.33.33 0 0 1-.26-.23l-3.47-22.18c0-.09.08-.14.22-.1a.34.34 0 0 1 .26.23L61.64 310c.01.1-.08.15-.22.11Z",
    id: "elbnpe0r49wfc",
    className: "animable",
    style: {
      transformOrigin: "59.6654px 298.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83 293.48a.37.37 0 0 1-.22-.14c-.08-.1-.06-.19 0-.21l56.7-8.85a.4.4 0 0 1 .34.15c.08.1.06.19 0 .21l-56.71 8.85Z",
    id: "eltbs0dqf3mqo",
    className: "animable",
    style: {
      transformOrigin: "87.13px 288.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69 299a.55.55 0 0 1-.22-.14c-.08-.1-.06-.19.05-.21l56.71-8.85a.4.4 0 0 1 .34.14c.08.1.05.19-.06.21L59.81 299a.24.24 0 0 1-.12 0Z",
    id: "elhri36c0rt6w",
    className: "animable",
    style: {
      transformOrigin: "88.0183px 294.403px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.56 304.57a.4.4 0 0 1-.22-.14c-.08-.1-.06-.19 0-.21l56.7-8.85a.4.4 0 0 1 .34.15c.08.1.06.19-.05.2l-56.71 8.86Z",
    id: "eldz8xdeuclo9",
    className: "animable",
    style: {
      transformOrigin: "88.8579px 299.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.42 310.11a.31.31 0 0 1-.12-.05.29.29 0 0 1-.14-.18l-3.47-22.18c0-.06 0-.1.1-.11l56.71-8.85a.37.37 0 0 1 .24.06.29.29 0 0 1 .14.18l3.46 22.17a.1.1 0 0 1-.09.12l-56.71 8.85a.17.17 0 0 1-.12-.01Zm-3.23-22.18 3.4 21.79 56.26-8.79-3.4-21.79Z",
    id: "elzfsdtyhlqsn",
    className: "animable",
    style: {
      transformOrigin: "88.016px 294.432px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "77.195px 303.28px"
    },
    className: "animable",
    d: "m79.55 309.95 19.29-3.01-43.29-10.33 1.23 7.91 22.77 5.43z",
    id: "elouq9ae6ons"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3 309.68 37.58 295a.63.63 0 0 0-.77.44l-7.74 32.34a.43.43 0 0 0 0 .11c-.05.18-.09.35-.13.52A15.92 15.92 0 0 0 30 338.9a5.45 5.45 0 0 0 .33.58l.07.12c.15.24.31.48.47.71s.24.33.37.49a10.52 10.52 0 0 0 5.82 4.07h.08L88 357a.62.62 0 0 0 .77-.44l11-46.16a.63.63 0 0 0-.47-.72Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "64.1375px 326.001px"
    },
    id: "eldjis9cewaol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3 309.68 37.58 295a.63.63 0 0 0-.77.44l-7.74 32.34a.43.43 0 0 0 0 .11c-.05.18-.09.35-.13.52A15.92 15.92 0 0 0 30 338.9a5.45 5.45 0 0 0 .33.58l.07.12c.15.24.31.48.47.71s.24.33.37.49a10.52 10.52 0 0 0 5.82 4.07h.08L88 357a.62.62 0 0 0 .77-.44l11-46.16a.63.63 0 0 0-.47-.72Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "64.1375px 326.001px"
    },
    className: "animable",
    id: "elfsfpfattbxe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.21 317-63-15 1.58-6.62a.61.61 0 0 1 .27-.36.67.67 0 0 1 .5-.07l61.74 14.74a.64.64 0 0 1 .51.63.2.2 0 0 1 0 .07l-.1.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "67.5115px 305.965px"
    },
    id: "el3pdx6lhk55m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.21 317-63-15 1.58-6.62a.61.61 0 0 1 .27-.36.67.67 0 0 1 .5-.07l61.74 14.74a.64.64 0 0 1 .51.63.2.2 0 0 1 0 .07l-.1.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "67.5115px 305.965px"
    },
    className: "animable",
    id: "elb711qy01uyd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.53 299.09a1.23 1.23 0 1 1 .94 1.31 1.15 1.15 0 0 1-.94-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "42.7505px 299.203px"
    },
    id: "el81f3jcsoihn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.85 301.08a1.23 1.23 0 1 1 .94 1.31 1.15 1.15 0 0 1-.94-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "51.0705px 301.193px"
    },
    id: "el1b14ui3iera",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17 303.06a1.23 1.23 0 1 1 .94 1.31 1.14 1.14 0 0 1-.94-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "59.3898px 303.173px"
    },
    id: "eljsovb2wk4ag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 307a1.23 1.23 0 1 1 .94 1.31 1.14 1.14 0 0 1-.94-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "76.0198px 307.113px"
    },
    id: "el1tu6jlopzaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.12 309a1.24 1.24 0 1 1 .95 1.31 1.15 1.15 0 0 1-.95-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "84.3511px 309.103px"
    },
    id: "elqldq2u81mie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.34 311.05a1.24 1.24 0 1 1 .94 1.31 1.15 1.15 0 0 1-.94-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "92.5709px 311.156px"
    },
    id: "elbn2y5sukkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "65.79px 313.42px",
      transform: "rotate(-76.56deg)"
    },
    className: "animable",
    d: "M61.78 281.05h8.02v64.74h-8.02z",
    id: "eltsbp3ep4v9a"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "65.79px 313.42px"
    },
    className: "animable",
    id: "eldxzzkas1z57"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "65.79px 313.42px",
      transform: "rotate(-76.56deg)"
    },
    className: "animable",
    d: "M61.78 281.05h8.02v64.74h-8.02z",
    id: "el6iuvf6sfgi9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m61 310.92-2-.47a.18.18 0 0 1-.11-.08.17.17 0 0 1 0-.12l.1-.43a.16.16 0 0 1 .08-.1.13.13 0 0 1 .12 0l2.62.62a.16.16 0 0 1 .1.08.13.13 0 0 1 0 .12l-.6 2.54a1.58 1.58 0 0 1-.71 1.07 1.84 1.84 0 0 1-1.33.09 2.11 2.11 0 0 1-.71-.28 1.44 1.44 0 0 1-.44-.4 1.16 1.16 0 0 1-.21-.5 1.41 1.41 0 0 1 0-.54.14.14 0 0 1 .07-.11.19.19 0 0 1 .13 0l.48.11a.18.18 0 0 1 .09.06.12.12 0 0 1 .05.1.55.55 0 0 0 0 .25.7.7 0 0 0 .33.44 1.28 1.28 0 0 0 .35.13.79.79 0 0 0 1.06-.64Z",
    style: {
      fill: "#455a64",
      transformOrigin: "59.9043px 312.015px"
    },
    id: "elww43dq5q3jk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1 311.35a.13.13 0 0 1 .1.07.16.16 0 0 1 0 .13l-.56 2.45a2 2 0 0 1-.27.65 1.4 1.4 0 0 1-1.07.64 2.09 2.09 0 0 1-.77-.06 2.32 2.32 0 0 1-.73-.3 1.55 1.55 0 0 1-.46-.46 1.33 1.33 0 0 1-.19-.59 1.89 1.89 0 0 1 .05-.7l.59-2.46a.14.14 0 0 1 .07-.1.15.15 0 0 1 .13 0l.49.11a.19.19 0 0 1 .1.08.17.17 0 0 1 0 .12l-.58 2.42a1.41 1.41 0 0 0 0 .44.81.81 0 0 0 .12.33.79.79 0 0 0 .25.23 1.18 1.18 0 0 0 .36.14 1.64 1.64 0 0 0 .38 0 .75.75 0 0 0 .33-.1.71.71 0 0 0 .25-.24 1.05 1.05 0 0 0 .17-.4l.58-2.43a.2.2 0 0 1 .2-.13Z",
    style: {
      fill: "#455a64",
      transformOrigin: "64.1756px 312.954px"
    },
    id: "elie0j2i5qty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.89 316.46a.19.19 0 0 1-.14-.1.37.37 0 0 1-.06-.1l-1.08-2.9-.61 2.48a.16.16 0 0 1-.08.1.17.17 0 0 1-.12 0l-.49-.11a.2.2 0 0 1-.1-.08.15.15 0 0 1 0-.13l.92-3.87a.18.18 0 0 1 .08-.11.17.17 0 0 1 .12 0l.42.1a.27.27 0 0 1 .15.09v.11l1.1 2.89.59-2.47a.14.14 0 0 1 .07-.1.15.15 0 0 1 .13 0l.48.11a.18.18 0 0 1 .11.08.17.17 0 0 1 0 .12l-.93 3.88a.13.13 0 0 1-.07.1.16.16 0 0 1-.13 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "68.2931px 314.096px"
    },
    id: "eleayojfe1x5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.38 316.73a.14.14 0 0 1 .1.08.12.12 0 0 1 0 .13l-.1.42a.13.13 0 0 1-.07.1.15.15 0 0 1-.13 0l-2.63-.62a.16.16 0 0 1-.1-.08.13.13 0 0 1 0-.12l.92-3.88a.18.18 0 0 1 .08-.11.17.17 0 0 1 .12 0l2.59.62a.16.16 0 0 1 .1.08.17.17 0 0 1 0 .12l-.1.43a.16.16 0 0 1-.08.1.17.17 0 0 1-.12 0l-1.96-.44-.23.95 1.81.43a.16.16 0 0 1 .1.08.13.13 0 0 1 0 .12l-.1.43a.16.16 0 0 1-.08.1.11.11 0 0 1-.12 0l-1.81-.43-.23 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "72.3531px 315.057px"
    },
    id: "elpp80hkghvq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.72 314.72a.9.9 0 0 0 .78 1l4.72 1.13a.82.82 0 1 0 .38-1.56l-4.73-1.12a.91.91 0 0 0-1.15.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "40.0529px 315.525px"
    },
    id: "eli6c1x9j8cv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7 316.62a.9.9 0 0 0 .77 1l4.73 1.12a.9.9 0 0 0 1.14-.55.91.91 0 0 0-.77-1l-4.73-1.12a.9.9 0 0 0-1.14.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "48.0195px 317.405px"
    },
    id: "elsi53jdg3rxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.67 318.52a.9.9 0 0 0 .77 1l4.73 1.12a.9.9 0 0 0 1.14-.55.89.89 0 0 0-.77-1L53.81 318a.9.9 0 0 0-1.14.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "55.9906px 319.318px"
    },
    id: "elgjs0iixae0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.64 320.42a.91.91 0 0 0 .77 1l4.73 1.13a.92.92 0 0 0 1.15-.55.91.91 0 0 0-.78-1l-4.72-1.13a.91.91 0 0 0-1.15.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "63.9649px 321.209px"
    },
    id: "elbkdr0ta6b79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.61 322.32a.91.91 0 0 0 .78 1l4.72 1.13a.82.82 0 1 0 .37-1.56l-4.72-1.13a.91.91 0 0 0-1.15.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "71.9438px 323.121px"
    },
    id: "el7ugba67l1df",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.58 324.22a.92.92 0 0 0 .78 1l4.72 1.13a.82.82 0 1 0 .38-1.56l-4.73-1.13a.91.91 0 0 0-1.15.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "79.9139px 325.021px"
    },
    id: "eli7010fbp60j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.56 326.12a.9.9 0 0 0 .77 1l4.72 1.13a.82.82 0 1 0 .38-1.56l-4.73-1.13a.91.91 0 0 0-1.14.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "87.8879px 326.922px"
    },
    id: "el5i4vqffmert",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "60.5729px 336.025px"
    },
    className: "animable",
    id: "ela05otutgvnl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7 353.77a.36.36 0 0 1-.16-.32l5.21-21.83c0-.09.13-.1.23 0s.19.23.16.32l-5.2 21.83c-.03.07-.13.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "88.3426px 342.688px"
    },
    id: "eladt0fo7zq17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.72 351.87a.36.36 0 0 1-.16-.32l5.21-21.83c0-.09.13-.1.24 0a.36.36 0 0 1 .16.32L78 351.85c-.06.09-.17.15-.28.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "80.365px 340.797px"
    },
    id: "el5z2p7jvwy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75 350a.38.38 0 0 1-.16-.32l5.21-21.83c0-.1.12-.1.23 0s.19.22.16.31L70 350s-.14.05-.25 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "72.3931px 338.899px"
    },
    id: "el3yw5yym4bda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.77 348.06a.36.36 0 0 1-.16-.31l5.21-21.84c0-.09.13-.1.24 0a.36.36 0 0 1 .16.31L62 348.05c0 .09-.12.1-.23.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "64.415px 336.981px"
    },
    id: "el2cs4ra93uht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 346.16a.36.36 0 0 1-.16-.31L58.85 324c0-.09.12-.1.23 0a.38.38 0 0 1 .16.32L54 346.14c0 .1-.09.1-.2.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "56.44px 335.073px"
    },
    id: "el70wmj0nl38x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.82 344.26a.36.36 0 0 1-.16-.32l5.21-21.83c0-.09.13-.1.24 0a.37.37 0 0 1 .16.32l-5.21 21.83c-.06.07-.13.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "48.4649px 333.178px"
    },
    id: "el2eho2aq50ax",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85 342.36a.37.37 0 0 1-.16-.32l5.21-21.83c0-.09.12-.1.23 0a.36.36 0 0 1 .16.32l-5.2 21.83c-.03.07-.09.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "40.4901px 331.278px"
    },
    id: "elhqo6mzt2d8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.32 318.6v.1l-4 16.77-.95 4a5.45 5.45 0 0 1-.33-.58l.91-3.85 4-16.75c0-.05 0-.07.1-.07h.06l.08.05a.36.36 0 0 1 .13.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "32.6818px 328.845px"
    },
    id: "elyixwyq6c6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.78 324.08a.47.47 0 0 1-.16-.21c0-.12 0-.2.13-.18L89.58 337a.38.38 0 0 1 .25.26c0 .12 0 .2-.12.18l-55.83-13.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.725px 330.565px"
    },
    id: "el1l3k5w9tfnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.48 329.54a.47.47 0 0 1-.16-.21c0-.12 0-.2.13-.18l55.83 13.32a.38.38 0 0 1 .25.26c0 .12 0 .2-.12.17l-55.83-13.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "60.425px 336.027px"
    },
    id: "eltr4qqlvqorb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17 335a.42.42 0 0 1-.15-.22c0-.12 0-.19.13-.17L87 347.93a.38.38 0 0 1 .26.26c0 .12 0 .2-.13.17l-55.85-13.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "59.14px 341.486px"
    },
    id: "elj1a1ke2b80h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.08 331.7a.39.39 0 0 0-.2-.15l-55.8-13.31H35c-.06 0-.09 0-.1.07l-4 16.75-.9 3.84a5.45 5.45 0 0 0 .33.58l.95-4 4-16.77 55.38 13.21-5.12 21.45L34 341.06l-3.11-.74c.12.17.24.33.37.49l2.81.67 51.73 12.34a.1.1 0 0 0 .14-.07l5.2-21.83a.28.28 0 0 0-.06-.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "60.5716px 336.035px"
    },
    id: "eln5q22d0387n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "60.5729px 336.025px"
    },
    className: "animable",
    id: "elg8u5c3xf4jn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7 353.77a.36.36 0 0 1-.16-.32l5.21-21.83c0-.09.13-.1.23 0s.19.23.16.32l-5.2 21.83c-.03.07-.13.08-.24 0Z",
    id: "el1f8i9l9bnup",
    className: "animable",
    style: {
      transformOrigin: "88.3426px 342.688px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.72 351.87a.36.36 0 0 1-.16-.32l5.21-21.83c0-.09.13-.1.24 0a.36.36 0 0 1 .16.32L78 351.85c-.06.09-.17.15-.28.02Z",
    id: "el65mwu4af47j",
    className: "animable",
    style: {
      transformOrigin: "80.365px 340.797px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75 350a.38.38 0 0 1-.16-.32l5.21-21.83c0-.1.12-.1.23 0s.19.22.16.31L70 350s-.14.05-.25 0Z",
    id: "elrvaaiggcxb8",
    className: "animable",
    style: {
      transformOrigin: "72.3931px 338.899px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.77 348.06a.36.36 0 0 1-.16-.31l5.21-21.84c0-.09.13-.1.24 0a.36.36 0 0 1 .16.31L62 348.05c0 .09-.12.1-.23.01Z",
    id: "elmt68e79itw",
    className: "animable",
    style: {
      transformOrigin: "64.415px 336.981px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 346.16a.36.36 0 0 1-.16-.31L58.85 324c0-.09.12-.1.23 0a.38.38 0 0 1 .16.32L54 346.14c0 .1-.09.1-.2.02Z",
    id: "elzj2zzp9jsj8",
    className: "animable",
    style: {
      transformOrigin: "56.44px 335.073px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.82 344.26a.36.36 0 0 1-.16-.32l5.21-21.83c0-.09.13-.1.24 0a.37.37 0 0 1 .16.32l-5.21 21.83c-.06.07-.13.08-.24 0Z",
    id: "ellzkufbpkk3m",
    className: "animable",
    style: {
      transformOrigin: "48.4649px 333.178px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.85 342.36a.37.37 0 0 1-.16-.32l5.21-21.83c0-.09.12-.1.23 0a.36.36 0 0 1 .16.32l-5.2 21.83c-.03.07-.09.08-.24 0Z",
    id: "elfyaxw1i1j7a",
    className: "animable",
    style: {
      transformOrigin: "40.4901px 331.278px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.32 318.6v.1l-4 16.77-.95 4a5.45 5.45 0 0 1-.33-.58l.91-3.85 4-16.75c0-.05 0-.07.1-.07h.06l.08.05a.36.36 0 0 1 .13.33Z",
    id: "elqsu977a63k",
    className: "animable",
    style: {
      transformOrigin: "32.6818px 328.845px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.78 324.08a.47.47 0 0 1-.16-.21c0-.12 0-.2.13-.18L89.58 337a.38.38 0 0 1 .25.26c0 .12 0 .2-.12.18l-55.83-13.31Z",
    id: "elqu0dj77gwio",
    className: "animable",
    style: {
      transformOrigin: "61.725px 330.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.48 329.54a.47.47 0 0 1-.16-.21c0-.12 0-.2.13-.18l55.83 13.32a.38.38 0 0 1 .25.26c0 .12 0 .2-.12.17l-55.83-13.31Z",
    id: "els9x02pai6kp",
    className: "animable",
    style: {
      transformOrigin: "60.425px 336.027px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17 335a.42.42 0 0 1-.15-.22c0-.12 0-.19.13-.17L87 347.93a.38.38 0 0 1 .26.26c0 .12 0 .2-.13.17l-55.85-13.31Z",
    id: "eltpcsmwdcas",
    className: "animable",
    style: {
      transformOrigin: "59.14px 341.486px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.08 331.7a.39.39 0 0 0-.2-.15l-55.8-13.31H35c-.06 0-.09 0-.1.07l-4 16.75-.9 3.84a5.45 5.45 0 0 0 .33.58l.95-4 4-16.77 55.38 13.21-5.12 21.45L34 341.06l-3.11-.74c.12.17.24.33.37.49l2.81.67 51.73 12.34a.1.1 0 0 0 .14-.07l5.2-21.83a.28.28 0 0 0-.06-.22Z",
    id: "elcbogzzvy3g",
    className: "animable",
    style: {
      transformOrigin: "60.5716px 336.035px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.93 333.56c.87 1.79 2.75 2.33 3.81 2.76s1.07 1.1.78 2.36a6.67 6.67 0 0 0 0 4 10.8 10.8 0 0 1-3.19-3.84 19.47 19.47 0 0 1-1.4-5.28Z",
    style: {
      opacity: 0.2,
      transformOrigin: "32.3061px 338.12px"
    },
    className: "animable",
    id: "el5l9b42fomef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.08 327.74a8.66 8.66 0 0 0 1.66 7.09c1.55 2 2.64 1.61 3.18 2.74.27.58-.07 1.48 0 2.84.1 2.22 1.23 4 3.24 4.49a11.13 11.13 0 0 1-6.74-5.29c-1.57-2.49-2.59-6.67-1.34-11.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "32.8403px 336.32px"
    },
    id: "elebw0wntsv9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.08 327.74a8.66 8.66 0 0 0 1.66 7.09c1.55 2 2.64 1.61 3.18 2.74.27.58-.07 1.48 0 2.84.1 2.22 1.23 4 3.24 4.49a11.13 11.13 0 0 1-6.74-5.29c-1.57-2.49-2.59-6.67-1.34-11.87Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "32.8403px 336.32px"
    },
    className: "animable",
    id: "elaqzvhtjd15j"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "379.5px 91.4468px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.31 69.75 373.19 114a.63.63 0 0 1-.83.33L324 95.68h-.35l-.17-.06-.23-.09c-3.74-1.49-4.72-2.29-6.35-4.56s-2.29-4.41-1.57-6.58c0-.1.06-.2.1-.3l14.51-37.5a.63.63 0 0 1 .82-.33L389.92 69a.62.62 0 0 1 .39.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "352.687px 80.2968px"
    },
    id: "elv6jzv12d2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31 69.75 373.19 114a.63.63 0 0 1-.83.33L324 95.68h-.35l-.17-.06-.23-.09c-3.74-1.49-4.72-2.29-6.35-4.56s-2.29-4.41-1.57-6.58c0-.1.06-.2.1-.3l14.51-37.5a.63.63 0 0 1 .82-.33L389.92 69a.62.62 0 0 1 .39.75Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "352.687px 80.2968px"
    },
    className: "animable",
    id: "elcexsgkkifv9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.86 76.1-60.4-23.33 2.45-6.34a.56.56 0 0 1 .32-.32.66.66 0 0 1 .5 0L389.92 69a.63.63 0 0 1 .42.69.19.19 0 0 1 0 .07l-.16.42Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "358.903px 61.0804px"
    },
    id: "el45hsn0e3z5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.86 76.1-60.4-23.33 2.45-6.34a.56.56 0 0 1 .32-.32.66.66 0 0 1 .5 0L389.92 69a.63.63 0 0 1 .42.69.19.19 0 0 1 0 .07l-.16.42Z",
    style: {
      opacity: 0.2,
      transformOrigin: "358.903px 61.0804px"
    },
    className: "animable",
    id: "eld8rb42vry44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.09 50.72a1.24 1.24 0 1 1 .76 1.42 1.15 1.15 0 0 1-.76-1.42Z",
    style: {
      fill: "#263238",
      transformOrigin: "335.293px 50.9851px"
    },
    id: "elk7hvyn5a01",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.07 53.8a1.17 1.17 0 0 1 1.53-.55 1.07 1.07 0 1 1-1.53.55Z",
    style: {
      fill: "#263238",
      transformOrigin: "343.07px 54.1983px"
    },
    id: "elaxskxwq474v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05 56.88a1.24 1.24 0 1 1 .75 1.42 1.15 1.15 0 0 1-.75-1.42Z",
    style: {
      fill: "#263238",
      transformOrigin: "351.252px 57.1487px"
    },
    id: "el2xk79p6ixuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 63a1.24 1.24 0 1 1 .76 1.42A1.15 1.15 0 0 1 366 63Z",
    style: {
      fill: "#263238",
      transformOrigin: "367.203px 63.265px"
    },
    id: "elb8x7wkwrgou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 66.12a1.23 1.23 0 0 1 2.28.88 1.23 1.23 0 0 1-2.28-.88Z",
    style: {
      fill: "#263238",
      transformOrigin: "375.14px 66.56px"
    },
    id: "elv3vf9651e0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85 69.24a1.23 1.23 0 1 1 .76 1.43 1.15 1.15 0 0 1-.76-1.43Z",
    style: {
      fill: "#263238",
      transformOrigin: "383.039px 69.5205px"
    },
    id: "eljumqf6zit6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "356.22px 68.17px",
      transform: "rotate(-68.87deg)"
    },
    className: "animable",
    d: "M352.21 35.8h8.02v64.74h-8.02z",
    id: "el0li0ak0qorvc"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "356.22px 68.17px"
    },
    className: "animable",
    id: "el92v7civimlo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "356.22px 68.17px",
      transform: "rotate(-68.87deg)"
    },
    className: "animable",
    d: "M352.21 35.8h8.02v64.74h-8.02z",
    id: "el1soymcgauqp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m352.36 65.24-1.88-.73a.14.14 0 0 1-.09-.08.2.2 0 0 1 0-.13l.16-.41a.2.2 0 0 1 .09-.09.19.19 0 0 1 .13 0l2.5 1a.13.13 0 0 1 .09.09.15.15 0 0 1 0 .13l-.94 2.43a1.53 1.53 0 0 1-.85 1 1.79 1.79 0 0 1-1.33-.08 2.28 2.28 0 0 1-.66-.37 1.37 1.37 0 0 1-.39-.46 1.21 1.21 0 0 1-.13-.52 1.67 1.67 0 0 1 .07-.54.16.16 0 0 1 .09-.09.15.15 0 0 1 .13 0l.47.18a.21.21 0 0 1 .08.06.23.23 0 0 1 0 .11.7.7 0 0 0 0 .25.79.79 0 0 0 .08.26 1 1 0 0 0 .19.22 1.29 1.29 0 0 0 .33.18.84.84 0 0 0 .69 0 .86.86 0 0 0 .44-.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "351.217px 66.1651px"
    },
    id: "el12bhvdosh6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.4 66.36a.2.2 0 0 1 .09.09.19.19 0 0 1 0 .13l-.92 2.36a2.06 2.06 0 0 1-.35.6 1.42 1.42 0 0 1-.5.38 1.66 1.66 0 0 1-.64.12 2.23 2.23 0 0 1-.76-.17 2.3 2.3 0 0 1-.68-.39 1.37 1.37 0 0 1-.39-.52 1.26 1.26 0 0 1-.12-.61 2 2 0 0 1 .15-.69l.91-2.36a.2.2 0 0 1 .09-.09.13.13 0 0 1 .12 0l.47.18a.14.14 0 0 1 .09.08.2.2 0 0 1 0 .13l-.9 2.33a1.06 1.06 0 0 0-.1.43.74.74 0 0 0 .08.34.76.76 0 0 0 .21.27 1.74 1.74 0 0 0 .33.18 1.31 1.31 0 0 0 .38.09.76.76 0 0 0 .62-.25 1.15 1.15 0 0 0 .22-.38l.9-2.33a.19.19 0 0 1 .22-.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "355.315px 67.6177px"
    },
    id: "elwh1degx7qzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.82 71.1a.16.16 0 0 1 .09.09.17.17 0 0 1 0 .12l-.16.41a.18.18 0 0 1-.09.1.19.19 0 0 1-.13 0l-2.52-1a.2.2 0 0 1-.09-.09.15.15 0 0 1 0-.13l1.43-3.72a.19.19 0 0 1 .22-.1l.43.22a.18.18 0 0 1 .1.09.15.15 0 0 1 0 .13l-1.22 3.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "358.413px 69.3025px"
    },
    id: "el7bbwonky7x9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.27 69a.2.2 0 0 1 .09.09.15.15 0 0 1 0 .13L362 71.15l-.49 1.27a.16.16 0 0 1-.09.09.13.13 0 0 1-.12 0l-.46-.18a.16.16 0 0 1-.1-.08.28.28 0 0 1 0-.13l.49-1.27-.44-2.93a.16.16 0 0 1 .09-.09.2.2 0 0 1 .13 0l.43.17a.24.24 0 0 1 .15.12.54.54 0 0 1 0 .12l.3 2 1.56-1.27a.21.21 0 0 1 .1-.06.27.27 0 0 1 .2 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "362.554px 70.1719px"
    },
    id: "elf72q845yjy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24 65.56a.9.9 0 0 0 .63 1.1l4.53 1.75a.82.82 0 1 0 .58-1.49l-4.53-1.75a.91.91 0 0 0-1.21.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "330.445px 66.813px"
    },
    id: "eldsxm0zp2mf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.88 68.51a.91.91 0 0 0 .63 1.1l4.54 1.75a.9.9 0 0 0 1.21-.39.91.91 0 0 0-.64-1.1l-4.53-1.75a.91.91 0 0 0-1.21.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "338.07px 69.7417px"
    },
    id: "eliselmox2lx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.53 71.46a.91.91 0 0 0 .63 1.11l4.53 1.75a.82.82 0 1 0 .58-1.5l-4.53-1.75a.91.91 0 0 0-1.21.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "345.725px 72.7114px"
    },
    id: "elx64ehpr9rnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.17 74.41a.92.92 0 0 0 .63 1.11l4.54 1.75a.91.91 0 0 0 1.21-.39.92.92 0 0 0-.64-1.11L351.38 74a.92.92 0 0 0-1.21.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "353.36px 75.6386px"
    },
    id: "elwbwntpnsyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.82 77.37a.91.91 0 0 0 .63 1.1l4.55 1.75a.82.82 0 1 0 .58-1.49L359 77a.91.91 0 0 0-1.18.37Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "361.036px 78.6366px"
    },
    id: "el37t2aqmercm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.46 80.32a.91.91 0 0 0 .64 1.1l4.53 1.75a.82.82 0 1 0 .58-1.49l-4.54-1.75a.91.91 0 0 0-1.21.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "368.671px 81.573px"
    },
    id: "elw2io0dltxjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.11 83.27a.9.9 0 0 0 .63 1.1l4.53 1.75a.82.82 0 1 0 .58-1.49l-4.53-1.75a.91.91 0 0 0-1.21.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "376.315px 84.523px"
    },
    id: "elcrv7j5flchj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "347.871px 89.8531px"
    },
    className: "animable",
    id: "el91fzb53lce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.54 110.82a.36.36 0 0 1-.12-.33l8.09-20.94c0-.09.14-.08.24 0a.37.37 0 0 1 .11.34l-8.08 20.94c-.04.09-.14.09-.24-.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "374.641px 100.191px"
    },
    id: "elc40v1qtzt15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89 107.87a.38.38 0 0 1-.12-.34l8.09-20.94c0-.08.14-.08.24 0a.33.33 0 0 1 .11.33l-8.08 20.94c-.04.14-.13.14-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "366.992px 97.2481px"
    },
    id: "elnr91ipnws1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24 104.92a.35.35 0 0 1-.11-.34l8.08-20.94c0-.09.14-.08.24 0a.36.36 0 0 1 .12.33l-8.09 20.94c-.03.09-.14.09-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "359.348px 94.2775px"
    },
    id: "eldw64u2gp4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59 102a.33.33 0 0 1-.11-.33l8.08-20.94c0-.09.14-.08.24 0a.38.38 0 0 1 .12.34L347.83 102c-.03.06-.14.06-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "351.698px 91.3556px"
    },
    id: "elybr0kvrtzje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.94 99c-.09-.1-.15-.25-.11-.33l8.08-21c0-.08.14-.08.24 0a.36.36 0 0 1 .12.33l-8.09 21c-.03.11-.18.1-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "344.046px 88.3444px"
    },
    id: "elf9h26dne3ga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.3 96.06a.38.38 0 0 1-.12-.34l8.09-20.94c0-.09.14-.08.23 0a.36.36 0 0 1 .12.33l-8.09 20.94c-.03.11-.14.1-.23.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "336.4px 85.4231px"
    },
    id: "elu7ga0r5hnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.65 93.1a.36.36 0 0 1-.12-.33l8.09-20.94c0-.09.14-.08.24 0a.37.37 0 0 1 .11.34l-8.08 20.94c-.04.09-.15.09-.24-.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "328.751px 82.4712px"
    },
    id: "elu6nzancgv58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 90.15a.37.37 0 0 1-.12-.33L325 68.87c0-.08.14-.08.24 0a.35.35 0 0 1 .11.33l-8.08 20.94c-.07.11-.17.1-.27.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "321.116px 79.515px"
    },
    id: "eli5s0chn6uej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06 74.44a.4.4 0 0 1-.12-.23c0-.12.05-.19.15-.15l53.54 20.67a.41.41 0 0 1 .22.3c0 .12-.05.19-.15.15l-53.54-20.67a.3.3 0 0 1-.1-.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "349.895px 84.62px"
    },
    id: "el21vnnsvf0d6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 79.68a.43.43 0 0 1-.12-.23c0-.13.05-.2.15-.16L374.61 100a.41.41 0 0 1 .22.29c0 .13-.05.2-.15.16l-53.54-20.71a.21.21 0 0 1-.14-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "347.855px 89.87px"
    },
    id: "elsq76667eyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 84.91a.4.4 0 0 1-.12-.23c0-.12 0-.19.15-.15l53.54 20.67a.38.38 0 0 1 .21.3c0 .12 0 .19-.14.15L319.12 85a.23.23 0 0 1-.12-.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "345.83px 95.09px"
    },
    id: "elz1hcl9o6jck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 90.15a.44.44 0 0 1-.08-.11.27.27 0 0 1 0-.22L325 68.87c0-.05.07-.07.14-.05l53.51 20.68a.36.36 0 0 1 .18.17.32.32 0 0 1 0 .23l-8.08 20.94a.12.12 0 0 1-.15 0l-53.5-20.63a.21.21 0 0 1-.1-.06Zm8.29-20.84-8 20.58 53.12 20.51 7.94-20.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "347.874px 89.8393px"
    },
    id: "elo8pidrr65ca",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "347.871px 89.8531px"
    },
    className: "animable",
    id: "el4og4prxz63x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.54 110.82a.36.36 0 0 1-.12-.33l8.09-20.94c0-.09.14-.08.24 0a.37.37 0 0 1 .11.34l-8.08 20.94c-.04.09-.14.09-.24-.01Z",
    id: "el15f7nhmn9w9h",
    className: "animable",
    style: {
      transformOrigin: "374.641px 100.191px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89 107.87a.38.38 0 0 1-.12-.34l8.09-20.94c0-.08.14-.08.24 0a.33.33 0 0 1 .11.33l-8.08 20.94c-.04.14-.13.14-.24.01Z",
    id: "elsy1nytnrmi8",
    className: "animable",
    style: {
      transformOrigin: "366.992px 97.2481px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24 104.92a.35.35 0 0 1-.11-.34l8.08-20.94c0-.09.14-.08.24 0a.36.36 0 0 1 .12.33l-8.09 20.94c-.03.09-.14.09-.24.01Z",
    id: "elcq5j0qu3b7i",
    className: "animable",
    style: {
      transformOrigin: "359.348px 94.2775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59 102a.33.33 0 0 1-.11-.33l8.08-20.94c0-.09.14-.08.24 0a.38.38 0 0 1 .12.34L347.83 102c-.03.06-.14.06-.24 0Z",
    id: "eljt8mzft20ir",
    className: "animable",
    style: {
      transformOrigin: "351.698px 91.3556px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.94 99c-.09-.1-.15-.25-.11-.33l8.08-21c0-.08.14-.08.24 0a.36.36 0 0 1 .12.33l-8.09 21c-.03.11-.18.1-.24 0Z",
    id: "elmlki3yjtdfm",
    className: "animable",
    style: {
      transformOrigin: "344.046px 88.3444px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.3 96.06a.38.38 0 0 1-.12-.34l8.09-20.94c0-.09.14-.08.23 0a.36.36 0 0 1 .12.33l-8.09 20.94c-.03.11-.14.1-.23.01Z",
    id: "elopepz6p9bp",
    className: "animable",
    style: {
      transformOrigin: "336.4px 85.4231px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.65 93.1a.36.36 0 0 1-.12-.33l8.09-20.94c0-.09.14-.08.24 0a.37.37 0 0 1 .11.34l-8.08 20.94c-.04.09-.15.09-.24-.01Z",
    id: "eljjy734galxc",
    className: "animable",
    style: {
      transformOrigin: "328.751px 82.4712px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 90.15a.37.37 0 0 1-.12-.33L325 68.87c0-.08.14-.08.24 0a.35.35 0 0 1 .11.33l-8.08 20.94c-.07.11-.17.1-.27.01Z",
    id: "eljd83hlclyx9",
    className: "animable",
    style: {
      transformOrigin: "321.116px 79.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06 74.44a.4.4 0 0 1-.12-.23c0-.12.05-.19.15-.15l53.54 20.67a.41.41 0 0 1 .22.3c0 .12-.05.19-.15.15l-53.54-20.67a.3.3 0 0 1-.1-.07Z",
    id: "eluolqee2yfpn",
    className: "animable",
    style: {
      transformOrigin: "349.895px 84.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 79.68a.43.43 0 0 1-.12-.23c0-.13.05-.2.15-.16L374.61 100a.41.41 0 0 1 .22.29c0 .13-.05.2-.15.16l-53.54-20.71a.21.21 0 0 1-.14-.06Z",
    id: "elwzpbn760vcb",
    className: "animable",
    style: {
      transformOrigin: "347.855px 89.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 84.91a.4.4 0 0 1-.12-.23c0-.12 0-.19.15-.15l53.54 20.67a.38.38 0 0 1 .21.3c0 .12 0 .19-.14.15L319.12 85a.23.23 0 0 1-.12-.09Z",
    id: "el7ber8jm9yvy",
    className: "animable",
    style: {
      transformOrigin: "345.83px 95.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 90.15a.44.44 0 0 1-.08-.11.27.27 0 0 1 0-.22L325 68.87c0-.05.07-.07.14-.05l53.51 20.68a.36.36 0 0 1 .18.17.32.32 0 0 1 0 .23l-8.08 20.94a.12.12 0 0 1-.15 0l-53.5-20.63a.21.21 0 0 1-.1-.06Zm8.29-20.84-8 20.58 53.12 20.51 7.94-20.58Z",
    id: "el7uxkcp1hfta",
    className: "animable",
    style: {
      transformOrigin: "347.874px 89.8393px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.72 86.54a7.87 7.87 0 0 0 3.47 1.33c1 .17 1.13.86.93 1.7s-.47 3.31 1 4.64a10.91 10.91 0 0 1-5.4-7.67Z",
    style: {
      opacity: 0.2,
      transformOrigin: "318.42px 90.375px"
    },
    className: "animable",
    id: "elggq0hq6n86p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4 83.93a2.68 2.68 0 0 0 1.47 3.54c1.16.64 2.47 1 2.32 2.57a4.26 4.26 0 0 0 1.42 3.62 11.42 11.42 0 0 0 3.4 2c-4.4-1.7-5.39-2.45-7.14-4.87s-2.35-4.58-1.47-6.86Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "319.504px 89.795px"
    },
    id: "el119qc08e4uz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4 83.93a2.68 2.68 0 0 0 1.47 3.54c1.16.64 2.47 1 2.32 2.57a4.26 4.26 0 0 0 1.42 3.62 11.42 11.42 0 0 0 3.4 2c-4.4-1.7-5.39-2.45-7.14-4.87s-2.35-4.58-1.47-6.86Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "319.504px 89.795px"
    },
    className: "animable",
    id: "elceytz7ib6q5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.31 85.28-13.14 3.8a.72.72 0 0 0-.39.31.49.49 0 0 0 0 .11v.11a.49.49 0 0 0 0 .24l.73 2.54 4.32 15Z",
    style: {
      opacity: 0.2,
      transformOrigin: "377.538px 96.335px"
    },
    className: "animable",
    id: "el8a448piup3y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.17 110.92c-.06.3-.14.61-.21.92v.08a31.22 31.22 0 0 1-2.07 6.28 3.58 3.58 0 0 1-.24.48 7.57 7.57 0 0 1-3.95 3.84 2.42 2.42 0 0 1-.35.12l-48.88 14.16a.62.62 0 0 1-.79-.4l-13.19-45.59a.63.63 0 0 1 .46-.76l60.94-17.67a.63.63 0 0 1 .79.4l7.4 25.58c0 .13.07.25.1.37 1.17 4.27 1.02 7.63-.01 12.19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "408.737px 104.591px"
    },
    id: "el8318a8wz5sl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.17 110.92c-.06.3-.14.61-.21.92v.08a31.22 31.22 0 0 1-2.07 6.28 3.58 3.58 0 0 1-.24.48 7.57 7.57 0 0 1-3.95 3.84 2.42 2.42 0 0 1-.35.12l-48.88 14.16a.62.62 0 0 1-.79-.4l-13.19-45.59a.63.63 0 0 1 .46-.76l60.94-17.67a.63.63 0 0 1 .79.4l7.4 25.58c0 .13.07.25.1.37 1.17 4.27 1.02 7.63-.01 12.19Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "408.737px 104.591px"
    },
    className: "animable",
    id: "eluc6hu4ld0tn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.57 79.32-62.19 18-1.89-6.54a.59.59 0 0 1 .06-.45.67.67 0 0 1 .4-.31l60.94-17.66a.64.64 0 0 1 .75.29.64.64 0 0 1 0 .07l.13.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "405.52px 84.8247px"
    },
    id: "elhpze2k4gmip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.57 79.32-62.19 18-1.89-6.54a.59.59 0 0 1 .06-.45.67.67 0 0 1 .4-.31l60.94-17.66a.64.64 0 0 1 .75.29.64.64 0 0 1 0 .07l.13.43Z",
    style: {
      opacity: 0.2,
      transformOrigin: "405.52px 84.8247px"
    },
    className: "animable",
    id: "el1zxhvgb0eei"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.41 91.69a1.24 1.24 0 0 1 2.35-.68 1.24 1.24 0 0 1-2.35.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "380.585px 91.35px"
    },
    id: "el649xusqdsnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.63 89.31a1.16 1.16 0 0 1 .88-1.36 1.07 1.07 0 1 1-.88 1.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "388.667px 89.0098px"
    },
    id: "el2cnue7nrqk6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.84 86.93a1.24 1.24 0 1 1 1.47.67 1.15 1.15 0 0 1-1.47-.67Z",
    style: {
      fill: "#263238",
      transformOrigin: "396.965px 86.4195px"
    },
    id: "elws0o8bf6clo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27 82.17a1.23 1.23 0 1 1 1.46.67 1.14 1.14 0 0 1-1.46-.67Z",
    style: {
      fill: "#263238",
      transformOrigin: "413.389px 81.669px"
    },
    id: "elrwr94qs6f8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.49 79.78a1.23 1.23 0 0 1 2.34-.68 1.16 1.16 0 0 1-.88 1.36 1.14 1.14 0 0 1-1.46-.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "421.665px 79.4502px"
    },
    id: "el4shwye0bkbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.64 77.5a1.24 1.24 0 1 1 1.47.68 1.16 1.16 0 0 1-1.47-.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "429.769px 76.997px"
    },
    id: "eltskhnc956",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "407.59px 92.17px",
      transform: "rotate(-16.14deg)"
    },
    className: "animable",
    d: "M375.22 88.16h64.74v8.02h-64.74z",
    id: "eldykzcqw4eh9"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "407.59px 92.17px"
    },
    className: "animable",
    id: "elyo3hflhyuy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "407.59px 92.17px",
      transform: "rotate(-16.2602deg)"
    },
    className: "animable",
    d: "M375.22 88.16h64.74v8.02h-64.74z",
    id: "elemw4ddqitbw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.64 92.84a.19.19 0 0 1 .15 0 .4.4 0 0 1 .13.13l2.54 3.33a.17.17 0 0 1 0 .12.14.14 0 0 1-.1.08l-.42.13a.27.27 0 0 1-.18 0 .49.49 0 0 1-.1-.08l-.44-.59-1.87.54-.07.74a.19.19 0 0 1 0 .11s-.07.08-.15.1l-.42.13a.19.19 0 0 1-.13 0 .16.16 0 0 1-.08-.1l.37-4.17a.39.39 0 0 1 0-.17.17.17 0 0 1 .13-.14Zm1.08 2.5-1.14-1.5-.17 1.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "398.485px 95.208px"
    },
    id: "elappsks88iwu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 91.29a.16.16 0 0 1 .21.11l.7 2.43a2 2 0 0 1 .09.7 1.35 1.35 0 0 1-.17.6 1.43 1.43 0 0 1-.44.48 2.22 2.22 0 0 1-.71.33 2 2 0 0 1-.77.1 1.4 1.4 0 0 1-.63-.17 1.32 1.32 0 0 1-.46-.42 2 2 0 0 1-.3-.63l-.7-2.43a.15.15 0 0 1 0-.13.16.16 0 0 1 .1-.08l.48-.14a.15.15 0 0 1 .13 0 .13.13 0 0 1 .07.09l.7 2.41a1.18 1.18 0 0 0 .19.39.71.71 0 0 0 .26.23.73.73 0 0 0 .33.08 1.31 1.31 0 0 0 .38-.06 1.23 1.23 0 0 0 .35-.15.82.82 0 0 0 .24-.25.68.68 0 0 0 .1-.33 1 1 0 0 0-.05-.44l-.69-2.4a.13.13 0 0 1 0-.12.13.13 0 0 1 .1-.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "401.904px 93.6623px"
    },
    id: "elzcxk1zyodwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.32 92.56a1.82 1.82 0 0 1-.05-.69 1.41 1.41 0 0 1 .19-.6 1.77 1.77 0 0 1 .46-.49 2.3 2.3 0 0 1 .74-.33 2.52 2.52 0 0 1 .89-.12 1.81 1.81 0 0 1 .62.17 1.25 1.25 0 0 1 .39.3 1.23 1.23 0 0 1 .19.31.15.15 0 0 1 0 .13.19.19 0 0 1-.1.08l-.48.14a.24.24 0 0 1-.12 0l-.05-.06-.09-.08a.53.53 0 0 0-.21-.12 1 1 0 0 0-.34-.07 1.35 1.35 0 0 0-.46.06 1 1 0 0 0-.64.44 1 1 0 0 0-.1.73l.13.49q.08.25.15.48a1 1 0 0 0 .49.63 1.15 1.15 0 0 0 .78 0 1.38 1.38 0 0 0 .39-.16.93.93 0 0 0 .27-.25.73.73 0 0 0 .13-.34 1.24 1.24 0 0 0-.05-.45l-.72.21a.15.15 0 0 1-.13 0 .2.2 0 0 1-.08-.1l-.12-.42a.15.15 0 0 1 0-.13.14.14 0 0 1 .09-.08l1.37-.39a.13.13 0 0 1 .12 0 .16.16 0 0 1 .08.1l.19.65a1.86 1.86 0 0 1 .08.69 1.41 1.41 0 0 1-.19.61 1.56 1.56 0 0 1-.46.5 2.32 2.32 0 0 1-.76.35 2.22 2.22 0 0 1-.81.11 1.49 1.49 0 0 1-.65-.17 1.38 1.38 0 0 1-.48-.42 2 2 0 0 1-.32-.61c0-.08-.05-.16-.08-.25a2.29 2.29 0 0 1-.08-.28c0-.09-.06-.19-.08-.28s-.08-.21-.1-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "406.296px 92.5951px"
    },
    id: "elwnoh76chhin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.42 88.84a.16.16 0 0 1 .21.11l.71 2.43a1.94 1.94 0 0 1 .08.7 1.35 1.35 0 0 1-.17.6 1.43 1.43 0 0 1-.44.48 2.13 2.13 0 0 1-.71.33 2 2 0 0 1-.77.1 1.48 1.48 0 0 1-.63-.17 1.32 1.32 0 0 1-.46-.42 2 2 0 0 1-.3-.63l-.7-2.43a.19.19 0 0 1 0-.13.16.16 0 0 1 .1-.08l.48-.14a.15.15 0 0 1 .13 0 .18.18 0 0 1 .08.09l.69 2.41a1.18 1.18 0 0 0 .19.39.71.71 0 0 0 .26.23.73.73 0 0 0 .33.08 1.31 1.31 0 0 0 .38-.06 1.6 1.6 0 0 0 .35-.15.82.82 0 0 0 .24-.25.8.8 0 0 0 .11-.33 1.22 1.22 0 0 0-.06-.44l-.69-2.4a.13.13 0 0 1 0-.12.15.15 0 0 1 .17-.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "410.327px 91.2123px"
    },
    id: "elg24ncdp9red",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.88 88.06a2 2 0 0 1 .73-.09 1.61 1.61 0 0 1 .58.12 1.07 1.07 0 0 1 .41.26.91.91 0 0 1 .22.33.12.12 0 0 1 0 .13.16.16 0 0 1-.1.08l-.41.12a.24.24 0 0 1-.17 0 .37.37 0 0 1-.12-.07.74.74 0 0 0-.34-.18 1.05 1.05 0 0 0-.57 0 1.26 1.26 0 0 0-.29.12.87.87 0 0 0-.21.17.44.44 0 0 0-.12.19.41.41 0 0 0 0 .22.53.53 0 0 0 .12.21.44.44 0 0 0 .23.09 2.18 2.18 0 0 0 .39 0h.58a5 5 0 0 1 .67 0 1.67 1.67 0 0 1 .49.13 1.13 1.13 0 0 1 .34.27 1 1 0 0 1 .2.41 1.07 1.07 0 0 1-.2 1 1.71 1.71 0 0 1-.46.42 2.57 2.57 0 0 1-.69.3 2.16 2.16 0 0 1-.66.1 2 2 0 0 1-.6-.07 1.4 1.4 0 0 1-.48-.26.91.91 0 0 1-.3-.42.15.15 0 0 1 0-.13.18.18 0 0 1 .11-.08l.41-.12a.3.3 0 0 1 .16 0 .2.2 0 0 1 .12.08l.15.13a.53.53 0 0 0 .2.09 1.19 1.19 0 0 0 .28 0 1.7 1.7 0 0 0 .39-.07 1.89 1.89 0 0 0 .33-.13.89.89 0 0 0 .27-.17.58.58 0 0 0 .15-.21.31.31 0 0 0 0-.25.28.28 0 0 0-.14-.19.73.73 0 0 0-.29-.07 3.71 3.71 0 0 0-.46 0h-.61a3.45 3.45 0 0 1-.57 0 1.36 1.36 0 0 1-.43-.13 1 1 0 0 1-.32-.28 1.39 1.39 0 0 1-.2-.44 1 1 0 0 1 0-.52 1.09 1.09 0 0 1 .21-.48 1.79 1.79 0 0 1 .42-.4 2.46 2.46 0 0 1 .58-.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "414.597px 90.1787px"
    },
    id: "elgcpzc590gqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 86.63a.17.17 0 0 1 .12 0 .14.14 0 0 1 .08.1l.12.42a.13.13 0 0 1 0 .12.16.16 0 0 1-.1.08l-1.07.31.95 3.25a.2.2 0 0 1 0 .13.14.14 0 0 1-.1.08l-.48.14a.21.21 0 0 1-.13 0 .15.15 0 0 1-.07-.1l-.95-3.25-1.06.31a.15.15 0 0 1-.13 0 .16.16 0 0 1-.08-.1l-.12-.42a.2.2 0 0 1 0-.13.25.25 0 0 1 .1-.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "417.652px 88.9447px"
    },
    id: "el6vh96uhuyug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 107.65a.9.9 0 0 0 1.17.49l4.67-1.35a.82.82 0 1 0-.45-1.54l-4.66 1.36a.9.9 0 0 0-.73 1.04Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "386.292px 106.679px"
    },
    id: "elv8vtsndt009",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82 105.37a.91.91 0 0 0 1.17.49l4.67-1.35a.82.82 0 1 0-.45-1.54l-4.66 1.35a.91.91 0 0 0-.73 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "394.112px 104.398px"
    },
    id: "el7tf1bqgrrxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69 103.09a.92.92 0 0 0 1.17.49l4.67-1.35a.82.82 0 1 0-.45-1.54l-4.66 1.31a.91.91 0 0 0-.73 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "401.979px 102.116px"
    },
    id: "eld6xjk8n57z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.56 100.8a.91.91 0 0 0 1.17.5l4.67-1.3a.82.82 0 1 0-.44-1.54l-4.67 1.35a.92.92 0 0 0-.73.99Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "409.863px 99.8616px"
    },
    id: "els2t3nvhx96j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.44 98.52a.9.9 0 0 0 1.17.5l4.66-1.35a.92.92 0 0 0 .73-1 .91.91 0 0 0-1.17-.49l-4.67 1.35a.9.9 0 0 0-.72.99Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "417.719px 97.6008px"
    },
    id: "elfjjmp08xftq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.31 96.24a.9.9 0 0 0 1.17.49l4.66-1.35a.82.82 0 1 0-.44-1.54L423 95.2a.9.9 0 0 0-.69 1.04Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "425.602px 95.2688px"
    },
    id: "el3wn5bktk6vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.18 94a.91.91 0 0 0 1.17.49L436 93.1a.82.82 0 1 0-.45-1.54l-4.67 1.35a.92.92 0 0 0-.7 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "433.459px 93.0077px"
    },
    id: "elcdqa66h9um6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "413.16px 114.521px"
    },
    className: "animable",
    id: "elip2ot36phjn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.17 110.92c-.06.3-.14.61-.21.92l-1.19-4.11L438.36 96l-.08-.29a.09.09 0 0 1 0-.11h.19a.17.17 0 0 1 .1 0l.08.05a.18.18 0 0 1 .07.09l3.35 11.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "440.716px 103.716px"
    },
    id: "el4q624ymcxgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 119.72a.37.37 0 0 1-.3-.19L430.4 98c0-.09.06-.15.2-.14a.35.35 0 0 1 .29.2l6.25 21.56c.03.06-.06.12-.14.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "433.773px 108.791px"
    },
    id: "elym8lxexw9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.07 122a.32.32 0 0 1-.29-.19l-6.25-21.56c0-.09.06-.15.2-.13a.35.35 0 0 1 .29.19l6.25 21.56c.03.13-.06.13-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "425.903px 111.058px"
    },
    id: "elzdrjj6vqvrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 124.29a.38.38 0 0 1-.3-.2l-6.25-21.56c0-.09.06-.15.2-.13s.27.1.29.19l6.25 21.56c.03.09-.06.15-.19.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.023px 113.344px"
    },
    id: "el9lzueqnqpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32 126.57c-.13 0-.27-.11-.29-.2l-6.25-21.56c0-.09.06-.15.2-.13a.38.38 0 0 1 .29.2l6.25 21.56c.03.09-.06.15-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "410.153px 115.625px"
    },
    id: "el3ci49vlqltg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45 128.85a.37.37 0 0 1-.3-.19l-6.25-21.56c0-.09.07-.15.2-.14a.38.38 0 0 1 .3.2l6.25 21.56c.02.09-.07.15-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "402.276px 117.906px"
    },
    id: "el5nqtilc4cu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.57 131.13a.34.34 0 0 1-.29-.19L391 109.38c0-.09.06-.15.2-.13a.35.35 0 0 1 .29.19l6.28 21.56c.03.09-.06.15-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "394.388px 120.19px"
    },
    id: "eljtwvvy4dew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.7 133.42a.38.38 0 0 1-.3-.2l-6.25-21.56c0-.09.07-.15.2-.13a.37.37 0 0 1 .3.19l6.25 21.56c.02.1-.07.15-.2.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "386.526px 122.474px"
    },
    id: "elw58501zkzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 117.25a.41.41 0 0 1-.24-.11c-.09-.09-.08-.18 0-.21l55.12-16a.4.4 0 0 1 .35.1c.1.09.08.18 0 .21l-55.12 16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "412.497px 109.086px"
    },
    id: "elyeqb3wrlyts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.57 122.64a.48.48 0 0 1-.24-.11c-.09-.09-.08-.18 0-.21l55.12-16a.41.41 0 0 1 .36.1c.09.09.08.18 0 .21l-55.12 16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "414.07px 114.476px"
    },
    id: "elh1qanzba7wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 111.74a.36.36 0 0 1 0 .1v.08l-.06.26-4.94 1.42-49.75 14.4h-.12a.48.48 0 0 1-.23-.1c-.1-.09-.08-.19 0-.22l49.89-14.46Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "415.418px 119.87px"
    },
    id: "el4jzrneayac6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.12 107.28-3.35-11.54a.18.18 0 0 0-.07-.09l-.08-.05a.17.17 0 0 0-.1 0h-.19l-55.08 16a.1.1 0 0 0-.08.13l6.25 21.56a.3.3 0 0 0 .17.16h.24l49.1-14.23 1.72-.5a3.58 3.58 0 0 0 .24-.48l-1.91.55L389.81 133l-6.14-21.18L438.36 96l3.41 11.76 1.19 4.11c.07-.31.15-.62.21-.92Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "413.168px 114.521px"
    },
    id: "eljndlyjbipv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "413.16px 114.521px"
    },
    className: "animable",
    id: "el991ae2fclvv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.17 110.92c-.06.3-.14.61-.21.92l-1.19-4.11L438.36 96l-.08-.29a.09.09 0 0 1 0-.11h.19a.17.17 0 0 1 .1 0l.08.05a.18.18 0 0 1 .07.09l3.35 11.54Z",
    id: "eld1ffp0xwjcu",
    className: "animable",
    style: {
      transformOrigin: "440.716px 103.716px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 119.72a.37.37 0 0 1-.3-.19L430.4 98c0-.09.06-.15.2-.14a.35.35 0 0 1 .29.2l6.25 21.56c.03.06-.06.12-.14.1Z",
    id: "elxyjglub44ps",
    className: "animable",
    style: {
      transformOrigin: "433.773px 108.791px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.07 122a.32.32 0 0 1-.29-.19l-6.25-21.56c0-.09.06-.15.2-.13a.35.35 0 0 1 .29.19l6.25 21.56c.03.13-.06.13-.2.13Z",
    id: "elyb2m0idzep",
    className: "animable",
    style: {
      transformOrigin: "425.903px 111.058px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 124.29a.38.38 0 0 1-.3-.2l-6.25-21.56c0-.09.06-.15.2-.13s.27.1.29.19l6.25 21.56c.03.09-.06.15-.19.14Z",
    id: "eldgb7ejyjxg9",
    className: "animable",
    style: {
      transformOrigin: "418.023px 113.344px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32 126.57c-.13 0-.27-.11-.29-.2l-6.25-21.56c0-.09.06-.15.2-.13a.38.38 0 0 1 .29.2l6.25 21.56c.03.09-.06.15-.2.13Z",
    id: "elw8q1x479k8r",
    className: "animable",
    style: {
      transformOrigin: "410.153px 115.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45 128.85a.37.37 0 0 1-.3-.19l-6.25-21.56c0-.09.07-.15.2-.14a.38.38 0 0 1 .3.2l6.25 21.56c.02.09-.07.15-.2.13Z",
    id: "el7x9hh9w24l",
    className: "animable",
    style: {
      transformOrigin: "402.276px 117.906px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.57 131.13a.34.34 0 0 1-.29-.19L391 109.38c0-.09.06-.15.2-.13a.35.35 0 0 1 .29.19l6.28 21.56c.03.09-.06.15-.2.13Z",
    id: "el5s0pnq6x5cg",
    className: "animable",
    style: {
      transformOrigin: "394.388px 120.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.7 133.42a.38.38 0 0 1-.3-.2l-6.25-21.56c0-.09.07-.15.2-.13a.37.37 0 0 1 .3.19l6.25 21.56c.02.1-.07.15-.2.14Z",
    id: "elit7beimdykc",
    className: "animable",
    style: {
      transformOrigin: "386.526px 122.474px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 117.25a.41.41 0 0 1-.24-.11c-.09-.09-.08-.18 0-.21l55.12-16a.4.4 0 0 1 .35.1c.1.09.08.18 0 .21l-55.12 16Z",
    id: "elvl0l2guey",
    className: "animable",
    style: {
      transformOrigin: "412.497px 109.086px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.57 122.64a.48.48 0 0 1-.24-.11c-.09-.09-.08-.18 0-.21l55.12-16a.41.41 0 0 1 .36.1c.09.09.08.18 0 .21l-55.12 16Z",
    id: "elu8xh9buxf2",
    className: "animable",
    style: {
      transformOrigin: "414.07px 114.476px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 111.74a.36.36 0 0 1 0 .1v.08l-.06.26-4.94 1.42-49.75 14.4h-.12a.48.48 0 0 1-.23-.1c-.1-.09-.08-.19 0-.22l49.89-14.46Z",
    id: "elbc8dltaic9u",
    className: "animable",
    style: {
      transformOrigin: "415.418px 119.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.12 107.28-3.35-11.54a.18.18 0 0 0-.07-.09l-.08-.05a.17.17 0 0 0-.1 0h-.19l-55.08 16a.1.1 0 0 0-.08.13l6.25 21.56a.3.3 0 0 0 .17.16h.24l49.1-14.23 1.72-.5a3.58 3.58 0 0 0 .24-.48l-1.91.55L389.81 133l-6.14-21.18L438.36 96l3.41 11.76 1.19 4.11c.07-.31.15-.62.21-.92Z",
    id: "el3m7m226oel9",
    className: "animable",
    style: {
      transformOrigin: "413.168px 114.521px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.69 106.33c-.6 1.42-3.52 3.22-5.31 4.17s-.9 2.21-.23 3.34 2.43 5.81.76 7.77c0 0 1.58-.58 2.81-4.1s1.97-11.18 1.97-11.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "439.508px 113.97px"
    },
    className: "animable",
    id: "elbjxq0a36b04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08 98.36c.65 2.24.72 6.33-.73 8.6s-4.38 3.69-4.78 4.76.82 1.62 1.32 5c.36 2.38-.18 5.23-2.56 5.92 4-1.16 5.58-6.41 6.61-10.72 1.26-5.22 1.51-8.83.14-13.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "440.166px 110.5px"
    },
    id: "el68jeaneupe7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08 98.36c.65 2.24.72 6.33-.73 8.6s-4.38 3.69-4.78 4.76.82 1.62 1.32 5c.36 2.38-.18 5.23-2.56 5.92 4-1.16 5.58-6.41 6.61-10.72 1.26-5.22 1.51-8.83.14-13.56Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "440.166px 110.5px"
    },
    className: "animable",
    id: "el2x3fwkc9hmx"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "428.856px 197.956px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.83 226.13c-1.27 2.47-2.66 4.44-6 5.37h-.14L428 245.11a.63.63 0 0 1-.78-.42l-11.8-46a.63.63 0 0 1 .48-.75l61.44-15.82a.64.64 0 0 1 .79.43l9.34 36.45a.13.13 0 0 1 0 .06 8.83 8.83 0 0 1-.64 7.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "451.667px 213.615px"
    },
    id: "elixk8t2px7pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.83 226.13c-1.27 2.47-2.66 4.44-6 5.37h-.14L428 245.11a.63.63 0 0 1-.78-.42l-11.8-46a.63.63 0 0 1 .48-.75l61.44-15.82a.64.64 0 0 1 .79.43l9.34 36.45a.13.13 0 0 1 0 .06 8.83 8.83 0 0 1-.64 7.07Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "451.667px 213.615px"
    },
    className: "animable",
    id: "el5lk2yqcl9is"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.81 189.17-62.71 16.14-1.69-6.59a.58.58 0 0 1 .07-.45.71.71 0 0 1 .41-.3l61.45-15.81a.64.64 0 0 1 .74.32v.07l.11.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "447.601px 193.723px"
    },
    id: "elydrrjv6xjgt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.81 189.17-62.71 16.14-1.69-6.59a.58.58 0 0 1 .07-.45.71.71 0 0 1 .41-.3l61.45-15.81a.64.64 0 0 1 .74.32v.07l.11.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "447.601px 193.723px"
    },
    className: "animable",
    id: "elqdhzzq7ysrl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.3 199.77a1.24 1.24 0 0 1 2.37-.6 1.23 1.23 0 0 1-2.37.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "422.489px 199.5px"
    },
    id: "elxk4vowyqe3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59 197.64a1.24 1.24 0 1 1 1.45.72 1.16 1.16 0 0 1-1.45-.72Z",
    style: {
      fill: "#263238",
      transformOrigin: "430.733px 197.167px"
    },
    id: "elbmf37yhfu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.87 195.51a1.23 1.23 0 1 1 1.44.72 1.14 1.14 0 0 1-1.44-.72Z",
    style: {
      fill: "#263238",
      transformOrigin: "439.006px 195.048px"
    },
    id: "elqz1be7j0af",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.43 191.25a1.15 1.15 0 0 1 .92-1.33 1.07 1.07 0 1 1-.92 1.33Z",
    style: {
      fill: "#263238",
      transformOrigin: "455.474px 190.984px"
    },
    id: "eleckw7j22p6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.72 189.12a1.23 1.23 0 1 1 1.44.72 1.15 1.15 0 0 1-1.44-.72Z",
    style: {
      fill: "#263238",
      transformOrigin: "463.856px 188.657px"
    },
    id: "el8x202qx54is",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.94 187.08a1.23 1.23 0 1 1 1.44.72 1.14 1.14 0 0 1-1.44-.72Z",
    style: {
      fill: "#263238",
      transformOrigin: "472.076px 186.618px"
    },
    id: "ellvrfuhdm2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "449.45px 201.11px",
      transform: "rotate(-14.41deg)"
    },
    className: "animable",
    d: "M417.08 197.1h64.74v8.02h-64.74z",
    id: "el8sclxstgp2e"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "449.45px 201.11px"
    },
    className: "animable",
    id: "elvg8gwz32pe"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "449.45px 201.11px",
      transform: "rotate(-14.41deg)"
    },
    className: "animable",
    d: "M417.08 197.1h64.74v8.02h-64.74z",
    id: "elz1w7ke9x7up"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.06 204a2.44 2.44 0 0 1 0-.66 1.56 1.56 0 0 1 .19-.6 1.7 1.7 0 0 1 .45-.48 2.24 2.24 0 0 1 .73-.33 2.47 2.47 0 0 1 .79-.07 1.57 1.57 0 0 1 .63.21 1.71 1.71 0 0 1 .46.43 2.09 2.09 0 0 1 .29.6c0 .08.05.16.08.25l.07.28c0 .1 0 .2.07.29l.06.25a2.17 2.17 0 0 1 0 .67 1.37 1.37 0 0 1-.19.59 1.61 1.61 0 0 1-.45.49 2.34 2.34 0 0 1-.73.32 2.29 2.29 0 0 1-.8.07 1.57 1.57 0 0 1-.62-.21 1.35 1.35 0 0 1-.46-.43 2.16 2.16 0 0 1-.29-.59c0-.08 0-.16-.08-.25s-.05-.19-.07-.29a2.86 2.86 0 0 1-.07-.28Zm2.71-.66a1 1 0 0 0-.44-.6 1 1 0 0 0-.74-.06 1 1 0 0 0-.61.41 1 1 0 0 0-.1.74c0 .15.07.32.11.51s.1.35.15.5a1 1 0 0 0 .44.59 1 1 0 0 0 .74.06.91.91 0 0 0 .72-1.14c0-.15-.08-.32-.12-.51s-.1-.37-.15-.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "437.972px 204.086px"
    },
    id: "elxaf8q6zb47s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.26 203.51a.2.2 0 0 1 0-.13.13.13 0 0 1 .1-.06l.48-.13a.15.15 0 0 1 .13 0 .13.13 0 0 1 .07.1 1.81 1.81 0 0 1 0 .52 1.4 1.4 0 0 1-.21.53 1.82 1.82 0 0 1-.46.46 2.32 2.32 0 0 1-.76.33 2 2 0 0 1-.76.06 1.51 1.51 0 0 1-.63-.2 1.6 1.6 0 0 1-.47-.43 2.2 2.2 0 0 1-.32-.63c-.05-.15-.09-.31-.14-.5s-.09-.35-.12-.5a2.13 2.13 0 0 1 0-.71 1.82 1.82 0 0 1 .2-.61 1.7 1.7 0 0 1 .45-.48 2.59 2.59 0 0 1 1.53-.38 1.46 1.46 0 0 1 .62.18 1.2 1.2 0 0 1 .44.36 1.88 1.88 0 0 1 .25.46.15.15 0 0 1 0 .13.18.18 0 0 1-.1.07l-.49.13H443a.24.24 0 0 1-.1-.1.74.74 0 0 0-.14-.22.76.76 0 0 0-.23-.15 1 1 0 0 0-.33-.08 1.7 1.7 0 0 0-.42.05 1 1 0 0 0-.38.18.73.73 0 0 0-.24.26.76.76 0 0 0-.11.34 1.17 1.17 0 0 0 0 .37c0 .15.07.32.11.5s.1.35.15.5a1 1 0 0 0 .16.34.94.94 0 0 0 .25.24.76.76 0 0 0 .34.11 1.08 1.08 0 0 0 .43 0 1.38 1.38 0 0 0 .39-.16 1.09 1.09 0 0 0 .25-.22.67.67 0 0 0 .13-.25.76.76 0 0 0 0-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "442.1px 202.974px"
    },
    id: "elcv0qve0s3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.83 199.55a.17.17 0 0 1 .12 0 .16.16 0 0 1 .08.1l.11.43a.13.13 0 0 1 0 .12.16.16 0 0 1-.1.08l-1.08.27.85 3.28a.2.2 0 0 1 0 .13.14.14 0 0 1-.1.07l-.48.13a.19.19 0 0 1-.13 0 .16.16 0 0 1-.08-.1l-.84-3.28-1.08.28a.17.17 0 0 1-.12 0 .16.16 0 0 1-.08-.1l-.11-.43a.17.17 0 0 1 0-.12.16.16 0 0 1 .1-.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "445.467px 201.855px"
    },
    id: "elunqy9lfew5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.76 201a2.09 2.09 0 0 1 0-.66 1.41 1.41 0 0 1 .19-.6 1.57 1.57 0 0 1 .45-.48 2.15 2.15 0 0 1 .73-.33 2.21 2.21 0 0 1 .79-.07 1.52 1.52 0 0 1 1.09.64 2.38 2.38 0 0 1 .29.6c0 .08.05.16.07.25a2.29 2.29 0 0 1 .08.28c0 .1.05.19.07.29l.06.25a2.47 2.47 0 0 1 0 .66 1.51 1.51 0 0 1-.19.6 1.7 1.7 0 0 1-.45.48 2.34 2.34 0 0 1-.73.33 2.29 2.29 0 0 1-.8.07 1.62 1.62 0 0 1-.63-.21 1.42 1.42 0 0 1-.45-.43 1.86 1.86 0 0 1-.29-.6c0-.07-.05-.15-.08-.24s0-.19-.07-.29-.05-.19-.08-.28-.03-.21-.05-.26Zm2.71-.66a1 1 0 0 0-.45-.6 1 1 0 0 0-.73-.06 1 1 0 0 0-.61.41 1 1 0 0 0-.11.74c0 .15.08.32.12.5l.14.51a1 1 0 0 0 .45.59 1.13 1.13 0 0 0 1.35-.35.94.94 0 0 0 .1-.73q0-.24-.12-.51a4.39 4.39 0 0 0-.14-.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "449.668px 201.085px"
    },
    id: "el7y8sygeiq7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.9 202.45a.19.19 0 0 1-.13 0 .2.2 0 0 1-.08-.1l-1-3.86a.15.15 0 0 1 0-.13.14.14 0 0 1 .1-.07l1.76-.46a1.78 1.78 0 0 1 .67-.05 1.43 1.43 0 0 1 .49.19 1.12 1.12 0 0 1 .32.33 1.18 1.18 0 0 1 .17.36 1 1 0 0 1 0 .34.92.92 0 0 1-.05.26.75.75 0 0 1-.1.2.48.48 0 0 1-.08.12 1.38 1.38 0 0 1 .43.27 1.09 1.09 0 0 1 .3.54 1.27 1.27 0 0 1 0 .48 1.07 1.07 0 0 1-.14.46 1.2 1.2 0 0 1-.32.4 1.45 1.45 0 0 1-.53.25Zm1.53-3.57a.47.47 0 0 0-.23-.31.8.8 0 0 0-.49 0l-1 .28.23.92 1.06-.27a.75.75 0 0 0 .42-.24.41.41 0 0 0 .01-.38Zm-1.08 2.66 1.1-.29a.7.7 0 0 0 .45-.26.53.53 0 0 0 .06-.41.51.51 0 0 0-.26-.33.72.72 0 0 0-.51 0l-1.1.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "453.699px 200.115px"
    },
    id: "elt39xgtso4co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.42 200a.19.19 0 0 1 .13 0 .25.25 0 0 1 .08.1l.1.43a.13.13 0 0 1 0 .12.18.18 0 0 1-.11.08l-2.62.68a.17.17 0 0 1-.12 0 .19.19 0 0 1-.08-.1l-1-3.87a.13.13 0 0 1 0-.12.14.14 0 0 1 .1-.08l2.57-.66a.15.15 0 0 1 .13 0 .13.13 0 0 1 .07.1l.11.42a.15.15 0 0 1 0 .13.16.16 0 0 1-.1.08l-1.93.49.25 1 1.8-.46a.13.13 0 0 1 .12 0 .16.16 0 0 1 .08.1l.11.42a.19.19 0 0 1 0 .13.16.16 0 0 1-.1.08l-1.8.46.26 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "457.765px 198.993px"
    },
    id: "elkur0vbtmnjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.14 195.87a1.71 1.71 0 0 1 1.22 0 1.26 1.26 0 0 1 .64.86 1.36 1.36 0 0 1 0 .8 1.25 1.25 0 0 1-.47.61l1.21 1.26v.06a.21.21 0 0 1 0 .11.15.15 0 0 1-.09.06l-.51.13a.25.25 0 0 1-.19 0 .45.45 0 0 1-.1-.09l-1.14-1.19-.8.21.36 1.39a.15.15 0 0 1 0 .13.14.14 0 0 1-.1.07l-.48.13a.19.19 0 0 1-.13 0 .17.17 0 0 1-.07-.1l-1-3.86a.19.19 0 0 1 0-.13.16.16 0 0 1 .1-.08Zm-.41 2.11.87-.22a1.22 1.22 0 0 0 .51-.26.51.51 0 0 0 .08-.51.5.5 0 0 0-.31-.4 1.18 1.18 0 0 0-.58 0l-.86.22Z",
    style: {
      fill: "#455a64",
      transformOrigin: "461.613px 198.089px"
    },
    id: "elstxtpcmeihp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36 215.84a.91.91 0 0 0 1.15.53l4.71-1.21a.82.82 0 1 0-.4-1.56l-4.71 1.21a.92.92 0 0 0-.75 1.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "427.671px 214.971px"
    },
    id: "elxu9ap19p1kd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29 213.79a.91.91 0 0 0 1.16.53l4.7-1.21a.82.82 0 1 0-.39-1.55l-4.71 1.21a.91.91 0 0 0-.76 1.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "435.618px 212.922px"
    },
    id: "el15zl0n35ykg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.23 211.75a.91.91 0 0 0 1.16.53l4.7-1.21a.82.82 0 1 0-.4-1.55l-4.7 1.21a.9.9 0 0 0-.76 1.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "443.552px 210.882px"
    },
    id: "elt3h2rjq2jbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.17 209.71a.91.91 0 0 0 1.15.53L454 209a.82.82 0 1 0-.4-1.56l-4.71 1.21a.92.92 0 0 0-.72 1.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "451.463px 208.826px"
    },
    id: "eleq1pirrort8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.1 207.66a.91.91 0 0 0 1.16.53L462 207a.82.82 0 1 0-.39-1.55l-4.71 1.21a.91.91 0 0 0-.8 1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "459.449px 206.802px"
    },
    id: "elwesi6kxlm6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 205.62a.91.91 0 0 0 1.16.53l4.7-1.21a.82.82 0 1 0-.4-1.55l-4.7 1.21a.9.9 0 0 0-.76 1.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "467.322px 204.752px"
    },
    id: "elucpuq5umvhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 203.58a.91.91 0 0 0 1.15.53l4.71-1.21a.82.82 0 1 0-.4-1.56l-4.71 1.21a.92.92 0 0 0-.75 1.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "475.311px 202.711px"
    },
    id: "elqjsgtesv6xj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "455.276px 223.602px"
    },
    className: "animable",
    id: "elhb7rl1qg649"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.9 227.49a.37.37 0 0 1-.29-.21L480 205.55c0-.1.07-.15.2-.13a.35.35 0 0 1 .29.2l5.6 21.74c.04.09-.09.15-.19.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "483.049px 216.455px"
    },
    id: "elupdizcyk5tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 229.53a.35.35 0 0 1-.28-.2l-5.6-21.74c0-.09.07-.15.2-.13a.36.36 0 0 1 .29.21l5.6 21.74c-.02.09-.11.14-.21.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "475.165px 218.495px"
    },
    id: "ellzr1ru3yqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 231.58a.38.38 0 0 1-.28-.21l-5.6-21.74c0-.09.07-.15.2-.12a.35.35 0 0 1 .29.2l5.6 21.74c.04.09-.05.15-.21.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "467.17px 220.543px"
    },
    id: "elo6z5ppo7rt9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08 233.62a.38.38 0 0 1-.29-.2l-5.59-21.74c0-.09.07-.15.2-.13a.35.35 0 0 1 .29.2l5.6 21.74c.02.09-.07.15-.21.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "459.246px 222.585px"
    },
    id: "elug1yikisjs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.14 235.66a.35.35 0 0 1-.28-.2l-5.6-21.74c0-.09.07-.15.2-.13a.38.38 0 0 1 .29.21l5.6 21.74c.02.09-.07.14-.21.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "451.306px 224.625px"
    },
    id: "el97bf4ytep6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.2 237.71a.39.39 0 0 1-.29-.21l-5.59-21.74c0-.09.07-.14.2-.12a.35.35 0 0 1 .29.2l5.6 21.74c.02.09-.07.15-.21.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "443.366px 226.675px"
    },
    id: "el6yuwth8jlxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.26 239.75a.38.38 0 0 1-.29-.2l-5.59-21.74c0-.09.07-.15.2-.13a.34.34 0 0 1 .29.21l5.6 21.73c.02.1-.07.15-.21.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "435.426px 228.715px"
    },
    id: "ell76dc55itbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32 241.8a.42.42 0 0 1-.29-.21l-5.59-21.74c0-.09.07-.15.2-.12a.35.35 0 0 1 .29.2l5.6 21.74c.02.09-.07.15-.21.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "427.486px 230.763px"
    },
    id: "eliy2qfph251p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13 225.49a.37.37 0 0 1-.24-.12c-.09-.09-.07-.18 0-.21l55.58-14.3a.39.39 0 0 1 .35.11c.09.09.08.18 0 .21l-55.58 14.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "453.857px 218.172px"
    },
    id: "el4l4l7jsqza5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.52 230.93a.51.51 0 0 1-.23-.12c-.09-.09-.07-.19 0-.21l55.58-14.31a.39.39 0 0 1 .35.11c.09.09.08.19 0 .22l-55.58 14.3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "455.257px 223.607px"
    },
    id: "el4ab8wnc3et8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.92 236.36a.43.43 0 0 1-.23-.12c-.09-.09-.07-.18 0-.21l55.58-14.3a.39.39 0 0 1 .35.11c.09.09.08.18 0 .21L429 236.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "456.657px 229.042px"
    },
    id: "elaqqllha9gc6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.32 241.8-.13-.05a.31.31 0 0 1-.16-.16l-5.59-21.74c0-.06 0-.1.08-.12l55.59-14.31a.36.36 0 0 1 .24 0 .31.31 0 0 1 .16.16l5.6 21.74a.1.1 0 0 1-.09.12l-55.58 14.31ZM425 220l5.5 21.35 55.14-14.19-5.5-21.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "455.276px 223.6px"
    },
    id: "elgrfb2md2w7k",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "455.276px 223.602px"
    },
    className: "animable",
    id: "elpsi94ujoz7g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.9 227.49a.37.37 0 0 1-.29-.21L480 205.55c0-.1.07-.15.2-.13a.35.35 0 0 1 .29.2l5.6 21.74c.04.09-.09.15-.19.13Z",
    id: "el2yyuq3sz0gr",
    className: "animable",
    style: {
      transformOrigin: "483.049px 216.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 229.53a.35.35 0 0 1-.28-.2l-5.6-21.74c0-.09.07-.15.2-.13a.36.36 0 0 1 .29.21l5.6 21.74c-.02.09-.11.14-.21.12Z",
    id: "el199zx0jz57p",
    className: "animable",
    style: {
      transformOrigin: "475.165px 218.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 231.58a.38.38 0 0 1-.28-.21l-5.6-21.74c0-.09.07-.15.2-.12a.35.35 0 0 1 .29.2l5.6 21.74c.04.09-.05.15-.21.13Z",
    id: "el4n8dp2lpth",
    className: "animable",
    style: {
      transformOrigin: "467.17px 220.543px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08 233.62a.38.38 0 0 1-.29-.2l-5.59-21.74c0-.09.07-.15.2-.13a.35.35 0 0 1 .29.2l5.6 21.74c.02.09-.07.15-.21.13Z",
    id: "elvvcvghd7tsc",
    className: "animable",
    style: {
      transformOrigin: "459.246px 222.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.14 235.66a.35.35 0 0 1-.28-.2l-5.6-21.74c0-.09.07-.15.2-.13a.38.38 0 0 1 .29.21l5.6 21.74c.02.09-.07.14-.21.12Z",
    id: "elxlpqk9mrmlm",
    className: "animable",
    style: {
      transformOrigin: "451.306px 224.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.2 237.71a.39.39 0 0 1-.29-.21l-5.59-21.74c0-.09.07-.14.2-.12a.35.35 0 0 1 .29.2l5.6 21.74c.02.09-.07.15-.21.13Z",
    id: "ely23mtpm0x6k",
    className: "animable",
    style: {
      transformOrigin: "443.366px 226.675px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.26 239.75a.38.38 0 0 1-.29-.2l-5.59-21.74c0-.09.07-.15.2-.13a.34.34 0 0 1 .29.21l5.6 21.73c.02.1-.07.15-.21.13Z",
    id: "elcdqjef01fbo",
    className: "animable",
    style: {
      transformOrigin: "435.426px 228.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32 241.8a.42.42 0 0 1-.29-.21l-5.59-21.74c0-.09.07-.15.2-.12a.35.35 0 0 1 .29.2l5.6 21.74c.02.09-.07.15-.21.13Z",
    id: "elg62w0garj65",
    className: "animable",
    style: {
      transformOrigin: "427.486px 230.763px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13 225.49a.37.37 0 0 1-.24-.12c-.09-.09-.07-.18 0-.21l55.58-14.3a.39.39 0 0 1 .35.11c.09.09.08.18 0 .21l-55.58 14.31Z",
    id: "elqwvq5oywqa",
    className: "animable",
    style: {
      transformOrigin: "453.857px 218.172px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.52 230.93a.51.51 0 0 1-.23-.12c-.09-.09-.07-.19 0-.21l55.58-14.31a.39.39 0 0 1 .35.11c.09.09.08.19 0 .22l-55.58 14.3Z",
    id: "el8euf2i2atx",
    className: "animable",
    style: {
      transformOrigin: "455.257px 223.607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.92 236.36a.43.43 0 0 1-.23-.12c-.09-.09-.07-.18 0-.21l55.58-14.3a.39.39 0 0 1 .35.11c.09.09.08.18 0 .21L429 236.36Z",
    id: "el5nveqor93lc",
    className: "animable",
    style: {
      transformOrigin: "456.657px 229.042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.32 241.8-.13-.05a.31.31 0 0 1-.16-.16l-5.59-21.74c0-.06 0-.1.08-.12l55.59-14.31a.36.36 0 0 1 .24 0 .31.31 0 0 1 .16.16l5.6 21.74a.1.1 0 0 1-.09.12l-55.58 14.31ZM425 220l5.5 21.35 55.14-14.19-5.5-21.36Z",
    id: "eleylhdl5ct3n",
    className: "animable",
    style: {
      transformOrigin: "455.276px 223.6px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M487.44 222.39c-.77 1.28-3 1.6-3.8 1.63s-1.39.41-1.11 1.66c.24 1.09.8 4-.28 5.25a13 13 0 0 0 5.19-8.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "484.845px 226.66px"
    },
    className: "animable",
    id: "el11yeqgwthzdh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.47 219a4.24 4.24 0 0 1-1.88 5.06c-1.25.76-1.76.43-2 1.05s.08 1.23-.25 3.07a4.26 4.26 0 0 1-2.74 3.4c3.53-.91 5-2.9 6.26-5.45a8.88 8.88 0 0 0 .61-7.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "484.274px 225.29px"
    },
    id: "elky7cu4xyvuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.47 219a4.24 4.24 0 0 1-1.88 5.06c-1.25.76-1.76.43-2 1.05s.08 1.23-.25 3.07a4.26 4.26 0 0 1-2.74 3.4c3.53-.91 5-2.9 6.26-5.45a8.88 8.88 0 0 0 .61-7.13Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "484.274px 225.29px"
    },
    className: "animable",
    id: "elw4wzsgq753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.19 213.26 3.32-20.08-18.62 4.82a.66.66 0 0 0-.4.3s0 .07 0 .1v.11a.65.65 0 0 0 0 .24l.69 2.69 2.68 10.42 11.67 1.92a.63.63 0 0 0 .66-.52Z",
    style: {
      opacity: 0.2,
      transformOrigin: "424.994px 203.481px"
    },
    className: "animable",
    id: "elg52tdpcvgl6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.94 161.09-62.6-10.3a.62.62 0 0 0-.74.49l-3.44 20.8v.41a26.36 26.36 0 0 0 1.27 13.67c.1.26.21.53.33.79a22 22 0 0 0 2.57 4.37 3.79 3.79 0 0 0 .34.45c.35.46.72.91 1.12 1.36.83.94 1.62 1.79 2.38 2.56l.4.4c.72.72 1.42 1.38 2.1 2l.6.5a17.7 17.7 0 0 0 8.31 4l.42.08 39 6.44a.63.63 0 0 0 .74-.49l7.74-46.83a.63.63 0 0 0-.54-.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "403.63px 179.949px"
    },
    id: "eln9frqw3fyx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.94 161.09-62.6-10.3a.62.62 0 0 0-.74.49l-3.44 20.8v.41a26.36 26.36 0 0 0 1.27 13.67c.1.26.21.53.33.79a22 22 0 0 0 2.57 4.37 3.79 3.79 0 0 0 .34.45c.35.46.72.91 1.12 1.36.83.94 1.62 1.79 2.38 2.56l.4.4c.72.72 1.42 1.38 2.1 2l.6.5a17.7 17.7 0 0 0 8.31 4l.42.08 39 6.44a.63.63 0 0 0 .74-.49l7.74-46.83a.63.63 0 0 0-.54-.7Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "403.63px 179.949px"
    },
    className: "animable",
    id: "el15yoii2xmx4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.38 168.5 372.49 158l1.11-6.71a.56.56 0 0 1 .25-.38.64.64 0 0 1 .49-.11L437 161.09a.64.64 0 0 1 .55.59s0 .05 0 .07l-.07.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "405.02px 159.645px"
    },
    id: "elechdiktu93",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.38 168.5 372.49 158l1.11-6.71a.56.56 0 0 1 .25-.38.64.64 0 0 1 .49-.11L437 161.09a.64.64 0 0 1 .55.59s0 .05 0 .07l-.07.45Z",
    style: {
      opacity: 0.2,
      transformOrigin: "405.02px 159.645px"
    },
    className: "animable",
    id: "ela7rm7f2356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.57 154.62a1.14 1.14 0 0 1 1.37-.85 1.07 1.07 0 1 1-.34 2.09 1.14 1.14 0 0 1-1.03-1.24Z",
    style: {
      fill: "#263238",
      transformOrigin: "379.779px 154.825px"
    },
    id: "elyo2hi8w7dmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 156a1.23 1.23 0 1 1 1 1.24 1.16 1.16 0 0 1-1-1.24Z",
    style: {
      fill: "#263238",
      transformOrigin: "388.228px 156.032px"
    },
    id: "eliw5xuzdonc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.44 157.4a1.16 1.16 0 0 1 1.38-.85 1.07 1.07 0 1 1-.34 2.09 1.16 1.16 0 0 1-1.04-1.24Z",
    style: {
      fill: "#263238",
      transformOrigin: "396.655px 157.606px"
    },
    id: "el8337y8vxw1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32 160.17a1.23 1.23 0 0 1 2.41.4 1.16 1.16 0 0 1-1.38.85 1.14 1.14 0 0 1-1.03-1.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "413.523px 160.365px"
    },
    id: "elqcorxegkl9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76 161.56a1.15 1.15 0 0 1 1.38-.84 1.07 1.07 0 1 1-.34 2.09 1.16 1.16 0 0 1-1.04-1.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "421.974px 161.775px"
    },
    id: "elmx4p54k1la",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.1 163a1.16 1.16 0 0 1 1.38-.85 1.07 1.07 0 1 1-.34 2.09 1.16 1.16 0 0 1-1.04-1.24Z",
    style: {
      fill: "#263238",
      transformOrigin: "430.315px 163.206px"
    },
    id: "elbhispoorq2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "403.79px 167.19px",
      transform: "rotate(-80.64deg)"
    },
    className: "animable",
    d: "M399.78 134.82h8.02v64.74h-8.02z",
    id: "el1zmub3f4m7o"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "403.79px 167.19px"
    },
    className: "animable",
    id: "eljbpewfpt3w"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "403.79px 167.19px",
      transform: "rotate(-80.64deg)"
    },
    className: "animable",
    d: "M399.78 134.82h8.02v64.74h-8.02z",
    id: "ell2k6togpl6r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.31 162.37a2.22 2.22 0 0 1 .7.22 1.88 1.88 0 0 1 .48.36 1.41 1.41 0 0 1 .25.42.93.93 0 0 1 .06.39.14.14 0 0 1-.07.11.15.15 0 0 1-.13 0l-.42-.07a.21.21 0 0 1-.15-.07.36.36 0 0 1-.08-.12.81.81 0 0 0-.23-.31 1.15 1.15 0 0 0-.53-.2 1.67 1.67 0 0 0-.31 0 .91.91 0 0 0-.26.06.46.46 0 0 0-.2.13.34.34 0 0 0-.09.19.37.37 0 0 0 0 .24.43.43 0 0 0 .17.19l.34.17a5.37 5.37 0 0 0 .54.22 5.65 5.65 0 0 1 .6.29 1.62 1.62 0 0 1 .39.33 1 1 0 0 1 .19.39 1.12 1.12 0 0 1 0 .45 1 1 0 0 1-.21.49 1.08 1.08 0 0 1-.41.35 2 2 0 0 1-.6.17 2.73 2.73 0 0 1-.75 0 2.78 2.78 0 0 1-.64-.19 2.23 2.23 0 0 1-.51-.33 1.34 1.34 0 0 1-.32-.44 1 1 0 0 1-.09-.51.14.14 0 0 1 .07-.11.14.14 0 0 1 .12 0l.43.07a.26.26 0 0 1 .15.06.24.24 0 0 1 .08.13c0 .05 0 .11.07.17a.75.75 0 0 0 .14.17 1.17 1.17 0 0 0 .25.14 1.45 1.45 0 0 0 .38.11h.35a1 1 0 0 0 .32-.05.56.56 0 0 0 .23-.12.4.4 0 0 0 .12-.22.3.3 0 0 0 0-.23.69.69 0 0 0-.24-.19 3.3 3.3 0 0 0-.41-.19l-.56-.24a3.45 3.45 0 0 1-.51-.26 1.1 1.1 0 0 1-.33-.31.87.87 0 0 1-.17-.38 1.57 1.57 0 0 1 0-.48 1.06 1.06 0 0 1 .2-.49 1.32 1.32 0 0 1 .4-.34 1.77 1.77 0 0 1 .55-.17 2 2 0 0 1 .64 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "387.914px 164.57px"
    },
    id: "els0r5hvjxdos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.05 166.81a.13.13 0 0 1 .1.06.15.15 0 0 1 0 .13l-.07.43a.19.19 0 0 1-.07.11.24.24 0 0 1-.12 0l-2.67-.44a.16.16 0 0 1-.11-.07.14.14 0 0 1 0-.12l.65-3.94a.19.19 0 0 1 .07-.11.24.24 0 0 1 .12 0l2.62.43a.21.21 0 0 1 .11.07.15.15 0 0 1 0 .13l-.07.43a.19.19 0 0 1-.07.11h-.12l-2-.33-.16 1 1.83.3a.16.16 0 0 1 .11.07.14.14 0 0 1 0 .12l-.07.44a.14.14 0 0 1-.07.1.14.14 0 0 1-.12 0l-1.83-.3-.17 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "391.896px 165.2px"
    },
    id: "eli9rbtw7j7ls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.33 163.75a1.72 1.72 0 0 1 1.09.54 1.29 1.29 0 0 1 .24 1.08 1.3 1.3 0 0 1-.57 1 1.76 1.76 0 0 1-1.21.16l-1-.16-.22 1.36a.19.19 0 0 1-.07.11.28.28 0 0 1-.13 0l-.49-.09a.17.17 0 0 1-.11-.06.28.28 0 0 1 0-.13l.65-3.93a.16.16 0 0 1 .07-.11.14.14 0 0 1 .12 0Zm-1.33 1.82.94.15a1 1 0 0 0 .57 0 .54.54 0 0 0 .29-.45.52.52 0 0 0-.13-.5 1 1 0 0 0-.53-.22l-.94-.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "395.772px 165.677px"
    },
    id: "elcew0usgk7d9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.38 164.58a.16.16 0 0 1 .11.07.14.14 0 0 1 0 .12l-.07.43a.14.14 0 0 1-.07.11.14.14 0 0 1-.12 0l-1.1-.18-.55 3.34a.17.17 0 0 1-.06.11.28.28 0 0 1-.13 0l-.49-.08a.19.19 0 0 1-.11-.07.28.28 0 0 1 0-.13l.55-3.33-1.09-.18a.16.16 0 0 1-.11-.07.15.15 0 0 1 0-.13l.07-.43a.19.19 0 0 1 .07-.11.17.17 0 0 1 .12 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "399.814px 166.313px"
    },
    id: "el6masq0evy1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.42 168.68a.13.13 0 0 1 .1.06.15.15 0 0 1 0 .13l-.07.43a.16.16 0 0 1-.19.14l-2.67-.44a.19.19 0 0 1-.11-.07.18.18 0 0 1 0-.12l.65-3.94a.19.19 0 0 1 .07-.11.27.27 0 0 1 .12 0l2.62.44a.16.16 0 0 1 .14.19l-.07.43a.16.16 0 0 1-.07.11h-.12l-2-.33-.16 1 1.84.3a.14.14 0 0 1 .1.07.15.15 0 0 1 0 .13l-.07.43a.19.19 0 0 1-.07.11.16.16 0 0 1-.12 0l-1.83-.3-.17 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "403.276px 167.098px"
    },
    id: "elnn419otsoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55 167.83 409 166l.1-.09a.24.24 0 0 1 .19 0l.42.07a.14.14 0 0 1 .11.06.28.28 0 0 1 0 .13l-.65 3.93a.16.16 0 0 1-.07.11.14.14 0 0 1-.12 0l-.5-.08a.14.14 0 0 1-.1-.07.14.14 0 0 1 0-.12l.39-2.39-1 1.24a.45.45 0 0 1-.1.09.19.19 0 0 1-.15 0h-.32a.22.22 0 0 1-.13-.08.41.41 0 0 1-.06-.11l-.57-1.5-.39 2.38a.19.19 0 0 1-.07.11h-.12l-.5-.08a.14.14 0 0 1-.1-.07.15.15 0 0 1 0-.13l.64-3.93a.19.19 0 0 1 .07-.11.14.14 0 0 1 .12 0l.42.07a.23.23 0 0 1 .17.1.64.64 0 0 1 .06.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "407.536px 167.785px"
    },
    id: "el1p5hhvx700ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.31 170.43a.14.14 0 0 1-.1-.07.14.14 0 0 1 0-.12l.64-3.94a.16.16 0 0 1 .2-.13l1.79.29a1.51 1.51 0 0 1 .63.23 1.16 1.16 0 0 1 .37.36 1.21 1.21 0 0 1 .17.43 1.41 1.41 0 0 1 0 .41.94.94 0 0 1-.1.31 1 1 0 0 1-.16.23.7.7 0 0 1-.17.14l-.12.08a1.29 1.29 0 0 1 .28.41 1.05 1.05 0 0 1 .06.62 1.36 1.36 0 0 1-.47.82 1.42 1.42 0 0 1-.46.23 1.45 1.45 0 0 1-.59 0Zm.79-.65 1.12.18a.67.67 0 0 0 .51-.06.54.54 0 0 0 .12-.76.69.69 0 0 0-.46-.22l-1.12-.19Zm2.06-2a.45.45 0 0 0-.09-.37.79.79 0 0 0-.45-.2l-1.07-.18-.16.94 1.08.18a.79.79 0 0 0 .48 0 .46.46 0 0 0 .21-.37Z",
    style: {
      fill: "#455a64",
      transformOrigin: "412.111px 168.462px"
    },
    id: "el5zkqtpnuwwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.28 170.79a.16.16 0 0 1 .11.07.15.15 0 0 1 0 .13l-.07.43a.19.19 0 0 1-.07.11.17.17 0 0 1-.12 0l-2.67-.43a.16.16 0 0 1-.11-.07.15.15 0 0 1 0-.13l.65-3.9a.16.16 0 0 1 .07-.11.13.13 0 0 1 .12 0l2.62.43a.16.16 0 0 1 .11.07.14.14 0 0 1 0 .12l-.07.44a.14.14 0 0 1-.07.1.14.14 0 0 1-.12 0l-2-.32-.16 1 1.83.3a.16.16 0 0 1 .11.07.14.14 0 0 1 0 .12l-.07.44a.14.14 0 0 1-.07.1.14.14 0 0 1-.12 0l-1.83-.3-.17 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "416.134px 169.208px"
    },
    id: "eluifz842p5yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.51 167.73a1.67 1.67 0 0 1 1.1.54 1.29 1.29 0 0 1 .24 1 1.38 1.38 0 0 1-.33.72 1.23 1.23 0 0 1-.68.37l.59 1.64a.2.2 0 0 1 0 .07.13.13 0 0 1-.05.09.15.15 0 0 1-.11 0l-.51-.08a.3.3 0 0 1-.24-.21l-.56-1.55-.81-.13-.23 1.42a.16.16 0 0 1-.2.13l-.49-.08a.13.13 0 0 1-.1-.06.2.2 0 0 1 0-.13l.65-3.93a.16.16 0 0 1 .07-.11.14.14 0 0 1 .12 0Zm-1.22 1.77.88.14a1.05 1.05 0 0 0 .57 0 .49.49 0 0 0 .28-.43.47.47 0 0 0-.13-.49 1.13 1.13 0 0 0-.53-.21l-.88-.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "419.994px 169.793px"
    },
    id: "elb868jfil9ub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.88 170.55a.91.91 0 0 0 .85.95l4.79.79a.82.82 0 1 0 .26-1.58l-4.79-.79a.91.91 0 0 0-1.11.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "378.262px 171.119px"
    },
    id: "ele5zdn9y148",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 171.88a.91.91 0 0 0 .84 1l4.8.79a.82.82 0 1 0 .26-1.58l-4.79-.79a.91.91 0 0 0-1.11.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "386.38px 172.497px"
    },
    id: "elkt8zxzlw1sc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.06 173.21a.9.9 0 0 0 .84.95l4.8.79a.82.82 0 1 0 .26-1.58l-4.8-.79a.9.9 0 0 0-1.1.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "394.442px 173.779px"
    },
    id: "elowjs608dx0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.14 174.54a.91.91 0 0 0 .85 1l4.79.79a.82.82 0 1 0 .26-1.58l-4.79-.79a.91.91 0 0 0-1.11.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "402.52px 175.157px"
    },
    id: "elux6qz039q2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.23 175.87a.91.91 0 0 0 .84.95l4.8.79a.82.82 0 1 0 .26-1.58l-4.79-.79a.91.91 0 0 0-1.11.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "410.612px 176.439px"
    },
    id: "elfz9ep3kvvgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.32 177.2a.9.9 0 0 0 .84 1l4.8.79a.82.82 0 1 0 .26-1.58l-4.8-.79a.9.9 0 0 0-1.1.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.7px 177.817px"
    },
    id: "elejh3c6d796q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41 178.53a.9.9 0 0 0 .84.95l4.79.79a.82.82 0 1 0 .26-1.58l-4.79-.79a.9.9 0 0 0-1.1.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "426.787px 179.099px"
    },
    id: "elcypfgfnd26h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "400.895px 190.123px"
    },
    className: "animable",
    id: "elcr9m77lytyu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.51 206a.35.35 0 0 1-.18-.31l3.67-22.11c0-.1.12-.11.24 0a.39.39 0 0 1 .18.3L426.74 206c-.01.09-.12.1-.23 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "428.375px 194.786px"
    },
    id: "elrtjgqe388tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.42 204.7a.35.35 0 0 1-.18-.31l3.64-22.15c0-.09.12-.1.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.07-.12.08-.23.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "420.27px 193.458px"
    },
    id: "el5loexy7vwu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.33 203.37a.35.35 0 0 1-.18-.31l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.06-.12.08-.23.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "412.18px 192.125px"
    },
    id: "elewhfax2shcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.24 202a.33.33 0 0 1-.18-.3l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3L402.47 202c-.01.09-.12.11-.23 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "404.09px 190.775px"
    },
    id: "elt9paclwt6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.15 200.7a.33.33 0 0 1-.18-.3l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.06-.12.08-.23 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "396px 189.464px"
    },
    id: "eli0i7s927d1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06 199.37a.33.33 0 0 1-.18-.3l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.06-.12.08-.23 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "387.91px 188.134px"
    },
    id: "elplbki1gnv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85 175.86v.09l-2.25 13.55-.44 2.68-.06.38-.59 3.58-.4-.4.54-3.25.06-.39.44-2.68 2.23-13.54.05-.29q0-.09.09-.09h.14a.39.39 0 0 1 .19.36Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "379.98px 185.82px"
    },
    id: "elw4axd5ivf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76 174.52v.1l-1.52 9.24-.54 3.14c-.12-.26-.23-.53-.33-.79l.51-3.12 1.46-8.83a.09.09 0 0 1 .13-.08h.11a.39.39 0 0 1 .18.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "372.565px 180.585px"
    },
    id: "elrae53uetck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.61 180.1a.47.47 0 0 1-.17-.2c0-.12 0-.2.12-.18l56.63 9.28a.42.42 0 0 1 .27.25c.05.12 0 .2-.11.18l-56.63-9.32a.25.25 0 0 1-.11-.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "400.96px 184.575px"
    },
    id: "elurby0kjkyvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7 185.63a.42.42 0 0 1-.17-.2c0-.11 0-.19.12-.18l56.63 9.32a.42.42 0 0 1 .27.25c.05.11 0 .2-.11.18l-56.63-9.32a.22.22 0 0 1-.11-.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "400.05px 190.126px"
    },
    id: "eltuxo0uasicp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64 200.35c0 .12 0 .2-.11.18l-.34-.06-44.81-7.37-3.28-.54-.45-.07-4-.67a3.79 3.79 0 0 1-.34-.45l4.44.73.45.08 3.19.52 44.9 7.39h.11a.37.37 0 0 1 .24.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "400.975px 195.952px"
    },
    id: "el0pfkdudwpn6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.31 183.63a.46.46 0 0 0-.21-.14l-48.48-8h-.09l-8-1.31h-.06a.09.09 0 0 0-.13.08l-1.46 8.83-.51 3.12c.1.26.21.53.33.79l.52-3.14 1.52-9.24 7.64 1.26.45.07 48.09 7.92-2.67 16.22-.06.38-.85 5.15-42.12-6.93-3.61-.59.6.5 3.35.55 42.05 6.92a.1.1 0 0 0 .13-.08l3.65-22.15a.28.28 0 0 0-.08-.21Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "400.88px 190.123px"
    },
    id: "elko69u0846m",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "400.895px 190.123px"
    },
    className: "animable",
    id: "el5lswbgm15bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.51 206a.35.35 0 0 1-.18-.31l3.67-22.11c0-.1.12-.11.24 0a.39.39 0 0 1 .18.3L426.74 206c-.01.09-.12.1-.23 0Z",
    id: "elzy9xqksj0j8",
    className: "animable",
    style: {
      transformOrigin: "428.375px 194.786px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.42 204.7a.35.35 0 0 1-.18-.31l3.64-22.15c0-.09.12-.1.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.07-.12.08-.23.01Z",
    id: "elzu7qknyv8yf",
    className: "animable",
    style: {
      transformOrigin: "420.27px 193.458px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.33 203.37a.35.35 0 0 1-.18-.31l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.06-.12.08-.23.01Z",
    id: "eln696s84090j",
    className: "animable",
    style: {
      transformOrigin: "412.18px 192.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.24 202a.33.33 0 0 1-.18-.3l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3L402.47 202c-.01.09-.12.11-.23 0Z",
    id: "elguzpw662kgj",
    className: "animable",
    style: {
      transformOrigin: "404.09px 190.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.15 200.7a.33.33 0 0 1-.18-.3l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.06-.12.08-.23 0Z",
    id: "elen4kgnjeez4",
    className: "animable",
    style: {
      transformOrigin: "396px 189.464px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06 199.37a.33.33 0 0 1-.18-.3l3.64-22.15c0-.09.12-.11.24 0a.38.38 0 0 1 .18.3l-3.65 22.15c-.01.06-.12.08-.23 0Z",
    id: "elx06l6xgs9fm",
    className: "animable",
    style: {
      transformOrigin: "387.91px 188.134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85 175.86v.09l-2.25 13.55-.44 2.68-.06.38-.59 3.58-.4-.4.54-3.25.06-.39.44-2.68 2.23-13.54.05-.29q0-.09.09-.09h.14a.39.39 0 0 1 .19.36Z",
    id: "elnnkispge43o",
    className: "animable",
    style: {
      transformOrigin: "379.98px 185.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76 174.52v.1l-1.52 9.24-.54 3.14c-.12-.26-.23-.53-.33-.79l.51-3.12 1.46-8.83a.09.09 0 0 1 .13-.08h.11a.39.39 0 0 1 .18.34Z",
    id: "el9z2o2lp0f0o",
    className: "animable",
    style: {
      transformOrigin: "372.565px 180.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.61 180.1a.47.47 0 0 1-.17-.2c0-.12 0-.2.12-.18l56.63 9.28a.42.42 0 0 1 .27.25c.05.12 0 .2-.11.18l-56.63-9.32a.25.25 0 0 1-.11-.01Z",
    id: "el4tr6upfx4io",
    className: "animable",
    style: {
      transformOrigin: "400.96px 184.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7 185.63a.42.42 0 0 1-.17-.2c0-.11 0-.19.12-.18l56.63 9.32a.42.42 0 0 1 .27.25c.05.11 0 .2-.11.18l-56.63-9.32a.22.22 0 0 1-.11-.05Z",
    id: "elr50ufmoxf1p",
    className: "animable",
    style: {
      transformOrigin: "400.05px 190.126px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64 200.35c0 .12 0 .2-.11.18l-.34-.06-44.81-7.37-3.28-.54-.45-.07-4-.67a3.79 3.79 0 0 1-.34-.45l4.44.73.45.08 3.19.52 44.9 7.39h.11a.37.37 0 0 1 .24.26Z",
    id: "elneqjb1begzf",
    className: "animable",
    style: {
      transformOrigin: "400.975px 195.952px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.31 183.63a.46.46 0 0 0-.21-.14l-48.48-8h-.09l-8-1.31h-.06a.09.09 0 0 0-.13.08l-1.46 8.83-.51 3.12c.1.26.21.53.33.79l.52-3.14 1.52-9.24 7.64 1.26.45.07 48.09 7.92-2.67 16.22-.06.38-.85 5.15-42.12-6.93-3.61-.59.6.5 3.35.55 42.05 6.92a.1.1 0 0 0 .13-.08l3.65-22.15a.28.28 0 0 0-.08-.21Z",
    id: "elkom1t9ti75k",
    className: "animable",
    style: {
      transformOrigin: "400.88px 190.123px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371 180.59a10.73 10.73 0 0 0 6.8 6.79c3.91 1.31 6.52 1 7.09 2.08s-.46 2.94-.51 5.54 1.13 5.66 2.38 6.62c-3.43-1.46-7.6-6-10.61-10.25s-4.37-7.22-5.15-10.78Z",
    style: {
      opacity: 0.2,
      transformOrigin: "378.88px 191.105px"
    },
    className: "animable",
    id: "elbi2m51xbhie"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16 172.09c-.71 4.33 1.31 12.82 4.72 15.43s5.73 1.49 7 2.88c.72.81.29 3 .93 5.26.75 2.74 3.39 6.4 7.16 7-5-.83-8.7-3.3-14.21-9.5s-6.76-13.16-5.6-21.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "379.867px 187.375px"
    },
    id: "elovw6ucp6u8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16 172.09c-.71 4.33 1.31 12.82 4.72 15.43s5.73 1.49 7 2.88c.72.81.29 3 .93 5.26.75 2.74 3.39 6.4 7.16 7-5-.83-8.7-3.3-14.21-9.5s-6.76-13.16-5.6-21.07Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "379.867px 187.375px"
    },
    className: "animable",
    id: "elcqsqs9qiejw"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "424.69px 302.361px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m446.86 262.76-9.71 46.45a.64.64 0 0 1-.77.46L385 299l-.72-.15a14.28 14.28 0 0 1-6.85-3.25c-2.35-2.28-2.68-3.87-2.37-5.71 0-.1 0-.19.06-.29l8.37-40a.63.63 0 0 1 .76-.46l62.1 12.86a.63.63 0 0 1 .51.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "410.919px 279.405px"
    },
    id: "elb8tya7uuvia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.86 262.76-9.71 46.45a.64.64 0 0 1-.77.46L385 299l-.72-.15a14.28 14.28 0 0 1-6.85-3.25c-2.35-2.28-2.68-3.87-2.37-5.71 0-.1 0-.19.06-.29a.25.25 0 0 1 0-.08l8.36-39.93a.63.63 0 0 1 .76-.46L446.35 262a.63.63 0 0 1 .51.76Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "410.919px 279.4px"
    },
    className: "animable",
    id: "elsjgin21cjfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.47 269.42-63.38-13.22 1.39-6.66a.56.56 0 0 1 .26-.37.71.71 0 0 1 .5-.09l62.11 13a.64.64 0 0 1 .53.61v.11l-.1.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "414.485px 259.244px"
    },
    id: "elvhxerknk38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.47 269.42-63.38-13.22 1.39-6.66a.56.56 0 0 1 .26-.37.71.71 0 0 1 .5-.09l62.11 13a.64.64 0 0 1 .53.61v.11l-.1.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "414.485px 259.244px"
    },
    className: "animable",
    id: "elsvcqme5n9l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3 253.09a1.23 1.23 0 0 1 2.39.5 1.23 1.23 0 0 1-2.39-.5Z",
    style: {
      fill: "#263238",
      transformOrigin: "389.495px 253.34px"
    },
    id: "elm6q0fe1s1sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.68 254.84a1.23 1.23 0 1 1 1 1.28 1.15 1.15 0 0 1-1-1.28Z",
    style: {
      fill: "#263238",
      transformOrigin: "397.905px 254.911px"
    },
    id: "elqwb0dy7kpbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405 256.58a1.17 1.17 0 0 1 1.42-.79 1.07 1.07 0 1 1-1.42.79Z",
    style: {
      fill: "#263238",
      transformOrigin: "406.048px 256.807px"
    },
    id: "el0nz32o6q0zuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.78 260.07a1.15 1.15 0 0 1 1.42-.78 1.13 1.13 0 0 1 1 1.28 1.23 1.23 0 0 1-2.39-.5Z",
    style: {
      fill: "#263238",
      transformOrigin: "422.995px 260.325px"
    },
    id: "elq9hafphc95c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.16 261.82a1.23 1.23 0 0 1 2.39.5 1.23 1.23 0 0 1-2.39-.5Z",
    style: {
      fill: "#263238",
      transformOrigin: "431.355px 262.07px"
    },
    id: "elfgy5o5c8x89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.44 263.63a1.23 1.23 0 0 1 2.39.49 1.15 1.15 0 0 1-1.42.79 1.14 1.14 0 0 1-.97-1.28Z",
    style: {
      fill: "#263238",
      transformOrigin: "439.632px 263.877px"
    },
    id: "elyxnwebp6io",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "412.97px 266.72px",
      transform: "rotate(-78.2deg)"
    },
    className: "animable",
    d: "M408.96 234.35h8.02v64.74h-8.02z",
    id: "eljhnt9eergu"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "412.97px 266.72px"
    },
    className: "animable",
    id: "elivdt2ct3ncf"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "412.97px 266.72px",
      transform: "rotate(-78.2deg)"
    },
    className: "animable",
    d: "M408.96 234.35h8.02v64.74h-8.02z",
    id: "elnh2de17wlk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.53 266.24a.22.22 0 0 1-.15-.08.64.64 0 0 1-.06-.11l-1.17-2.86-.52 2.49a.14.14 0 0 1-.07.1.14.14 0 0 1-.12 0l-.49-.11a.16.16 0 0 1-.11-.07.17.17 0 0 1 0-.12l.81-3.91a.16.16 0 0 1 .08-.1.13.13 0 0 1 .12 0l.42.08a.27.27 0 0 1 .15.09.64.64 0 0 1 .06.1l1.17 2.87.51-2.49a.18.18 0 0 1 .08-.11.17.17 0 0 1 .12 0l.49.1a.16.16 0 0 1 .13.2l-.81 3.9a.18.18 0 0 1-.08.11.17.17 0 0 1-.12 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "398.907px 263.893px"
    },
    id: "elg3hobmmf69e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.46 263.88a2.24 2.24 0 0 1 .26-.61 1.46 1.46 0 0 1 .44-.45 1.55 1.55 0 0 1 .62-.24 2.2 2.2 0 0 1 .8 0 2.16 2.16 0 0 1 .74.29 1.59 1.59 0 0 1 .47.46 1.56 1.56 0 0 1 .22.59 1.88 1.88 0 0 1 0 .67v.25l-.06.29-.06.29c0 .09-.05.17-.07.25a1.85 1.85 0 0 1-.26.61 1.54 1.54 0 0 1-.43.45 1.45 1.45 0 0 1-.62.23 2.19 2.19 0 0 1-.8 0 2.14 2.14 0 0 1-.75-.29 1.59 1.59 0 0 1-.47-.46 1.68 1.68 0 0 1-.22-.59 2.1 2.1 0 0 1 0-.66v-.26l.06-.28.06-.29c.03-.13.05-.13.07-.25Zm2.73.6a.92.92 0 0 0-.77-1.12 1 1 0 0 0-.73.1 1 1 0 0 0-.42.62q-.06.23-.12.51t-.09.51a.93.93 0 0 0 .14.73 1 1 0 0 0 .63.38 1 1 0 0 0 .73-.1 1 1 0 0 0 .42-.61q.06-.22.12-.51c.03-.19.07-.36.09-.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "403.142px 264.77px"
    },
    id: "el48y0isq6ydw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.9 266.53 1.62-2.67.08-.09a.24.24 0 0 1 .15 0l.46.1a.14.14 0 0 1 .1.07.14.14 0 0 1 0 .12l-2.14 3.52a.43.43 0 0 1-.12.14.19.19 0 0 1-.15 0l-.49-.1a.17.17 0 0 1-.13-.08.38.38 0 0 1 0-.17l-.56-4.09a.19.19 0 0 1 .07-.11.17.17 0 0 1 .12 0l.46.1a.17.17 0 0 1 .13.08.25.25 0 0 1 0 .11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "407.522px 265.447px"
    },
    id: "elmxw8zwn0mke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.1 268.08a.14.14 0 0 1 .1.07.14.14 0 0 1 0 .12l-.09.43a.16.16 0 0 1-.07.11.19.19 0 0 1-.13 0l-2.65-.55a.14.14 0 0 1-.1-.07.15.15 0 0 1 0-.13l.82-3.9a.16.16 0 0 1 .07-.11.17.17 0 0 1 .12 0l2.61.54a.14.14 0 0 1 .1.07.15.15 0 0 1 0 .13l-.09.43a.12.12 0 0 1-.07.1.14.14 0 0 1-.12 0l-1.95-.41-.2 1 1.82.38a.17.17 0 0 1 .1.07.19.19 0 0 1 0 .13l-.09.43s0 .07-.07.1a.14.14 0 0 1-.12 0l-1.82-.38-.21 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "411.02px 266.43px"
    },
    id: "elm5wu5mj7wf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.27 267.36 1.56-1.75.1-.08a.2.2 0 0 1 .19 0l.41.08a.18.18 0 0 1 .11.08.17.17 0 0 1 0 .12l-.81 3.9a.18.18 0 0 1-.08.11.13.13 0 0 1-.12 0l-.49-.1a.14.14 0 0 1-.1-.07.15.15 0 0 1 0-.13l.49-2.36-1.06 1.2-.11.08a.19.19 0 0 1-.15 0l-.31-.06a.24.24 0 0 1-.13-.08.34.34 0 0 1-.06-.12l-.5-1.52-.5 2.36a.14.14 0 0 1-.07.1.14.14 0 0 1-.12 0l-.49-.1a.18.18 0 0 1-.11-.08.17.17 0 0 1 0-.12l.81-3.91a.17.17 0 0 1 .07-.1.15.15 0 0 1 .13 0l.41.08a.22.22 0 0 1 .16.11l.06.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "415.28px 267.315px"
    },
    id: "elcglxtp4brpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92 270.08a.21.21 0 0 1-.11-.07.19.19 0 0 1 0-.13l.81-3.9a.18.18 0 0 1 .08-.11.17.17 0 0 1 .12 0l1.78.37a1.55 1.55 0 0 1 .62.25 1.2 1.2 0 0 1 .36.39 1 1 0 0 1 .14.43 1.06 1.06 0 0 1 0 .4 1 1 0 0 1-.11.32 1 1 0 0 1-.17.21.73.73 0 0 1-.18.14.42.42 0 0 1-.13.07 1.22 1.22 0 0 1 .27.43 1.06 1.06 0 0 1 0 .62 1.85 1.85 0 0 1-.18.44 1.29 1.29 0 0 1-.34.36 1.34 1.34 0 0 1-.47.2 1.41 1.41 0 0 1-.58 0Zm.81-.62 1.11.23a.72.72 0 0 0 .52 0 .54.54 0 0 0 .15-.75.7.7 0 0 0-.45-.24l-1.12-.23Zm2.14-1.91a.42.42 0 0 0-.07-.37.79.79 0 0 0-.44-.22l-1.06-.22-.2.93 1.07.22a.68.68 0 0 0 .48 0 .41.41 0 0 0 .22-.34Z",
    style: {
      fill: "#455a64",
      transformOrigin: "419.769px 268.195px"
    },
    id: "el7kitcbj6mvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.87 270.74a.14.14 0 0 1 .1.07.15.15 0 0 1 0 .13l-.09.42a.18.18 0 0 1-.08.11.13.13 0 0 1-.12 0l-2.65-.55a.16.16 0 0 1-.13-.2l.81-3.9a.16.16 0 0 1 .08-.1.14.14 0 0 1 .12 0l2.6.55a.16.16 0 0 1 .11.07.17.17 0 0 1 0 .12l-.09.43a.16.16 0 0 1-.07.11.17.17 0 0 1-.12 0l-1.95-.41-.21 1 1.82.37a.18.18 0 0 1 .11.08.16.16 0 0 1 0 .12l-.09.43a.14.14 0 0 1-.07.1.14.14 0 0 1-.12 0l-1.82-.38-.21 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "423.763px 269.096px"
    },
    id: "elpd1v044lscf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.22 267.81a1.74 1.74 0 0 1 1.08.59 1.31 1.31 0 0 1 .19 1.06 1.37 1.37 0 0 1-.36.71 1.26 1.26 0 0 1-.69.34l.52 1.66a.08.08 0 0 1 0 .07.11.11 0 0 1-.06.09.12.12 0 0 1-.1 0l-.51-.11a.3.3 0 0 1-.17-.09.49.49 0 0 1-.06-.13l-.49-1.57-.81-.17-.29 1.41a.16.16 0 0 1-.07.11.19.19 0 0 1-.13 0l-.49-.1a.14.14 0 0 1-.1-.07.19.19 0 0 1 0-.13l.82-3.9a.16.16 0 0 1 .07-.11.19.19 0 0 1 .13 0Zm-1.3 1.72.88.18a1 1 0 0 0 .57 0 .5.5 0 0 0 .3-.41.49.49 0 0 0-.11-.5 1.2 1.2 0 0 0-.52-.23l-.88-.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "427.599px 269.9px"
    },
    id: "elnr9ee3uqf3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.94 268.85a.91.91 0 0 0 .81 1l4.75 1a.82.82 0 1 0 .33-1.57l-4.76-1a.91.91 0 0 0-1.13.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "387.293px 269.579px"
    },
    id: "elh2lo26icrrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 270.52a.92.92 0 0 0 .8 1l4.76 1a.82.82 0 1 0 .32-1.57l-4.75-1a.91.91 0 0 0-1.13.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "395.354px 271.249px"
    },
    id: "elqedbgrjyo38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 272.19a.91.91 0 0 0 .8 1l4.76 1a.82.82 0 1 0 .33-1.57l-4.76-1a.91.91 0 0 0-1.13.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "403.353px 272.919px"
    },
    id: "el2x1a3mulqea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 273.87a.91.91 0 0 0 .8 1l4.76 1a.82.82 0 1 0 .33-1.56l-4.76-1a.91.91 0 0 0-1.13.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "411.364px 274.609px"
    },
    id: "elukwrq2row8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 275.54a.89.89 0 0 0 .8 1l4.75 1a.82.82 0 1 0 .33-1.57l-4.75-1a.9.9 0 0 0-1.13.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "419.347px 276.268px"
    },
    id: "elolnwvm1k2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.06 277.21a.91.91 0 0 0 .8 1l4.76 1a.82.82 0 1 0 .32-1.57l-4.75-1a.91.91 0 0 0-1.13.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "427.413px 277.939px"
    },
    id: "elpoek6g4xp4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.08 278.88a.91.91 0 0 0 .8 1l4.76 1a.9.9 0 0 0 1.13-.58.92.92 0 0 0-.8-1l-4.76-1a.91.91 0 0 0-1.13.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "435.424px 279.591px"
    },
    id: "elnqkkotjp0gg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "408.245px 289.462px"
    },
    className: "animable",
    id: "elictguyb95mt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434 306.49a.37.37 0 0 1-.17-.31l4.59-22c0-.09.12-.1.23 0a.35.35 0 0 1 .17.31l-4.58 22c-.01.07-.12.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "436.325px 295.328px"
    },
    id: "elxzf4oh8tsy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 304.81a.33.33 0 0 1-.17-.31l4.58-22c0-.09.13-.1.24 0a.36.36 0 0 1 .17.31l-4.59 22c-.03.07-.13.08-.23 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "428.325px 293.648px"
    },
    id: "el4h3o67igbjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 303.14a.37.37 0 0 1-.17-.31l4.58-22c0-.1.13-.11.24 0a.37.37 0 0 1 .17.31l-4.58 22c-.06.07-.17.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "420.325px 291.974px"
    },
    id: "elns5kpzam8lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.93 301.47a.36.36 0 0 1-.16-.31l4.58-22c0-.09.12-.1.24 0a.36.36 0 0 1 .16.31l-4.58 22c-.02.07-.12.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "412.26px 290.308px"
    },
    id: "elqniack5b13f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91 299.79a.36.36 0 0 1-.17-.31l4.58-22c0-.09.13-.11.24 0a.37.37 0 0 1 .17.31l-4.58 22c-.02.07-.15.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "404.235px 288.626px"
    },
    id: "elvej0hfnepf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88 298.12a.37.37 0 0 1-.17-.31l4.59-22c0-.09.12-.1.23 0a.35.35 0 0 1 .17.31l-4.58 22c-.02.07-.12.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "396.205px 286.958px"
    },
    id: "elmclaw3jwuca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85 296.45a.36.36 0 0 1-.16-.32l4.58-22c0-.09.12-.1.24 0a.35.35 0 0 1 .16.31l-4.58 22c-.02.07-.09.08-.24.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "388.18px 285.278px"
    },
    id: "elyopltifcsds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.83 294.77a.37.37 0 0 1-.17-.31l4.58-22c0-.1.13-.11.24 0a.37.37 0 0 1 .17.31l-4.58 22c-.02.07-.13.08-.24 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "380.155px 283.604px"
    },
    id: "el1gd1te1fcsq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27 278.29a.41.41 0 0 1-.16-.21c0-.12 0-.2.12-.17l56.18 11.71a.43.43 0 0 1 .27.26c0 .12 0 .2-.13.18l-56.18-11.72a.24.24 0 0 1-.1-.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "409.395px 283.983px"
    },
    id: "elw1y4zeaer4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.12 283.78a.45.45 0 0 1-.16-.2c0-.12 0-.2.12-.18l56.19 11.72a.4.4 0 0 1 .26.25c0 .12 0 .2-.12.18l-56.18-11.72a.16.16 0 0 1-.11-.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "408.245px 289.475px"
    },
    id: "elz2yvxiidlns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 289.28a.39.39 0 0 1-.15-.21c0-.12 0-.2.12-.18l56.18 11.72a.41.41 0 0 1 .27.26c0 .12 0 .2-.13.17l-56.18-11.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "407.135px 294.967px"
    },
    id: "elsazs9aaa35o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.83 294.77a.43.43 0 0 1-.1-.09.35.35 0 0 1-.07-.22l4.58-22a.11.11 0 0 1 .13-.08l56.19 11.72a.43.43 0 0 1 .2.14.3.3 0 0 1 .07.22l-4.58 22a.1.1 0 0 1-.13.08l-56.19-11.72a.24.24 0 0 1-.1-.05Zm4.8-21.9-4.5 21.59 55.73 11.62 4.51-21.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "408.245px 289.461px"
    },
    id: "el7bws62svh7a",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "408.245px 289.462px"
    },
    className: "animable",
    id: "elj3wq8cqc8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434 306.49a.37.37 0 0 1-.17-.31l4.59-22c0-.09.12-.1.23 0a.35.35 0 0 1 .17.31l-4.58 22c-.01.07-.12.08-.24 0Z",
    id: "elajjckpr1bni",
    className: "animable",
    style: {
      transformOrigin: "436.325px 295.328px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 304.81a.33.33 0 0 1-.17-.31l4.58-22c0-.09.13-.1.24 0a.36.36 0 0 1 .17.31l-4.59 22c-.03.07-.13.08-.23 0Z",
    id: "el2m1e8eyia1w",
    className: "animable",
    style: {
      transformOrigin: "428.325px 293.648px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 303.14a.37.37 0 0 1-.17-.31l4.58-22c0-.1.13-.11.24 0a.37.37 0 0 1 .17.31l-4.58 22c-.06.07-.17.08-.24 0Z",
    id: "elvmvlh2egv",
    className: "animable",
    style: {
      transformOrigin: "420.325px 291.974px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.93 301.47a.36.36 0 0 1-.16-.31l4.58-22c0-.09.12-.1.24 0a.36.36 0 0 1 .16.31l-4.58 22c-.02.07-.12.08-.24 0Z",
    id: "eleo3e918dizn",
    className: "animable",
    style: {
      transformOrigin: "412.26px 290.308px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91 299.79a.36.36 0 0 1-.17-.31l4.58-22c0-.09.13-.11.24 0a.37.37 0 0 1 .17.31l-4.58 22c-.02.07-.15.08-.24 0Z",
    id: "el1qfwrz24vla",
    className: "animable",
    style: {
      transformOrigin: "404.235px 288.626px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88 298.12a.37.37 0 0 1-.17-.31l4.59-22c0-.09.12-.1.23 0a.35.35 0 0 1 .17.31l-4.58 22c-.02.07-.12.08-.24 0Z",
    id: "elxx7vlugw5gs",
    className: "animable",
    style: {
      transformOrigin: "396.205px 286.958px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85 296.45a.36.36 0 0 1-.16-.32l4.58-22c0-.09.12-.1.24 0a.35.35 0 0 1 .16.31l-4.58 22c-.02.07-.09.08-.24.01Z",
    id: "el6sek7odoun",
    className: "animable",
    style: {
      transformOrigin: "388.18px 285.278px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.83 294.77a.37.37 0 0 1-.17-.31l4.58-22c0-.1.13-.11.24 0a.37.37 0 0 1 .17.31l-4.58 22c-.02.07-.13.08-.24 0Z",
    id: "elv5t1lkuy5oi",
    className: "animable",
    style: {
      transformOrigin: "380.155px 283.604px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27 278.29a.41.41 0 0 1-.16-.21c0-.12 0-.2.12-.17l56.18 11.71a.43.43 0 0 1 .27.26c0 .12 0 .2-.13.18l-56.18-11.72a.24.24 0 0 1-.1-.05Z",
    id: "elwsprhmbbar",
    className: "animable",
    style: {
      transformOrigin: "409.395px 283.983px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.12 283.78a.45.45 0 0 1-.16-.2c0-.12 0-.2.12-.18l56.19 11.72a.4.4 0 0 1 .26.25c0 .12 0 .2-.12.18l-56.18-11.72a.16.16 0 0 1-.11-.05Z",
    id: "el5fqcpym7ldj",
    className: "animable",
    style: {
      transformOrigin: "408.245px 289.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 289.28a.39.39 0 0 1-.15-.21c0-.12 0-.2.12-.18l56.18 11.72a.41.41 0 0 1 .27.26c0 .12 0 .2-.13.17l-56.18-11.71Z",
    id: "el68hqbpav7la",
    className: "animable",
    style: {
      transformOrigin: "407.135px 294.967px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.83 294.77a.43.43 0 0 1-.1-.09.35.35 0 0 1-.07-.22l4.58-22a.11.11 0 0 1 .13-.08l56.19 11.72a.43.43 0 0 1 .2.14.3.3 0 0 1 .07.22l-4.58 22a.1.1 0 0 1-.13.08l-56.19-11.72a.24.24 0 0 1-.1-.05Zm4.8-21.9-4.5 21.59 55.73 11.62 4.51-21.59Z",
    id: "elqd25ltzdo1o",
    className: "animable",
    style: {
      transformOrigin: "408.245px 289.461px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.22 291.5c.54.9 1.53 1.54 3.78 1.63 1.4.06 1.46.68 1.62 1.69a5 5 0 0 0 2.17 3.51c-1.45-.33-6.58-2.78-7.57-6.83Z",
    style: {
      opacity: 0.2,
      transformOrigin: "379.005px 294.915px"
    },
    className: "animable",
    id: "el6zleoyfvmr7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12 289.48c-.41 2 1.61 3.32 3 3.72s1.65.66 1.84 1.62 1.51 3.4 5 4.13c-1.72-.35-5.18-1.08-7.57-3.4s-2.68-4.08-2.27-6.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "379.963px 294.215px"
    },
    id: "el7mgaitg69a9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12 289.48c-.41 2 1.61 3.32 3 3.72s1.65.66 1.84 1.62 1.51 3.4 5 4.13c-1.72-.35-5.18-1.08-7.57-3.4s-2.68-4.08-2.27-6.07Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "379.963px 294.215px"
    },
    className: "animable",
    id: "elhmop18prhgr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.15 309.21 3-14.15-30.72 9 27 5.63a.62.62 0 0 0 .72-.48Z",
    style: {
      opacity: 0.2,
      transformOrigin: "424.79px 302.38px"
    },
    className: "animable",
    id: "elmepni38rziq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.06 327.61a11.37 11.37 0 0 1-1.8 2.75c-1.5 1.63-1.1 1.66-.57 3.78a8.91 8.91 0 0 1 .17 3l2.52-.73a20.33 20.33 0 0 0 1.23-3.52Zm.88-10.73-.14-.48a.24.24 0 0 0 0-.08l-7.25-24.83a.62.62 0 0 0-.79-.4l-60.9 17.81a.63.63 0 0 0-.45.77l13.29 45.56a.63.63 0 0 0 .8.39l49.19-14.39.28-.08a8.62 8.62 0 0 0 5.15-4.22c.09-.16.17-.32.25-.48a20.33 20.33 0 0 0 1.23-3.52c0-.13.07-.27.11-.4s.08-.3.11-.46c.88-3.62.84-9.07-.88-15.19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "438.888px 323.356px"
    },
    id: "elybwyfra4pro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.06 327.61a11.37 11.37 0 0 1-1.8 2.75c-1.5 1.63-1.1 1.66-.57 3.78a8.91 8.91 0 0 1 .17 3l2.52-.73a20.33 20.33 0 0 0 1.23-3.52Zm.88-10.73-.14-.48a.24.24 0 0 0 0-.08l-7.25-24.83a.62.62 0 0 0-.79-.4l-60.9 17.81a.63.63 0 0 0-.45.77l13.29 45.56a.63.63 0 0 0 .8.39l49.19-14.39.28-.08a8.62 8.62 0 0 0 5.15-4.22c.09-.16.17-.32.25-.48a20.33 20.33 0 0 0 1.23-3.52c0-.13.07-.27.11-.4s.08-.3.11-.46c.88-3.62.84-9.07-.88-15.19Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "438.888px 323.356px"
    },
    className: "animable",
    id: "el80rvko15q85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.44 298-62.14 18.2-1.91-6.53a.54.54 0 0 1 .06-.45.63.63 0 0 1 .4-.31l60.89-17.82a.65.65 0 0 1 .76.3v.07l.12.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "435.403px 303.63px"
    },
    id: "el1jj1ivlywgwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.44 298-62.14 18.2-1.91-6.53a.54.54 0 0 1 .06-.45.63.63 0 0 1 .4-.31l60.89-17.82a.65.65 0 0 1 .76.3v.07l.12.43Z",
    style: {
      opacity: 0.2,
      transformOrigin: "435.403px 303.63px"
    },
    className: "animable",
    id: "elsbyjhzb1xnn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31 310.53a1.24 1.24 0 1 1 1.47.67 1.16 1.16 0 0 1-1.47-.67Z",
    style: {
      fill: "#263238",
      transformOrigin: "410.435px 310.018px"
    },
    id: "elpmu78ch7gmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.53 308.13a1.23 1.23 0 1 1 1.47.67 1.16 1.16 0 0 1-1.47-.67Z",
    style: {
      fill: "#263238",
      transformOrigin: "418.65px 307.629px"
    },
    id: "el7hwv7417flj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.73 305.73a1.16 1.16 0 0 1 .88-1.36 1.07 1.07 0 1 1-.88 1.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "426.767px 305.43px"
    },
    id: "elte9jrdkqxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.14 300.93a1.24 1.24 0 1 1 1.47.67 1.16 1.16 0 0 1-1.47-.67Z",
    style: {
      fill: "#263238",
      transformOrigin: "443.265px 300.418px"
    },
    id: "elfx1dcc7opyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.36 298.52a1.23 1.23 0 1 1 1.47.68 1.14 1.14 0 0 1-1.47-.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "451.484px 298.031px"
    },
    id: "elz6fzo1gsyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.51 296.22a1.23 1.23 0 0 1 2.34-.68 1.23 1.23 0 0 1-2.34.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "459.68px 295.88px"
    },
    id: "elrcu0m7nhvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "437.49px 310.95px",
      transform: "rotate(-16.28deg)"
    },
    className: "animable",
    d: "M405.12 306.94h64.74v8.02h-64.74z",
    id: "ellz677h8aewh"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "437.49px 310.95px"
    },
    className: "animable",
    id: "el7asmtjoz0mg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "437.49px 310.95px",
      transform: "rotate(-16.28deg)"
    },
    className: "animable",
    d: "M405.12 306.94h64.74v8.02h-64.74z",
    id: "el0tt9b7a9irr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.28 312.86a2.31 2.31 0 0 1 .79-.11 1.64 1.64 0 0 1 .64.17 1.58 1.58 0 0 1 .48.42 2.27 2.27 0 0 1 .33.64 8.7 8.7 0 0 1 .26.87 2.29 2.29 0 0 1 .06.72 1.55 1.55 0 0 1-.18.61 1.4 1.4 0 0 1-.43.48 2.47 2.47 0 0 1-.71.34l-1.49.43a.15.15 0 0 1-.13 0 .16.16 0 0 1-.08-.1l-1.12-3.83a.13.13 0 0 1 0-.12.12.12 0 0 1 .09-.08Zm1.45 1.35a1.48 1.48 0 0 0-.18-.33.75.75 0 0 0-.27-.23.8.8 0 0 0-.36-.1 1.32 1.32 0 0 0-.46.06l-.79.23.78 2.67.82-.25a1.06 1.06 0 0 0 .4-.19.82.82 0 0 0 .34-.61 1.16 1.16 0 0 0 0-.37 8.84 8.84 0 0 0-.28-.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "423.766px 315.097px"
    },
    id: "elkz8ka303hvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.57 314.71a.19.19 0 0 1 .13 0 .14.14 0 0 1 .08.1l.12.42a.13.13 0 0 1 0 .12.16.16 0 0 1-.1.08l-2.6.76a.13.13 0 0 1-.12 0 .14.14 0 0 1-.08-.1l-1.12-3.83a.13.13 0 0 1 0-.12.16.16 0 0 1 .1-.08l2.55-.75a.15.15 0 0 1 .13 0 .14.14 0 0 1 .08.09l.12.42a.16.16 0 0 1-.11.21l-1.91.56.27.94 1.78-.52a.15.15 0 0 1 .13 0 .14.14 0 0 1 .08.09l.12.43a.13.13 0 0 1 0 .12.16.16 0 0 1-.1.08l-1.78.52.29 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "427.89px 313.75px"
    },
    id: "el9v5ep8ln1h8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.81 313.14a.15.15 0 0 1 0-.13.14.14 0 0 1 .1-.07l.48-.14a.17.17 0 0 1 .12 0 .12.12 0 0 1 .08.1 1.3 1.3 0 0 1 0 .52 1.17 1.17 0 0 1-.19.53 1.53 1.53 0 0 1-.44.48 2.18 2.18 0 0 1-.75.36 2.08 2.08 0 0 1-.76.09 1.5 1.5 0 0 1-.63-.19 1.6 1.6 0 0 1-.49-.41 2.47 2.47 0 0 1-.34-.62l-.16-.49-.13-.5a2.43 2.43 0 0 1-.05-.7 1.73 1.73 0 0 1 .19-.62 1.59 1.59 0 0 1 .44-.5 2.05 2.05 0 0 1 .68-.33 2.26 2.26 0 0 1 .82-.1 1.72 1.72 0 0 1 .64.16 1.18 1.18 0 0 1 .44.35 1.58 1.58 0 0 1 .27.44.15.15 0 0 1 0 .13.16.16 0 0 1-.1.08l-.48.14h-.12a.19.19 0 0 1-.1-.1.62.62 0 0 0-.15-.21.82.82 0 0 0-.24-.15 1 1 0 0 0-.32-.06 1.64 1.64 0 0 0-.42.06 1.13 1.13 0 0 0-.38.19.77.77 0 0 0-.33.61 1.16 1.16 0 0 0 0 .37c0 .15.08.32.13.5s.11.35.16.5a1.06 1.06 0 0 0 .18.33 1 1 0 0 0 .26.23.9.9 0 0 0 .34.1 1 1 0 0 0 .42 0 1.57 1.57 0 0 0 .39-.18 1.06 1.06 0 0 0 .24-.23.64.64 0 0 0 .12-.25.58.58 0 0 0 .08-.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "431.63px 312.65px"
    },
    id: "elkzknwcv8yc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.24 312.47a.16.16 0 0 1 .13 0 .16.16 0 0 1 .08.1l.12.42a.13.13 0 0 1 0 .12.14.14 0 0 1-.09.08l-2.6.76a.19.19 0 0 1-.13 0 .16.16 0 0 1-.08-.1l-1.14-3.85a.13.13 0 0 1 0-.12.12.12 0 0 1 .1-.08l2.54-.75a.16.16 0 0 1 .21.11l.12.42a.15.15 0 0 1 0 .13.14.14 0 0 1-.1.08l-1.91.56.28.94 1.78-.52a.17.17 0 0 1 .12 0 .15.15 0 0 1 .08.1l.13.42a.15.15 0 0 1 0 .13.14.14 0 0 1-.1.08l-1.78.52.29 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "435.55px 311.501px"
    },
    id: "el6nkz79qz2ls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.7 310.35.55-2.28.05-.12a.26.26 0 0 1 .16-.12l.4-.11a.13.13 0 0 1 .12 0 .15.15 0 0 1 .09.1l1.12 3.82a.19.19 0 0 1 0 .13.16.16 0 0 1-.1.08l-.48.14a.13.13 0 0 1-.12 0 .16.16 0 0 1-.08-.1l-.68-2.32-.38 1.56a.34.34 0 0 1-.06.12.14.14 0 0 1-.12.09l-.3.09a.18.18 0 0 1-.16 0l-.11-.07-1.16-1.11.68 2.32a.17.17 0 0 1 0 .12.19.19 0 0 1-.1.08l-.48.14a.15.15 0 0 1-.13 0 .2.2 0 0 1-.08-.1l-1.15-3.81a.17.17 0 0 1 0-.12.14.14 0 0 1 .1-.08l.4-.12a.24.24 0 0 1 .19 0l.11.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "439.685px 310.315px"
    },
    id: "elxovrddjk24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31 311.5a.13.13 0 0 1-.12 0 .14.14 0 0 1-.08-.09l-1.11-3.85a.16.16 0 0 1 .11-.21l1.75-.51a1.62 1.62 0 0 1 .67-.07 1.24 1.24 0 0 1 .49.17 1.22 1.22 0 0 1 .56 1 1.08 1.08 0 0 1-.05.27 1.29 1.29 0 0 1-.09.2.48.48 0 0 1-.08.12 1.37 1.37 0 0 1 .44.26 1 1 0 0 1 .32.53 1.48 1.48 0 0 1 .05.47 1.1 1.1 0 0 1-.13.47 1.2 1.2 0 0 1-.31.41 1.35 1.35 0 0 1-.52.27Zm1.42-3.62a.42.42 0 0 0-.24-.3.73.73 0 0 0-.48 0l-1.05.3.26.92 1-.31a.7.7 0 0 0 .42-.25.44.44 0 0 0 .09-.36Zm-1 2.69 1.09-.32a.73.73 0 0 0 .44-.28.48.48 0 0 0 0-.41.49.49 0 0 0-.26-.32.74.74 0 0 0-.51 0l-1.1.32Z",
    style: {
      fill: "#455a64",
      transformOrigin: "444.081px 309.138px"
    },
    id: "elfd9s2gr5n79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.76 308.81a.17.17 0 0 1 .12 0 .19.19 0 0 1 .08.1l.12.42a.15.15 0 0 1 0 .13.14.14 0 0 1-.1.08l-2.6.76a.17.17 0 0 1-.12 0 .19.19 0 0 1-.08-.1l-1.12-3.83a.16.16 0 0 1 .11-.21l2.55-.74a.19.19 0 0 1 .13 0 .16.16 0 0 1 .08.1l.12.42a.2.2 0 0 1 0 .13.16.16 0 0 1-.1.08l-1.91.56.27.94 1.78-.52a.16.16 0 0 1 .21.11l.12.42a.15.15 0 0 1 0 .13.16.16 0 0 1-.1.08l-1.78.52.29 1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "448.073px 307.86px"
    },
    id: "elod6e1619me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.34 304.65a1.74 1.74 0 0 1 1.22 0 1.28 1.28 0 0 1 .67.85 1.42 1.42 0 0 1 0 .79 1.3 1.3 0 0 1-.45.62l1.24 1.23v.06a.17.17 0 0 1 0 .1.16.16 0 0 1-.09.07l-.5.14a.21.21 0 0 1-.19 0l-.11-.08-1.13-1.14-.78.23.4 1.38a.13.13 0 0 1 0 .12.14.14 0 0 1-.1.08l-.47.14a.15.15 0 0 1-.13 0 .16.16 0 0 1-.08-.1l-1.12-3.83a.17.17 0 0 1 0-.12.15.15 0 0 1 .1-.08Zm-.34 2.13.86-.26a1 1 0 0 0 .5-.27.51.51 0 0 0 .07-.51.5.5 0 0 0-.33-.39 1.17 1.17 0 0 0-.57 0l-.86.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "451.868px 306.897px"
    },
    id: "elbeao1zfckif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.89 326.48a.89.89 0 0 0 1.17.49l4.67-1.36a.82.82 0 1 0-.45-1.54l-4.67 1.37a.91.91 0 0 0-.72 1.04Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "416.183px 325.506px"
    },
    id: "elrol5l1q0zvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76 324.18a.89.89 0 0 0 1.17.49l4.66-1.36a.82.82 0 1 0-.45-1.54l-4.66 1.36a.91.91 0 0 0-.72 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "424.047px 323.206px"
    },
    id: "el0hwavmfxgqxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62 321.88a.91.91 0 0 0 1.17.49l4.67-1.36a.82.82 0 1 0-.45-1.54l-4.67 1.36a.92.92 0 0 0-.72 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "431.913px 320.903px"
    },
    id: "elk7qht4hk6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.49 319.58a.91.91 0 0 0 1.17.49l4.66-1.36a.82.82 0 1 0-.45-1.54l-4.66 1.36a.91.91 0 0 0-.72 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "439.777px 318.603px"
    },
    id: "el4jug8df8rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.35 317.28a.92.92 0 0 0 1.17.49l4.67-1.36a.82.82 0 1 0-.45-1.54l-4.66 1.36a.91.91 0 0 0-.73 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "447.642px 316.301px"
    },
    id: "elf7hl15vybo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.22 315a.91.91 0 0 0 1.17.49l4.66-1.36a.92.92 0 0 0 .73-1.05.91.91 0 0 0-1.18-.49l-4.66 1.36a.9.9 0 0 0-.72 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "455.498px 314.038px"
    },
    id: "elyippnl69wf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.08 312.68a.92.92 0 0 0 1.18.49l4.66-1.37a.82.82 0 1 0-.45-1.53l-4.66 1.36a.91.91 0 0 0-.73 1.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "463.382px 311.697px"
    },
    id: "elddqsc0xi9cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "443.48px 333.245px"
    },
    className: "animable",
    id: "elui5spatu8sp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.83 332.06c0 .16-.07.31-.11.46s-.07.27-.11.4l-1.55-5.31-3.79-12.94-.08-.28c0-.09.06-.15.19-.13h.1a.3.3 0 0 1 .17.16l3.69 12.58Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "471.01px 323.588px"
    },
    id: "elc7cus84965f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.91 338.42a.37.37 0 0 1-.29-.19l-6.3-21.55c0-.09.06-.15.2-.13a.37.37 0 0 1 .29.19l6.3 21.55c.03.09-.06.15-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "463.718px 327.485px"
    },
    id: "el3jyk5spibks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05 340.72a.35.35 0 0 1-.3-.19l-6.3-21.53c0-.09.06-.15.2-.13a.38.38 0 0 1 .29.2l6.3 21.54c.03.07-.06.13-.19.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "455.848px 329.795px"
    },
    id: "elt88jsa8p7w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.18 343a.38.38 0 0 1-.3-.2l-6.3-21.54c0-.09.06-.15.2-.14s.27.11.29.2l6.3 21.54c.03.14-.06.14-.19.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "447.978px 332.059px"
    },
    id: "elpo0nje3z12k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31 345.33a.38.38 0 0 1-.3-.2l-6.3-21.54c0-.09.06-.15.2-.14s.27.11.29.2l6.31 21.54c.02.09-.07.15-.2.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "440.111px 334.39px"
    },
    id: "eltlgucwfqose",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44 347.63a.38.38 0 0 1-.3-.2l-6.3-21.54c0-.09.06-.15.2-.13a.32.32 0 0 1 .29.19l6.31 21.55c.02.09-.07.15-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "432.241px 336.695px"
    },
    id: "elqq69lwaxfpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57 349.93a.37.37 0 0 1-.3-.19L421 328.19c0-.09.06-.15.2-.13s.27.1.29.19l6.31 21.55c-.01.09-.1.2-.23.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "424.4px 339.004px"
    },
    id: "elrcn1m1o2mzr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.7 352.23a.32.32 0 0 1-.29-.19l-6.31-21.55c0-.09.06-.15.2-.13s.27.1.29.2l6.31 21.54c.02.09-.06.15-.2.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "416.502px 341.295px"
    },
    id: "el7j4dyptgupp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 336.07a.48.48 0 0 1-.23-.1c-.1-.09-.09-.19 0-.22l55.08-16.11a.41.41 0 0 1 .36.1c.09.09.08.18 0 .21l-55.08 16.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "442.486px 327.851px"
    },
    id: "elajdnhw7aa3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55 341.46a.41.41 0 0 1-.24-.11c-.09-.08-.08-.18 0-.21L471.42 325a.37.37 0 0 1 .35.1c.09.09.08.18 0 .21l-55.09 16.11a.2.2 0 0 1-.13.04Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "444.04px 333.225px"
    },
    id: "elvfvem5z97b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.12 346.85a.41.41 0 0 1-.23-.11c-.1-.09-.08-.18 0-.21L473 330.41a.44.44 0 0 1 .36.1c.09.09.08.19 0 .22l-55.08 16.11Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "445.623px 338.627px"
    },
    id: "elqs9rc3m0qf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.34 327-3.66-12.52a.3.3 0 0 0-.17-.16H468.3l-55.09 16.12a.09.09 0 0 0-.08.12L419.4 352a.32.32 0 0 0 .17.15.33.33 0 0 0 .13 0 .25.25 0 0 0 .12 0l50-14.61 2.34-.69c.09-.16.17-.32.25-.48l-2.52.73-50.05 14.64-6.19-21.16 54.65-16 3.79 12.94 1.55 5.31c0-.13.07-.27.11-.4s.08-.3.11-.46Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "443.492px 333.239px"
    },
    id: "el1ornig2jys9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "443.48px 333.245px"
    },
    className: "animable",
    id: "elhpjzallf3lq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.83 332.06c0 .16-.07.31-.11.46s-.07.27-.11.4l-1.55-5.31-3.79-12.94-.08-.28c0-.09.06-.15.19-.13h.1a.3.3 0 0 1 .17.16l3.69 12.58Z",
    id: "eln0emgw35e",
    className: "animable",
    style: {
      transformOrigin: "471.01px 323.588px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.91 338.42a.37.37 0 0 1-.29-.19l-6.3-21.55c0-.09.06-.15.2-.13a.37.37 0 0 1 .29.19l6.3 21.55c.03.09-.06.15-.2.13Z",
    id: "elt9hpj37jr2i",
    className: "animable",
    style: {
      transformOrigin: "463.718px 327.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05 340.72a.35.35 0 0 1-.3-.19l-6.3-21.53c0-.09.06-.15.2-.13a.38.38 0 0 1 .29.2l6.3 21.54c.03.07-.06.13-.19.11Z",
    id: "elxe5aqiscj0g",
    className: "animable",
    style: {
      transformOrigin: "455.848px 329.795px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.18 343a.38.38 0 0 1-.3-.2l-6.3-21.54c0-.09.06-.15.2-.14s.27.11.29.2l6.3 21.54c.03.14-.06.14-.19.14Z",
    id: "elldi1xj4h2e",
    className: "animable",
    style: {
      transformOrigin: "447.978px 332.059px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31 345.33a.38.38 0 0 1-.3-.2l-6.3-21.54c0-.09.06-.15.2-.14s.27.11.29.2l6.31 21.54c.02.09-.07.15-.2.14Z",
    id: "elqdojjdrc0xq",
    className: "animable",
    style: {
      transformOrigin: "440.111px 334.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44 347.63a.38.38 0 0 1-.3-.2l-6.3-21.54c0-.09.06-.15.2-.13a.32.32 0 0 1 .29.19l6.31 21.55c.02.09-.07.15-.2.13Z",
    id: "elmvaij3c8cik",
    className: "animable",
    style: {
      transformOrigin: "432.241px 336.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57 349.93a.37.37 0 0 1-.3-.19L421 328.19c0-.09.06-.15.2-.13s.27.1.29.19l6.31 21.55c-.01.09-.1.2-.23.13Z",
    id: "ela5nv5vj21pd",
    className: "animable",
    style: {
      transformOrigin: "424.4px 339.004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.7 352.23a.32.32 0 0 1-.29-.19l-6.31-21.55c0-.09.06-.15.2-.13s.27.1.29.2l6.31 21.54c.02.09-.06.15-.2.13Z",
    id: "elrybv7qzprh",
    className: "animable",
    style: {
      transformOrigin: "416.502px 341.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 336.07a.48.48 0 0 1-.23-.1c-.1-.09-.09-.19 0-.22l55.08-16.11a.41.41 0 0 1 .36.1c.09.09.08.18 0 .21l-55.08 16.12Z",
    id: "elb93ewv102i8",
    className: "animable",
    style: {
      transformOrigin: "442.486px 327.851px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55 341.46a.41.41 0 0 1-.24-.11c-.09-.08-.08-.18 0-.21L471.42 325a.37.37 0 0 1 .35.1c.09.09.08.18 0 .21l-55.09 16.11a.2.2 0 0 1-.13.04Z",
    id: "el67smh1z6f0h",
    className: "animable",
    style: {
      transformOrigin: "444.04px 333.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.12 346.85a.41.41 0 0 1-.23-.11c-.1-.09-.08-.18 0-.21L473 330.41a.44.44 0 0 1 .36.1c.09.09.08.19 0 .22l-55.08 16.11Z",
    id: "el2c6ij8qyukg",
    className: "animable",
    style: {
      transformOrigin: "445.623px 338.627px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.34 327-3.66-12.52a.3.3 0 0 0-.17-.16H468.3l-55.09 16.12a.09.09 0 0 0-.08.12L419.4 352a.32.32 0 0 0 .17.15.33.33 0 0 0 .13 0 .25.25 0 0 0 .12 0l50-14.61 2.34-.69c.09-.16.17-.32.25-.48l-2.52.73-50.05 14.64-6.19-21.16 54.65-16 3.79 12.94 1.55 5.31c0-.13.07-.27.11-.4s.08-.3.11-.46Z",
    id: "elt3c5pnph64p",
    className: "animable",
    style: {
      transformOrigin: "443.492px 333.239px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.66 323.36c0 2-1.67 4.69-3.13 5.89s-2.7 2-2.35 3.15 1.37 3.35 1 5.38-.77 2.51-1.79 3.17c1.4-.41 4.22-3.42 5-6.32a44.93 44.93 0 0 0 1.27-11.27Z",
    style: {
      opacity: 0.2,
      transformOrigin: "470.527px 332.155px"
    },
    className: "animable",
    id: "elo0z7nju642h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.78 316.32c1.53 5.23.33 10.91-2.52 14-1.5 1.64-1.1 1.66-.57 3.78.38 1.55.78 6-3 7.1 4.89-1.43 6-5 7.05-8.72s.99-9.48-.96-16.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "470.554px 328.76px"
    },
    id: "elmqw65kkeq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.78 316.32c1.53 5.23.33 10.91-2.52 14-1.5 1.64-1.1 1.66-.57 3.78.38 1.55.78 6-3 7.1 4.89-1.43 6-5 7.05-8.72s.99-9.48-.96-16.16Z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "470.554px 328.76px"
    },
    className: "animable",
    id: "ele70bfyupnhp"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-103",
    className: "animable",
    style: {
      transformOrigin: "106.631px 392.329px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-103",
    className: "animable",
    style: {
      transformOrigin: "106.631px 392.329px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "113.014px 387.387px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.18 413.5a22.57 22.57 0 0 0 2.22-.79c2.66-1.2 5.21-4.11 7.44-6.83 1.47-1.79 3.44-4.22 3.67-6.79a3.55 3.55 0 0 0-1.34-3.33c-1.08-.65-2.58-.23-3.43-1.24 1.33-2.35 3.87-3.72 4.67-6.37a11.07 11.07 0 0 0-.15-6.14 5.55 5.55 0 0 0-2.07-3.27c-1.19-.66-2.54.13-3.66.85a2.37 2.37 0 0 1-1 .42.86.86 0 0 1-.88-.49 1.53 1.53 0 0 1 .25-1.34c.49-.84 1.09-1.62 1.54-2.5a5.06 5.06 0 0 0 .62-2.94 6.52 6.52 0 0 0-1.68-3.13 52.83 52.83 0 0 0-4-4.4 41 41 0 0 1-3.31-4c-4.1 2.21-7.61 5.89-10.47 9.83-1.6 2.19-3.66 5.75-2.87 8.86a6 6 0 0 0 1.25 2.31 9.15 9.15 0 0 0 .86.79c.18.17.89.79.23.8a.81.81 0 0 1-.42-.14l-3.56-1.95a2 2 0 0 0-1.12-.35c-.82.09-2.06 1.7-2.61 4.51a9.81 9.81 0 0 0 .83 5.61 24.28 24.28 0 0 0 5.28 7l-2.82-1c-3.29-1.13-1 4.3-.42 5.35a26.74 26.74 0 0 0 7.5 7.93c3.03 1.89 6.12 3.1 9.45 2.74Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "113.014px 387.387px"
    },
    id: "elif15mn4trx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.18 413.5a22.57 22.57 0 0 0 2.22-.79c2.66-1.2 5.21-4.11 7.44-6.83 1.47-1.79 3.44-4.22 3.67-6.79a3.55 3.55 0 0 0-1.34-3.33c-1.08-.65-2.58-.23-3.43-1.24 1.33-2.35 3.87-3.72 4.67-6.37a11.07 11.07 0 0 0-.15-6.14 5.55 5.55 0 0 0-2.07-3.27c-1.19-.66-2.54.13-3.66.85a2.37 2.37 0 0 1-1 .42.86.86 0 0 1-.88-.49 1.53 1.53 0 0 1 .25-1.34c.49-.84 1.09-1.62 1.54-2.5a5.06 5.06 0 0 0 .62-2.94 6.52 6.52 0 0 0-1.68-3.13 52.83 52.83 0 0 0-4-4.4 41 41 0 0 1-3.31-4c-4.1 2.21-7.61 5.89-10.47 9.83-1.6 2.19-3.66 5.75-2.87 8.86a6 6 0 0 0 1.25 2.31 9.15 9.15 0 0 0 .86.79c.18.17.89.79.23.8a.81.81 0 0 1-.42-.14l-3.56-1.95a2 2 0 0 0-1.12-.35c-.82.09-2.06 1.7-2.61 4.51a9.81 9.81 0 0 0 .83 5.61 24.28 24.28 0 0 0 5.28 7l-2.82-1c-3.29-1.13-1 4.3-.42 5.35a26.74 26.74 0 0 0 7.5 7.93c3.03 1.89 6.12 3.1 9.45 2.74Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "113.014px 387.387px"
    },
    className: "animable",
    id: "el5a7e6j4u7rv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.06 398a32.34 32.34 0 0 0-10.69-9.25l-.09-.06a.42.42 0 0 1-.16-.52.32.32 0 0 1 .46-.17l.09.05a33.7 33.7 0 0 1 10.19 8.54c-1.55-12-.87-25.39.94-30.35a.35.35 0 0 1 .48-.21.47.47 0 0 1 .2.55c-1.79 4.89-2.45 18.09-.91 29.95a20.94 20.94 0 0 1 10-10.26.34.34 0 0 1 .44.24.41.41 0 0 1-.06.39.36.36 0 0 1-.14.11 20.25 20.25 0 0 0-10 10.84c.81 5.58 2.13 10.78 4.07 14.55a.43.43 0 0 1 0 .44.33.33 0 0 1-.11.13.35.35 0 0 1-.5-.16c-2.05-3.81-3.39-9.13-4.21-14.81Z",
    style: {
      fill: "#fff",
      transformOrigin: "112.06px 389.509px"
    },
    id: "el5xmlz5q44qp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "102.611px 407.545px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 418.51c-.14.18-1.44 1.25-1.62 1.39-2.12 1.57-5.36 2.36-8.31 3-2 .41-4.58.95-6.46.09a2.59 2.59 0 0 1-1.64-2.38c.08-1.1 1.09-2.09.81-3.16-2.26.08-4.44 1.49-6.66 1a7.83 7.83 0 0 1-4.15-2.6 4.23 4.23 0 0 1-1.24-2.93c.07-1.16 1.27-1.92 2.27-2.46a2.3 2.3 0 0 0 .74-.57.79.79 0 0 0 .1-.88 1.14 1.14 0 0 0-1-.34c-.82 0-1.64.18-2.47.17a3.61 3.61 0 0 1-2.32-.71 4.82 4.82 0 0 1-1.34-2.56 41.47 41.47 0 0 1-1.08-4.89 32.13 32.13 0 0 0-1.14-4.18 30.26 30.26 0 0 1 11.85-4.11c2.28-.34 5.73-.5 7.49 1.37a4.33 4.33 0 0 1 1 1.9 6.71 6.71 0 0 1 .13 1c0 .21.12 1 .45.5a.83.83 0 0 0 .1-.38c.13-1.18.26-2.36.38-3.54a2 2 0 0 1 .31-1c.46-.59 2.17-.9 4.37-.18a6.91 6.91 0 0 1 3.46 2.9 19.2 19.2 0 0 1 2.28 6.93c.24-.86.47-1.71.7-2.57.82-3 3.48.93 3.89 1.84a21.75 21.75 0 0 1 1.83 9 15 15 0 0 1-2.73 8.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "102.611px 407.545px"
    },
    id: "elhlwfvpjto2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 418.51c-.14.18-1.44 1.25-1.62 1.39-2.12 1.57-5.36 2.36-8.31 3-2 .41-4.58.95-6.46.09a2.59 2.59 0 0 1-1.64-2.38c.08-1.1 1.09-2.09.81-3.16-2.26.08-4.44 1.49-6.66 1a7.83 7.83 0 0 1-4.15-2.6 4.23 4.23 0 0 1-1.24-2.93c.07-1.16 1.27-1.92 2.27-2.46a2.3 2.3 0 0 0 .74-.57.79.79 0 0 0 .1-.88 1.14 1.14 0 0 0-1-.34c-.82 0-1.64.18-2.47.17a3.61 3.61 0 0 1-2.32-.71 4.82 4.82 0 0 1-1.34-2.56 41.47 41.47 0 0 1-1.08-4.89 32.13 32.13 0 0 0-1.14-4.18 30.26 30.26 0 0 1 11.85-4.11c2.28-.34 5.73-.5 7.49 1.37a4.33 4.33 0 0 1 1 1.9 6.71 6.71 0 0 1 .13 1c0 .21.12 1 .45.5a.83.83 0 0 0 .1-.38c.13-1.18.26-2.36.38-3.54a2 2 0 0 1 .31-1c.46-.59 2.17-.9 4.37-.18a6.91 6.91 0 0 1 3.46 2.9 19.2 19.2 0 0 1 2.28 6.93c.24-.86.47-1.71.7-2.57.82-3 3.48.93 3.89 1.84a21.75 21.75 0 0 1 1.83 9 15 15 0 0 1-2.73 8.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "102.611px 407.545px"
    },
    className: "animable",
    id: "elxfmjpy0qg1o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.28 409.05a27.82 27.82 0 0 1-1.2-12V397a.3.3 0 0 0-.28-.33.31.31 0 0 0-.34.28v.05a29.16 29.16 0 0 0 .94 11.34c-7.53-6.07-17.07-10.95-21.36-11.56a.33.33 0 1 0-.09.65c4.23.6 13.65 5.44 21.07 11.43a19.06 19.06 0 0 0-11.9 3.54.31.31 0 0 0-.05.44.32.32 0 0 0 .3.11.27.27 0 0 0 .14-.07 18.34 18.34 0 0 1 12.33-3.35 33.89 33.89 0 0 1 8 9 .34.34 0 0 0 .31.17.25.25 0 0 0 .14 0 .33.33 0 0 0 .13-.45 34.52 34.52 0 0 0-8.14-9.2Z",
    style: {
      fill: "#fff",
      transformOrigin: "103.046px 407.689px"
    },
    id: "ell3r2ctmfkdj",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-103",
    className: "animable",
    style: {
      transformOrigin: "244.162px 313.004px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar--inject-103",
    className: "animable",
    style: {
      transformOrigin: "244.162px 313.004px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.83 421.49a3.11 3.11 0 0 1-1.3-3.19L148.77 280a5.73 5.73 0 0 1 2.39-3.25L337 169.46a4.12 4.12 0 0 1 3.7-.06 3.07 3.07 0 0 1 1.3 3.18l-31.21 138.28a5.75 5.75 0 0 1-2.39 3.25L122.53 421.42a4.09 4.09 0 0 1-3.7.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "229.766px 295.444px"
    },
    id: "elc0wtrp5f8vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83 421.49a3.11 3.11 0 0 1-1.3-3.19L148.77 280a5.73 5.73 0 0 1 2.39-3.25L337 169.46a4.12 4.12 0 0 1 3.7-.06 3.07 3.07 0 0 1 1.3 3.18l-31.21 138.28a5.75 5.75 0 0 1-2.39 3.25L122.53 421.42a4.09 4.09 0 0 1-3.7.07Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "229.766px 295.444px"
    },
    className: "animable",
    id: "elkhdw2vyrhrm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.35 282.09-31.24 138.28c-.27 1.19.37 1.66 1.42 1.05L308.4 314.11a5.75 5.75 0 0 0 2.39-3.25L342 172.58c.27-1.19-.37-1.66-1.42-1.05L154.74 278.84a5.8 5.8 0 0 0-2.39 3.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "231.555px 296.475px"
    },
    id: "eldbrmt70ltg5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.35 282.09-31.24 138.28c-.27 1.19.37 1.66 1.42 1.05L308.4 314.11a5.75 5.75 0 0 0 2.39-3.25L342 172.58c.27-1.19-.37-1.66-1.42-1.05L154.74 278.84a5.8 5.8 0 0 0-2.39 3.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "231.555px 296.475px"
    },
    className: "animable",
    id: "elxavighnfwi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.35 282.09-31.24 138.28c-.27 1.19.37 1.66 1.42 1.05L308.4 314.11a5.75 5.75 0 0 0 2.39-3.25L342 172.58c.27-1.19-.37-1.66-1.42-1.05L154.74 278.84a5.8 5.8 0 0 0-2.39 3.25Z",
    style: {
      opacity: 0.05,
      transformOrigin: "231.555px 296.475px"
    },
    className: "animable",
    id: "el3446etb0usa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31 171.46a4.09 4.09 0 0 0-3.7.07L154.74 278.84a3.53 3.53 0 0 0-1.6 3.28l24.44 171.28a5 5 0 0 0 2.1 3.21 4.07 4.07 0 0 0 3.69-.07l185.87-107.31a3.49 3.49 0 0 0 1.6-3.28l-24.43-171.27a5 5 0 0 0-2.1-3.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "261.991px 314.035px"
    },
    id: "elodllhbne8of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31 171.46a4.09 4.09 0 0 0-3.7.07L154.74 278.84a3.53 3.53 0 0 0-1.6 3.28l24.44 171.28a5 5 0 0 0 2.1 3.21 4.07 4.07 0 0 0 3.69-.07l185.87-107.31a3.49 3.49 0 0 0 1.6-3.28l-24.43-171.27a5 5 0 0 0-2.1-3.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "261.991px 314.035px"
    },
    className: "animable",
    id: "el8aqjrudmlmv"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.72 284.19 24.43 171.28a1.38 1.38 0 0 0 2.22 1.07l185.87-107.31a3.49 3.49 0 0 0 1.6-3.28l-24.43-171.27a1.38 1.38 0 0 0-2.22-1.08L158.32 280.91a3.53 3.53 0 0 0-1.6 3.28Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "263.781px 315.07px"
    },
    id: "eltc9r1becwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.72 284.19 24.43 171.28a1.38 1.38 0 0 0 2.22 1.07l185.87-107.31a3.49 3.49 0 0 0 1.6-3.28l-24.43-171.27a1.38 1.38 0 0 0-2.22-1.08L158.32 280.91a3.53 3.53 0 0 0-1.6 3.28Z",
    style: {
      fill: "#fff",
      opacity: 0.95,
      transformOrigin: "263.781px 315.07px"
    },
    className: "animable",
    id: "elbr9r1u2wa79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.27 402.13-21.83 12.59a3.21 3.21 0 0 0-1.34-.05l-25.74 5h-.08l47.57-27.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "145.775px 405.93px"
    },
    id: "el9c44gj6d9nd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.27 402.13-21.83 12.59a3.21 3.21 0 0 0-1.34-.05l-25.74 5h-.08l47.57-27.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "145.775px 405.93px"
    },
    className: "animable",
    id: "elfcblfxg7c8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.27 402.13-21.83 12.59a3.21 3.21 0 0 0-1.34-.05l-25.74 5h-.08l47.57-27.48Z",
    style: {
      opacity: 0.2,
      transformOrigin: "145.775px 405.93px"
    },
    className: "animable",
    id: "elbwcptzggnsk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.39 452.06-26.82-36.13a3.74 3.74 0 0 0-2-1.27l21.73-12.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.98px 427.095px"
    },
    id: "elsjeszie1upi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.39 452.06-26.82-36.13a3.74 3.74 0 0 0-2-1.27l21.73-12.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "162.98px 427.095px"
    },
    className: "animable",
    id: "elz11b68x794b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.39 452.06-26.82-36.13a3.74 3.74 0 0 0-2-1.27l21.73-12.53Z",
    style: {
      opacity: 0.1,
      transformOrigin: "162.98px 427.095px"
    },
    className: "animable",
    id: "elafyrus8pe1v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.54 453.75-25.94-33.7a4.12 4.12 0 0 0-3.52-1.43l-24.28 3.5a7.23 7.23 0 0 1-4-.72c-1-.57-.82-1.22.38-1.45l27.88-5.37a3.83 3.83 0 0 1 3.48 1.36l29.58 39.85c.73 1 .51 1.31-.47.74a13.08 13.08 0 0 1-3.11-2.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "149.352px 435.679px"
    },
    id: "elcx1xyppjaig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.54 453.75-25.94-33.7a4.12 4.12 0 0 0-3.52-1.43l-24.28 3.5a7.23 7.23 0 0 1-4-.72c-1-.57-.82-1.22.38-1.45l27.88-5.37a3.83 3.83 0 0 1 3.48 1.36l29.58 39.85c.73 1 .51 1.31-.47.74a13.08 13.08 0 0 1-3.11-2.78Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "149.352px 435.679px"
    },
    className: "animable",
    id: "elggqub7vuh5s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09 171.9a3 3 0 0 0-1.36-2.51 4.13 4.13 0 0 0-3.7.08L151.16 276.78a5.12 5.12 0 0 0-1.45 1.36 5.51 5.51 0 0 0-1 1.89l-4.4 19.53 3.58 2.06 189.73-109.51 4.38-19.53a2.81 2.81 0 0 0 .06-.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "243.2px 235.306px"
    },
    id: "elz7adeaod0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 172.58c.27-1.19-.37-1.66-1.42-1.05L154.74 278.84a5.8 5.8 0 0 0-2.39 3.25l-4.41 19.53L337.62 192.1Z",
    style: {
      opacity: 0.6,
      transformOrigin: "245.001px 236.441px"
    },
    className: "animable",
    id: "eluuc8a3w5829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28 280.21a5.08 5.08 0 0 0-.93 1.88l-4.41 19.53-3.58-2.06 4.4-19.53a5.26 5.26 0 0 1 1-1.89Z",
    style: {
      opacity: 0.5,
      transformOrigin: "148.82px 289.88px"
    },
    className: "animable",
    id: "elhz2kbe5y3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09 171.9c-.09-.66-.66-.84-1.48-.37L154.74 278.84a5.06 5.06 0 0 0-1.46 1.37l-3.57-2.07a5.12 5.12 0 0 1 1.45-1.36L337 169.46a4.16 4.16 0 0 1 3.7-.07 3 3 0 0 1 1.39 2.51Z",
    style: {
      opacity: 0.2,
      transformOrigin: "245.9px 224.6px"
    },
    className: "animable",
    id: "els3wwf5ir93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.64 176.32-.23-1.63c0-.08 0-.16-.05-.24s0-.05 0-.07a5 5 0 0 0-2-2.91 4.09 4.09 0 0 0-3.7.07l-185.92 107.3a3.3 3.3 0 0 0-1.28 1.47 3.35 3.35 0 0 0-.32 1.82l3.51 24.53 3.58 2.08 189.68-109.51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "251.516px 239.901px"
    },
    id: "elzpq115ybu4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.91 199.23-189.68 109.5-3.51-24.54a3.29 3.29 0 0 1 .32-1.82 3.39 3.39 0 0 1 1.28-1.46L344.19 173.6a1.35 1.35 0 0 1 2.13.7v.14a2.1 2.1 0 0 1 .06.24l.23 1.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "253.305px 241.022px"
    },
    className: "animable",
    id: "el9ivl36v1c3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.23 308.74-3.58-2.08-3.51-24.53a3.35 3.35 0 0 1 .32-1.82l3.59 2.06a3.2 3.2 0 0 0-.33 1.82Z",
    style: {
      opacity: 0.5,
      transformOrigin: "156.676px 294.525px"
    },
    className: "animable",
    id: "elxw8biavp8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.34 174.37a1.35 1.35 0 0 0-2.15-.77L158.32 280.91a3.31 3.31 0 0 0-1.27 1.46l-3.59-2.06a3.36 3.36 0 0 1 1.28-1.47l185.87-107.31a4.12 4.12 0 0 1 3.7-.07 5 5 0 0 1 2.03 2.91Z",
    style: {
      opacity: 0.3,
      transformOrigin: "249.9px 226.713px"
    },
    className: "animable",
    id: "ele5qnvayd7kh"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "252.485px 238.931px"
    },
    className: "animable",
    id: "el49h51sf0fy9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.77 284.39a6.36 6.36 0 0 1 3-5.88c2-1.15 3.82-.36 4.12 1.75a6.38 6.38 0 0 1-3 5.88c-1.98 1.14-3.82.36-4.12-1.75Z",
    id: "el9gw1c0alb",
    className: "animable",
    style: {
      transformOrigin: "177.33px 282.323px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.84 269.92a6.4 6.4 0 0 1 3-5.89c2-1.14 3.82-.35 4.12 1.75a6.36 6.36 0 0 1-3 5.89c-1.96 1.14-3.82.33-4.12-1.75Z",
    id: "elk8da8q75c0e",
    className: "animable",
    style: {
      transformOrigin: "202.401px 267.848px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88 255.46a6.37 6.37 0 0 1 3-5.89c2-1.14 3.82-.35 4.12 1.76a6.39 6.39 0 0 1-3 5.88c-2 1.14-3.82.36-4.12-1.75Z",
    id: "elcpjkx7xks8e",
    className: "animable",
    style: {
      transformOrigin: "227.439px 253.391px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 226.54a6.41 6.41 0 0 1 3-5.89c2-1.14 3.82-.35 4.12 1.76a6.37 6.37 0 0 1-3 5.88c-2 1.14-3.85.36-4.12-1.75Z",
    id: "els8rx2m23yz9",
    className: "animable",
    style: {
      transformOrigin: "277.56px 224.471px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05 212.07a6.36 6.36 0 0 1 3-5.89c2-1.14 3.82-.36 4.12 1.75a6.4 6.4 0 0 1-3 5.89c-1.98 1.18-3.82.35-4.12-1.75Z",
    id: "elo8941o26dd",
    className: "animable",
    style: {
      transformOrigin: "302.609px 210.008px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08 197.61a6.4 6.4 0 0 1 3-5.89c2-1.14 3.82-.35 4.12 1.75a6.38 6.38 0 0 1-3 5.89c-1.97 1.14-3.82.36-4.12-1.75Z",
    id: "elnro5ioqlcui",
    className: "animable",
    style: {
      transformOrigin: "327.64px 195.541px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.35 276.84a11.92 11.92 0 0 1-.19 2.17 9 9 0 0 1-.27 1.08 6.66 6.66 0 0 1-3 4 6.22 6.22 0 0 1-3.17.83 6.36 6.36 0 0 1-.87-.06c0-.15-.07-.3-.1-.47a5.43 5.43 0 0 1 .47-2.87 3.18 3.18 0 0 0 2-.35 4.09 4.09 0 0 0 1.69-3.12.8.8 0 0 0 0-.15c0-.31.05-.66.05-1.06a17.38 17.38 0 0 0-3.34-9.5 18.67 18.67 0 0 0-2.38-2.75 13.6 13.6 0 0 0-2.38-1.79c-1.83-1-3.51-1.27-4.65-.63s-1.78 2.21-1.78 4.34a13.24 13.24 0 0 0 .37 3l-3 1.74-.06-.2a16.84 16.84 0 0 1-.66-4.5c0-3.38 1.23-6 3.46-7.25s5.07-1.06 8 .63a17.24 17.24 0 0 1 3.7 3 23.45 23.45 0 0 1 2.26 2.82 20.84 20.84 0 0 1 3.85 11.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "170.715px 271.706px"
    },
    id: "elto00am2ss1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43 262.37a12.67 12.67 0 0 1-.19 2.16 9.64 9.64 0 0 1-.27 1.12 6.62 6.62 0 0 1-3 4 6.33 6.33 0 0 1-4 .78 3 3 0 0 1-.11-.47 5.42 5.42 0 0 1 .46-2.87 3.22 3.22 0 0 0 2-.35 4.1 4.1 0 0 0 1.7-3.12.77.77 0 0 1 0-.15 8.32 8.32 0 0 0 .06-1.06 17.32 17.32 0 0 0-3.35-9.5 17.12 17.12 0 0 0-2.37-2.75 13.18 13.18 0 0 0-2.39-1.79c-1.82-1-3.51-1.28-4.65-.63s-1.78 2.2-1.78 4.34a12.7 12.7 0 0 0 .38 3l-3 1.74-.06-.2a16.72 16.72 0 0 1-.66-4.49c0-3.39 1.23-6 3.47-7.25s5.07-1.06 8 .62a16.82 16.82 0 0 1 3.7 3 23.26 23.26 0 0 1 2.26 2.82 20.74 20.74 0 0 1 3.8 11.05Z",
    style: {
      fill: "#263238",
      transformOrigin: "195.815px 257.279px"
    },
    id: "eldl5bf7kqjwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46 247.91a12.88 12.88 0 0 1-.19 2.17 9.3 9.3 0 0 1-.27 1.1 6.66 6.66 0 0 1-3 4 6.38 6.38 0 0 1-4 .77 3 3 0 0 1-.11-.47 5.52 5.52 0 0 1 .46-2.87 3.15 3.15 0 0 0 2-.34 4.07 4.07 0 0 0 1.7-3.13v-.15a8.32 8.32 0 0 0 .06-1.06 17.31 17.31 0 0 0-3.35-9.49 18.12 18.12 0 0 0-2.37-2.76 13 13 0 0 0-2.39-1.79c-1.82-1-3.51-1.27-4.64-.62s-1.79 2.2-1.79 4.33a13.24 13.24 0 0 0 .37 3l-3 1.74v-.21a16.75 16.75 0 0 1-.67-4.49c0-3.38 1.23-6 3.47-7.25s5.07-1.06 8 .64a16.43 16.43 0 0 1 3.7 3 21.71 21.71 0 0 1 2.27 2.82 20.84 20.84 0 0 1 3.75 11.06Z",
    style: {
      fill: "#263238",
      transformOrigin: "220.865px 242.795px"
    },
    id: "el04kkmds01tcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56 219a11.92 11.92 0 0 1-.18 2.17 9.64 9.64 0 0 1-.27 1.12 6.71 6.71 0 0 1-3 4 6.25 6.25 0 0 1-3.16.82 6.35 6.35 0 0 1-.87 0 2.71 2.71 0 0 1-.11-.51 5.51 5.51 0 0 1 .44-2.84 3.18 3.18 0 0 0 2-.33 4.15 4.15 0 0 0 1.7-3.17s0-.07 0-.11a8.47 8.47 0 0 0 .05-1.06 17.42 17.42 0 0 0-3.36-9.53 18.15 18.15 0 0 0-2.39-2.75 13.21 13.21 0 0 0-2.31-1.81c-1.83-1.05-3.51-1.27-4.65-.62s-1.78 2.2-1.78 4.33a12.85 12.85 0 0 0 .36 2.91l-3 1.74v-.16a16.83 16.83 0 0 1-.66-4.49c0-3.39 1.23-6 3.47-7.25s5.06-1.07 8 .63a16.64 16.64 0 0 1 3.67 2.94 21.71 21.71 0 0 1 2.27 2.82 20.74 20.74 0 0 1 3.78 11.15Z",
    style: {
      fill: "#263238",
      transformOrigin: "270.965px 213.886px"
    },
    id: "elkn1mpx7jeop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.64 204.55a12 12 0 0 1-.19 2.18 9.64 9.64 0 0 1-.27 1.12 6.69 6.69 0 0 1-3 4 6.22 6.22 0 0 1-3.17.83 6.47 6.47 0 0 1-.87-.06c0-.16-.08-.32-.11-.51a5.38 5.38 0 0 1 .45-2.83 3.18 3.18 0 0 0 2-.34 4.14 4.14 0 0 0 1.7-3.16s0-.08 0-.12v-1.06a17.33 17.33 0 0 0-3.37-9.52 18.25 18.25 0 0 0-2.38-2.76 13.21 13.21 0 0 0-2.35-1.76c-1.83-1-3.51-1.27-4.65-.62s-1.78 2.2-1.78 4.34a12.77 12.77 0 0 0 .36 2.9l-3 1.75v-.16a16.77 16.77 0 0 1-.66-4.49c0-3.39 1.23-6 3.46-7.25s5.07-1.07 8 .63a16.66 16.66 0 0 1 3.65 2.94 20.15 20.15 0 0 1 2.27 2.82 20.75 20.75 0 0 1 3.91 11.13Z",
    style: {
      fill: "#263238",
      transformOrigin: "295.995px 199.449px"
    },
    id: "elpf7ufhu4pv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67 190.09a11.87 11.87 0 0 1-.19 2.18 9.14 9.14 0 0 1-.27 1.09 6.67 6.67 0 0 1-3 4 6.7 6.7 0 0 1-4 .77c0-.16-.08-.34-.11-.51a5.5 5.5 0 0 1 .44-2.84 3.14 3.14 0 0 0 2-.34 4.1 4.1 0 0 0 1.69-3.16s0-.07 0-.11a8.38 8.38 0 0 0 .06-1.07 17.34 17.34 0 0 0-3.36-9.52 17.73 17.73 0 0 0-2.4-2.75 12.8 12.8 0 0 0-2.34-1.76c-1.83-1.05-3.51-1.27-4.65-.62s-1.78 2.2-1.78 4.33a13 13 0 0 0 .36 2.92l-3 1.73v-.16a16.77 16.77 0 0 1-.66-4.49c0-3.39 1.23-6 3.46-7.24s5.07-1.08 8 .62a16.14 16.14 0 0 1 3.66 2.94 21.11 21.11 0 0 1 2.28 2.82 20.88 20.88 0 0 1 3.81 11.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "321.065px 184.953px"
    },
    id: "elvnhlku44ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.135px 268.405px"
    },
    id: "elz1go1um34ko",
    className: "animable",
    d: "m164.37 337.58 189.67-109.42-4.13-28.93-189.68 109.42 4.14 28.93z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "257.135px 268.405px"
    },
    className: "animable",
    id: "elw438oq43mnj"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "257.135px 268.405px"
    },
    id: "el442xusiv8tb",
    className: "animable",
    d: "m164.37 337.58 189.67-109.42-4.13-28.93-189.68 109.42 4.14 28.93z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.32 344.6c.23 1.6 1.71 2.14 3.3 1.22l14.24-8.21a5.05 5.05 0 0 0 2.48-4.56c-.23-1.6-1.71-2.15-3.31-1.23L181.8 340a5 5 0 0 0-2.48 4.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "189.328px 338.821px"
    },
    id: "el47fxqw3a0en",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33 330.74c.23 1.59 1.71 2.14 3.3 1.22l14.24-8.21a5 5 0 0 0 2.47-4.57c-.23-1.59-1.7-2.14-3.3-1.22l-14.23 8.22a5 5 0 0 0-2.48 4.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "213.335px 324.96px"
    },
    id: "elrjo5i7wnc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.34 316.87c.22 1.6 1.7 2.15 3.3 1.23l14.23-8.22a5 5 0 0 0 2.48-4.56c-.23-1.59-1.71-2.14-3.3-1.22l-14.24 8.21a5 5 0 0 0-2.47 4.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "237.345px 311.1px"
    },
    id: "el7m2qltlvhmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.34 303c.23 1.6 1.71 2.15 3.31 1.23l14.23-8.23a5 5 0 0 0 2.48-4.56c-.23-1.6-1.71-2.14-3.31-1.22l-14.23 8.21a5.05 5.05 0 0 0-2.48 4.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "261.35px 297.224px"
    },
    id: "elqhgyz1zi45h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.35 289.15c.23 1.6 1.71 2.14 3.31 1.22l14.23-8.21a5 5 0 0 0 2.48-4.56c-.23-1.6-1.71-2.15-3.31-1.22l-14.23 8.21a5 5 0 0 0-2.48 4.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "285.36px 283.373px"
    },
    id: "elwkp08vwj88b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.36 275.29c.23 1.6 1.71 2.14 3.3 1.22l14.24-8.21a5.05 5.05 0 0 0 2.48-4.56c-.23-1.6-1.71-2.15-3.31-1.23l-14.23 8.22a5 5 0 0 0-2.48 4.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "309.369px 269.511px"
    },
    id: "ell04nf0cwtxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.37 261.43c.23 1.59 1.71 2.14 3.3 1.22l14.24-8.21a5 5 0 0 0 2.47-4.57c-.23-1.59-1.7-2.14-3.3-1.22l-14.23 8.22a5 5 0 0 0-2.48 4.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "333.375px 255.65px"
    },
    id: "eleqpr6k6jd15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "269.199px 352.185px"
    },
    className: "animable",
    id: "elge4rpxuf7sa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.17 344.76a.76.76 0 0 1-.81-.58l-11.59-81a.6.6 0 0 1 .63-.65.75.75 0 0 1 .8.59l11.6 81a.59.59 0 0 1-.63.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "353.285px 303.645px"
    },
    id: "elmodcnrl0x2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.15 358.63a.76.76 0 0 1-.81-.59l-11.59-81a.59.59 0 0 1 .63-.64.76.76 0 0 1 .81.58l11.59 81a.59.59 0 0 1-.63.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "329.265px 317.515px"
    },
    id: "el4k0k4z0qioi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.13 372.5a.76.76 0 0 1-.8-.59l-11.6-81a.6.6 0 0 1 .63-.65.77.77 0 0 1 .81.59l11.59 81a.6.6 0 0 1-.63.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "305.245px 331.38px"
    },
    id: "elzl83ascqwjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.11 386.37a.77.77 0 0 1-.8-.59l-11.6-81a.6.6 0 0 1 .63-.65.77.77 0 0 1 .81.59l11.59 81a.6.6 0 0 1-.63.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "281.225px 345.25px"
    },
    id: "elv1h2g0rwsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1 400.23a.76.76 0 0 1-.81-.58l-11.6-81a.59.59 0 0 1 .63-.64.76.76 0 0 1 .81.58l11.6 81a.59.59 0 0 1-.63.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.21px 359.12px"
    },
    id: "elob27euhtot9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08 414.1a.77.77 0 0 1-.81-.59l-11.59-81a.59.59 0 0 1 .63-.64.75.75 0 0 1 .8.58l11.6 81a.6.6 0 0 1-.63.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "233.195px 372.985px"
    },
    id: "eln3w9klkaysq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06 428a.77.77 0 0 1-.81-.59l-11.59-81a.6.6 0 0 1 .63-.65.76.76 0 0 1 .8.59l11.6 81a.6.6 0 0 1-.63.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "209.175px 386.88px"
    },
    id: "elnqvz50zlzzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 441.84a.76.76 0 0 1-.8-.59l-11.6-81a.59.59 0 0 1 .63-.64.76.76 0 0 1 .81.59l11.59 81a.6.6 0 0 1-.63.64Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "185.115px 400.725px"
    },
    id: "el2lcfvbn9mzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34 381.1a.84.84 0 0 1-.66-.28.55.55 0 0 1 .14-.86L350 282.89a.83.83 0 0 1 1 .19.54.54 0 0 1-.14.85L182.69 381a.79.79 0 0 1-.35.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "266.34px 331.95px"
    },
    id: "elhb90rvna2tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.24 401.34a.84.84 0 0 1-.66-.28.54.54 0 0 1 .14-.85l168.13-97.07a.83.83 0 0 1 1 .18.55.55 0 0 1-.14.86l-168.12 97.07a.73.73 0 0 1-.35.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.215px 352.193px"
    },
    id: "el8bsuainr0op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.14 421.59a.82.82 0 0 1-.66-.28.55.55 0 0 1 .14-.86l168.13-97.07a.83.83 0 0 1 1 .19.54.54 0 0 1-.14.85l-168.12 97.07a.88.88 0 0 1-.35.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "272.115px 372.44px"
    },
    id: "elpyifzwtufgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 441.84a1 1 0 0 1-.37-.07.68.68 0 0 1-.43-.52l-11.6-81a.53.53 0 0 1 .28-.54l168.13-97.07a.82.82 0 0 1 .72 0 .68.68 0 0 1 .43.52l11.6 81a.55.55 0 0 1-.28.55l-168.09 97.03a.79.79 0 0 1-.39.1Zm-10.91-81.28 11.39 79.56 166.79-96.3-11.39-79.56Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.18px 352.198px"
    },
    id: "el6qqp5nfdyab",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17,
      transformOrigin: "269.199px 352.185px"
    },
    className: "animable",
    id: "elmasr2xi7ojd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.17 344.76a.76.76 0 0 1-.81-.58l-11.59-81a.6.6 0 0 1 .63-.65.75.75 0 0 1 .8.59l11.6 81a.59.59 0 0 1-.63.64Z",
    id: "el6c6igl4j8qx",
    className: "animable",
    style: {
      transformOrigin: "353.285px 303.645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.15 358.63a.76.76 0 0 1-.81-.59l-11.59-81a.59.59 0 0 1 .63-.64.76.76 0 0 1 .81.58l11.59 81a.59.59 0 0 1-.63.65Z",
    id: "el7wy3fa38imh",
    className: "animable",
    style: {
      transformOrigin: "329.265px 317.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.13 372.5a.76.76 0 0 1-.8-.59l-11.6-81a.6.6 0 0 1 .63-.65.77.77 0 0 1 .81.59l11.59 81a.6.6 0 0 1-.63.65Z",
    id: "eldh4af04se5b",
    className: "animable",
    style: {
      transformOrigin: "305.245px 331.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.11 386.37a.77.77 0 0 1-.8-.59l-11.6-81a.6.6 0 0 1 .63-.65.77.77 0 0 1 .81.59l11.59 81a.6.6 0 0 1-.63.65Z",
    id: "elg8vycx18hqc",
    className: "animable",
    style: {
      transformOrigin: "281.225px 345.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1 400.23a.76.76 0 0 1-.81-.58l-11.6-81a.59.59 0 0 1 .63-.64.76.76 0 0 1 .81.58l11.6 81a.59.59 0 0 1-.63.64Z",
    id: "elxq3e88nc10m",
    className: "animable",
    style: {
      transformOrigin: "257.21px 359.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.08 414.1a.77.77 0 0 1-.81-.59l-11.59-81a.59.59 0 0 1 .63-.64.75.75 0 0 1 .8.58l11.6 81a.6.6 0 0 1-.63.65Z",
    id: "elwqt9e84y0o",
    className: "animable",
    style: {
      transformOrigin: "233.195px 372.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06 428a.77.77 0 0 1-.81-.59l-11.59-81a.6.6 0 0 1 .63-.65.76.76 0 0 1 .8.59l11.6 81a.6.6 0 0 1-.63.65Z",
    id: "elwat7ahghsh",
    className: "animable",
    style: {
      transformOrigin: "209.175px 386.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 441.84a.76.76 0 0 1-.8-.59l-11.6-81a.59.59 0 0 1 .63-.64.76.76 0 0 1 .81.59l11.59 81a.6.6 0 0 1-.63.64Z",
    id: "elbvttn0eg56a",
    className: "animable",
    style: {
      transformOrigin: "185.115px 400.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34 381.1a.84.84 0 0 1-.66-.28.55.55 0 0 1 .14-.86L350 282.89a.83.83 0 0 1 1 .19.54.54 0 0 1-.14.85L182.69 381a.79.79 0 0 1-.35.1Z",
    id: "el812dn4npo6",
    className: "animable",
    style: {
      transformOrigin: "266.34px 331.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.24 401.34a.84.84 0 0 1-.66-.28.54.54 0 0 1 .14-.85l168.13-97.07a.83.83 0 0 1 1 .18.55.55 0 0 1-.14.86l-168.12 97.07a.73.73 0 0 1-.35.09Z",
    id: "elcnoxjinhv9c",
    className: "animable",
    style: {
      transformOrigin: "269.215px 352.193px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.14 421.59a.82.82 0 0 1-.66-.28.55.55 0 0 1 .14-.86l168.13-97.07a.83.83 0 0 1 1 .19.54.54 0 0 1-.14.85l-168.12 97.07a.88.88 0 0 1-.35.1Z",
    id: "eluu9rnq81xyk",
    className: "animable",
    style: {
      transformOrigin: "272.115px 372.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 441.84a1 1 0 0 1-.37-.07.68.68 0 0 1-.43-.52l-11.6-81a.53.53 0 0 1 .28-.54l168.13-97.07a.82.82 0 0 1 .72 0 .68.68 0 0 1 .43.52l11.6 81a.55.55 0 0 1-.28.55l-168.09 97.03a.79.79 0 0 1-.39.1Zm-10.91-81.28 11.39 79.56 166.79-96.3-11.39-79.56Z",
    id: "eleehzaanzv5",
    className: "animable",
    style: {
      transformOrigin: "269.18px 352.198px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.92 281.65a5 5 0 0 1 2.09-.74 2.67 2.67 0 0 1 1.64.39 3.75 3.75 0 0 1 1.21 1.4 8.7 8.7 0 0 1 .81 2.27c.24 1.06.43 2.13.58 3.24a12.32 12.32 0 0 1 .07 2.7 8.75 8.75 0 0 1-.52 2.4 7.22 7.22 0 0 1-1.19 2 7.13 7.13 0 0 1-1.89 1.56l-3.94 2.27a.29.29 0 0 1-.33 0 .46.46 0 0 1-.19-.34l-2.52-14.11a.93.93 0 0 1 0-.49.59.59 0 0 1 .27-.34Zm3.64 4.54a4.53 4.53 0 0 0-.43-1.18 2 2 0 0 0-.67-.77 1.48 1.48 0 0 0-.93-.24 2.79 2.79 0 0 0-1.2.42l-2.1 1.21 1.75 9.83 2.18-1.26a3.74 3.74 0 0 0 1.07-.89 4.05 4.05 0 0 0 .65-1.14 4.38 4.38 0 0 0 .29-1.32 6.74 6.74 0 0 0 0-1.42c-.17-1.11-.38-2.18-.61-3.24Z",
    style: {
      fill: "#455a64",
      transformOrigin: "221.035px 290.046px"
    },
    id: "elsqg667ffg6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18 286.11a.27.27 0 0 1 .32 0 .46.46 0 0 1 .2.35l.3 1.54a.88.88 0 0 1 0 .48.62.62 0 0 1-.27.35l-6.87 4a.29.29 0 0 1-.32 0 .47.47 0 0 1-.2-.34l-2.52-14.11a.93.93 0 0 1 .05-.49.68.68 0 0 1 .27-.34l6.74-3.89a.29.29 0 0 1 .33 0 .51.51 0 0 1 .2.34l.28 1.55a.93.93 0 0 1-.06.49.69.69 0 0 1-.26.35l-5.05 2.91.62 3.48 4.7-2.72a.29.29 0 0 1 .33 0 .47.47 0 0 1 .2.34l.28 1.55a.92.92 0 0 1 0 .49.66.66 0 0 1-.27.35l-4.71 2.72.65 3.62Z",
    style: {
      fill: "#455a64",
      transformOrigin: "231.92px 283.243px"
    },
    id: "el7ib41iwaws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79 278.8a1.05 1.05 0 0 1 .09-.52.64.64 0 0 1 .27-.31l1.26-.73a.32.32 0 0 1 .34 0 .42.42 0 0 1 .19.35 8.73 8.73 0 0 1 0 2 7.77 7.77 0 0 1-.55 2.1 8.54 8.54 0 0 1-1.21 2 7.18 7.18 0 0 1-2 1.66 4.41 4.41 0 0 1-2 .65 2.75 2.75 0 0 1-1.63-.43 3.86 3.86 0 0 1-1.24-1.39 8.34 8.34 0 0 1-.82-2.2c-.12-.54-.24-1.15-.35-1.82s-.22-1.28-.3-1.85a12.4 12.4 0 0 1 0-2.65 9.17 9.17 0 0 1 .56-2.43 7.48 7.48 0 0 1 1.19-2.05 6.35 6.35 0 0 1 1.82-1.55 5 5 0 0 1 2.17-.75 3.07 3.07 0 0 1 1.63.36 3.12 3.12 0 0 1 1.13 1.15 6 6 0 0 1 .64 1.59.75.75 0 0 1-.05.49.68.68 0 0 1-.27.34l-1.27.74a.44.44 0 0 1-.32 0 .5.5 0 0 1-.25-.33 2.19 2.19 0 0 0-.37-.73 1.61 1.61 0 0 0-.6-.47 1.65 1.65 0 0 0-.85-.1 2.89 2.89 0 0 0-1.1.41 3.32 3.32 0 0 0-1 .87 4.24 4.24 0 0 0-.63 1.14 4.7 4.7 0 0 0-.28 1.32 6.54 6.54 0 0 0 0 1.4c.08.57.18 1.18.3 1.85s.24 1.28.36 1.82a4.75 4.75 0 0 0 .42 1.19 2.07 2.07 0 0 0 .66.76 1.47 1.47 0 0 0 .88.26 2.33 2.33 0 0 0 1.11-.35 4 4 0 0 0 1-.82 4.39 4.39 0 0 0 .66-1 3.84 3.84 0 0 0 .41-2Z",
    style: {
      fill: "#455a64",
      transformOrigin: "241.883px 277.439px"
    },
    id: "eljuy6r3pm5d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.43 274.41a.3.3 0 0 1 .33 0 .47.47 0 0 1 .2.34l.28 1.55a.93.93 0 0 1-.05.49.68.68 0 0 1-.27.34l-6.87 4a.29.29 0 0 1-.33 0 .49.49 0 0 1-.19-.35L247 266.66a.92.92 0 0 1 .05-.49.65.65 0 0 1 .27-.35l6.74-3.89a.3.3 0 0 1 .33 0 .53.53 0 0 1 .2.35l.27 1.55a.8.8 0 0 1-.05.48.65.65 0 0 1-.26.35l-5.06 2.92.62 3.47 4.71-2.72a.32.32 0 0 1 .33 0 .53.53 0 0 1 .2.35l.28 1.55a.94.94 0 0 1-.06.49.66.66 0 0 1-.26.34l-4.71 2.72.65 3.62Z",
    style: {
      fill: "#455a64",
      transformOrigin: "252.12px 271.531px"
    },
    id: "elhbtzts90ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.08 265.33 1.69-8.92c0-.1.08-.26.14-.48a.93.93 0 0 1 .42-.5l1.07-.62a.3.3 0 0 1 .33 0 .51.51 0 0 1 .2.34l2.51 14.11a.88.88 0 0 1-.05.48.62.62 0 0 1-.27.35l-1.27.73a.27.27 0 0 1-.32 0 .47.47 0 0 1-.2-.34l-1.52-8.48-1.16 6a3.08 3.08 0 0 1-.16.49.74.74 0 0 1-.32.39l-.82.47a.35.35 0 0 1-.39 0 1 1 0 0 1-.28-.24l-2.91-3.74 1.52 8.54a.93.93 0 0 1-.05.49.65.65 0 0 1-.27.35l-1.27.73a.29.29 0 0 1-.32 0 .45.45 0 0 1-.2-.34l-2.52-14.11a.88.88 0 0 1 0-.48.66.66 0 0 1 .27-.35l1.06-.61a.44.44 0 0 1 .51 0 2.92 2.92 0 0 1 .27.23Z",
    style: {
      fill: "#455a64",
      transformOrigin: "263.04px 265.144px"
    },
    id: "elsog103qgumq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.41 268.2a.29.29 0 0 1-.33 0 .51.51 0 0 1-.2-.34l-2.52-14.11a.94.94 0 0 1 .06-.49.62.62 0 0 1 .26-.34l4.62-2.67a3.36 3.36 0 0 1 1.75-.54 2.24 2.24 0 0 1 1.27.45 3 3 0 0 1 .83 1.06 4.72 4.72 0 0 1 .43 1.3 5.37 5.37 0 0 1 .09 1.24 5.3 5.3 0 0 1-.15 1.05 7.2 7.2 0 0 1-.25.81 3.41 3.41 0 0 1-.24.5 2.6 2.6 0 0 1 1.13.78 3.77 3.77 0 0 1 .78 1.89 6.94 6.94 0 0 1 .08 1.78 7.62 7.62 0 0 1-.38 1.84 5.91 5.91 0 0 1-.87 1.67 4.28 4.28 0 0 1-1.39 1.25Zm4.08-14.35a1.31 1.31 0 0 0-.6-1 1.43 1.43 0 0 0-1.26.26l-2.77 1.6.6 3.36 2.77-1.59a2.64 2.64 0 0 0 1.11-1.12 2.4 2.4 0 0 0 .15-1.51Zm-2.88 10.65 2.89-1.67a2.57 2.57 0 0 0 1.17-1.24 2.73 2.73 0 0 0 .16-1.58 1.5 1.5 0 0 0-.65-1.11 1.35 1.35 0 0 0-1.34.19l-2.9 1.67Z",
    style: {
      fill: "#455a64",
      transformOrigin: "274.697px 258.981px"
    },
    id: "el97l9on5q1ra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52 255.31a.3.3 0 0 1 .33 0 .51.51 0 0 1 .2.34l.27 1.55a.93.93 0 0 1-.05.49.62.62 0 0 1-.26.34l-6.87 4a.3.3 0 0 1-.33 0 .48.48 0 0 1-.2-.34l-2.51-14.1a.91.91 0 0 1 0-.49.65.65 0 0 1 .26-.35l6.75-3.89a.27.27 0 0 1 .32 0 .47.47 0 0 1 .2.35l.28 1.55a.88.88 0 0 1 0 .48.62.62 0 0 1-.27.35l-5.05 2.92.62 3.47 4.71-2.72a.29.29 0 0 1 .33 0 .48.48 0 0 1 .19.34l.28 1.56a.88.88 0 0 1-.05.48.62.62 0 0 1-.27.35l-4.7 2.72.64 3.62Z",
    style: {
      fill: "#455a64",
      transformOrigin: "285.2px 252.443px"
    },
    id: "elpwj6ckgux5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.1 238.82c1.31-.75 2.37-.9 3.2-.45a3.84 3.84 0 0 1 1.64 2.93 7.46 7.46 0 0 1 0 3 6.17 6.17 0 0 1-1.24 2.56l3.12 4.15a.48.48 0 0 1 .09.21.7.7 0 0 1 0 .4.53.53 0 0 1-.22.28l-1.33.77c-.21.12-.37.14-.5.05a.94.94 0 0 1-.27-.25l-3-3.91-2.08 1.2.91 5.09a.94.94 0 0 1-.06.49.62.62 0 0 1-.26.34l-1.27.73a.29.29 0 0 1-.33 0 .51.51 0 0 1-.2-.34L289.75 242a.93.93 0 0 1 .05-.49.59.59 0 0 1 .27-.34Zm-1.1 8.23 2.27-1.31a3.74 3.74 0 0 0 1.35-1.26 2.75 2.75 0 0 0 .23-2c-.14-.82-.42-1.26-.82-1.33a2.32 2.32 0 0 0-1.5.4l-2.27 1.31Z",
    style: {
      fill: "#455a64",
      transformOrigin: "295.338px 247.289px"
    },
    id: "el7b3044wismu",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-103",
    className: "animable",
    style: {
      transformOrigin: "249.025px 218.692px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.26 233.55s17 9.77 20.82 12.59 6 11.17 2.37 18.8-3.78 13-1.15 19.31 0 13.77 3 16.8 5.81 7.55 7.22 16.07 4.15 21.69 13.61 19.57 12.16-18.18 7.58-27.83-10.64-32.76-6.85-47.37 13.18-33.68-6.53-51Z",
    style: {
      opacity: 0.2,
      transformOrigin: "254.074px 273.704px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-103",
    className: "animable",
    style: {
      transformOrigin: "249.025px 218.692px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-103",
    className: "animable",
    style: {
      transformOrigin: "255.036px 268.597px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.14 271.92s-6.54 11.14-7.47 15.78c-1 4.83-2.37 6.27-2.31 11.68 0 1.18.29 3.58.3 4.53a1.39 1.39 0 0 1-1.5 1.55c-2.17.13-5.1-4.34-6.15-8.9a130.35 130.35 0 0 1-2-15.82 6.74 6.74 0 0 1 1.16-3.31 9.85 9.85 0 0 1 1.23-1.62c1-2 1.92-6 2.91-8.7Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "264.575px 286.288px"
    },
    id: "elev17cgxmpgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26 284.58a5.19 5.19 0 0 0-.8 1.51c-.19 1 1.54 4.48 2.23 5.77a7.87 7.87 0 0 1 .79 5.76 13.53 13.53 0 0 0 2 9.13 21.55 21.55 0 0 0 9.61 8.48c4.89 2.32 7.07 0 7.07 0s1.95-2.24 1.14-3.39-22.04-27.26-22.04-27.26Z",
    style: {
      fill: "#263238",
      transformOrigin: "260.971px 300.421px"
    },
    id: "elg08rxp2zm8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42 275.81c-.16 0-.43-.12-.9.31-.18.16-1.45 2.33-2.4 3.43s-3.32 3.1-3.86 5c.64 4 3.82 7.13 3.84 10.79s-.53 7.84 4.35 13 10.48 6.46 12.69 5.59 2.33-3.07.09-7.64c-2.37-4.85-3-14.71-3-14.71a31.78 31.78 0 0 1 .05-4.14 26.41 26.41 0 0 1 1-4 2.33 2.33 0 0 0-1.36-3.13 14 14 0 0 0-2.7-1.37 4.58 4.58 0 0 0-3-.07 20.9 20.9 0 0 1-2 .9 2.64 2.64 0 0 1-2.64-.87 2.29 2.29 0 0 1-.37-2.6s.21-.49.21-.49Z",
    style: {
      fill: "#37474f",
      transformOrigin: "261.557px 294.987px"
    },
    id: "elb1dkq32ffpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74 304.41a8.86 8.86 0 0 1 8.61-3.16c5.85.87 7.45 4.14 8.08 6 .76 2.24 1.32 6.18-1.25 6.92-2.78.79-5.75 0-10.16-3.08s-5.28-6.68-5.28-6.68Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "264.404px 307.771px"
    },
    id: "eln90m0gapixn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35 286.93a.61.61 0 0 0 .54.08c1-.33 5.9-.64 8.31 2.35.4-.24.41-.78.05-1.59-3-2.55-7.62-2.28-8.8-1.88a.57.57 0 0 0-.33.75.6.6 0 0 0 .23.29Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "263.794px 287.496px"
    },
    id: "el9x90xt9pkwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.31 292.86a1.84 1.84 0 0 0-.11-1.66 11.07 11.07 0 0 0-8.42-1.57.57.57 0 0 0-.34.75.62.62 0 0 0 .24.29.59.59 0 0 0 .53.08c.95-.32 5.62-.61 8.1 2.11Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "263.928px 291.12px"
    },
    id: "eli9tc0u9htpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.55 301.11a3.31 3.31 0 0 0-.44-2.22c-3-2.43-7.52-2.17-8.68-1.78a.57.57 0 0 0-.34.75.68.68 0 0 0 .24.29.59.59 0 0 0 .53.08c1.03-.35 6.46-.67 8.69 2.88Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "264.819px 298.984px"
    },
    id: "el5g674k78wmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 294.41a.61.61 0 0 0 .54.08c1-.33 5.79-.63 8.23 2.25a2.1 2.1 0 0 0-.24-1.8 11.08 11.08 0 0 0-8.42-1.57.57.57 0 0 0-.34.75.66.66 0 0 0 .23.29Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "264.301px 294.93px"
    },
    id: "elae0g3a4euus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.24 287.21s.3 14.79 2.15 20.78 2.83 8.89 5.89 13.66c.66 1 2.23 3 2.78 3.85a1.47 1.47 0 0 1-.48 2.21c-1.85 1.32-8.82.69-12.28-2.77s-6.08-10.17-8.06-12.84c-.74-1-1.42-2-2.06-3.08s-.29-1.87-.21-2.91c0-.51.31-1.85.31-1.85-.18-2.51-1.06-6.53-1.48-9Z",
    style: {
      fill: "#b16668",
      transformOrigin: "276.086px 307.78px"
    },
    id: "el8voqk3knbjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34 315a5.32 5.32 0 0 0-.08 1.79c.25 1 3.46 3.55 4.69 4.46a8.21 8.21 0 0 1 3.31 5.1 14.26 14.26 0 0 0 6 7.75 22.61 22.61 0 0 0 12.88 3.73c5.67 0 6.71-3.15 6.71-3.15s.84-3-.44-3.72S262.34 315 262.34 315Z",
    style: {
      fill: "#263238",
      transformOrigin: "279.17px 326.417px"
    },
    id: "elt0tes6m2k78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.19 303.47c-.16 0-.45.09-.7.7-.1.23-.33 2.85-.74 4.32s-1.75 4.41-1.41 6.51c2.38 3.47 6.8 5 8.45 8.5s3 7.65 9.94 10.38 12.8 1.44 14.5-.37.84-4-3.32-7.28c-4.42-3.52-9.43-12.56-9.43-12.56a31.92 31.92 0 0 1-1.8-3.95 27.54 27.54 0 0 1-.86-4.19 3.22 3.22 0 0 0-.83-1.76 3.31 3.31 0 0 0-1.86-.59 13.93 13.93 0 0 0-3.16-.09 4.83 4.83 0 0 0-2.84 1.26 20.58 20.58 0 0 1-1.48 1.74 2.76 2.76 0 0 1-2.89.35 2.36 2.36 0 0 1-1.51-2.29s-.06-.68-.06-.68Z",
    style: {
      fill: "#455a64",
      transformOrigin: "279.168px 319.246px"
    },
    id: "elevv47gris7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38 331.3a9.28 9.28 0 0 1 6.74-6.85c5.92-1.79 8.9.59 10.34 2.09 1.72 1.78 4 5.26 1.9 7.1-2.28 2-5.44 2.57-11 1.63s-7.98-3.97-7.98-3.97Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "286.291px 329.761px"
    },
    id: "eli7ulpd338k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 313.14a.62.62 0 0 0 .53-.17c.78-.75 5.3-3.24 8.92-1.49.28-.4 0-.92-.66-1.53-3.94-1.08-8.23 1.26-9.16 2.16a.59.59 0 0 0 0 .86.71.71 0 0 0 .37.17Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "276.501px 311.409px"
    },
    id: "el3xslgekv3ph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.12 314.74a1.94 1.94 0 0 0-.84-1.52 11.57 11.57 0 0 0-8.67 2.28.59.59 0 0 0 0 .86.61.61 0 0 0 .35.17.63.63 0 0 0 .54-.17c.76-.72 5.06-3.08 8.62-1.62Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "278.272px 314.822px"
    },
    id: "elsl6gncq6gdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 322a3.53 3.53 0 0 0-1.41-1.91c-3.89-1-8.09 1.31-9 2.2a.59.59 0 0 0 0 .86.68.68 0 0 0 .35.17.64.64 0 0 0 .54-.17c.81-.79 5.8-3.52 9.52-1.15Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "282.702px 321.586px"
    },
    id: "elbqyrrjdcqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 319.93a.66.66 0 0 0 .54-.17c.77-.74 5.2-3.18 8.8-1.54a2.22 2.22 0 0 0-1-1.61 11.56 11.56 0 0 0-8.67 2.29.58.58 0 0 0 0 .85.62.62 0 0 0 .33.18Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "280.412px 318.217px"
    },
    id: "elvjqw1pya0pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49 199.36c5.3 5.2 23 21.1 30.22 30.06 2.1 2.59 2.46 5.65.94 12-2.07 8.61-13.21 37.32-13.21 37.32-1.19 1.54-2.39-1.88-2.39-1.88l-26.67-46.2Z",
    style: {
      fill: "#37474f",
      transformOrigin: "268.981px 239.249px"
    },
    id: "elwf8d1jz3mga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.36 269.27c-6.65-7.41-25.5-49.47-25.5-49.47 3.73-2.33 9.27-11.41 9.27-11.41.78 4-2.32 10.73-3.64 12.65 1.68 1.94 9.72 10.72 16.4 17.79a10.89 10.89 0 0 1 3.5 7.4c.39 8.39.38 21.41-.03 23.04Z",
    style: {
      opacity: 0.3,
      transformOrigin: "263.768px 238.83px"
    },
    className: "animable",
    id: "eldafv0ov6br5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.62 201.46-2.13-2.1-44.62 4.25c.94 8 .94 12.08 2.5 16.46s3.31 9.08 13.47 16.05c9.78 6.71 21.88 13.91 24.27 15.51 1.81 1.2 2.17 5.21 2.32 10.37.16 5.4-.36 9.54 3.26 21.36 3.54 11.58 4.25 14.07 4.25 14.07s7.78 2 13.69-1.89c0 0-1.78-38.19-2.34-45.1-.31-3.86 0-5.83-4.09-10.61-3.46-4.09-18.29-19.1-18.29-19.1s8.81-7.49 7.71-19.27Z",
    style: {
      fill: "#455a64",
      transformOrigin: "245.75px 248.652px"
    },
    id: "el9lq05dicicc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-103",
    className: "animable",
    style: {
      transformOrigin: "249.025px 174.623px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.31 144.79c1 0 3.67 3.52 4.33 7.66s-1.29 8.52-2.43 9.07-7.9-7.73-7.9-7.73Z",
    style: {
      fill: "#37474f",
      transformOrigin: "271.542px 153.168px"
    },
    id: "elimfnbf8wmon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87 154.66c-3.2 1.76-31.85 13.39-38 16.63-2.9-11 3.77-21.16 3.77-21.16s24-6.57 27.22-8.49c0 0 2.2-3.71 3.27-5.43 1.75-2.82 4.81-7 7.25-11.72.52-1 0-3.49-.31-4.56-1-3.17-.65-4.3-1.06-7.06-.32-2.16-1.14-3.22-.69-3.52a2.48 2.48 0 0 1 3.25.92 10.47 10.47 0 0 1 2 3c.13-.77.23-1.57.31-2.29a30.19 30.19 0 0 0 .27-3.29c0-1.52.05-2.19.1-2.93a9.88 9.88 0 0 1 .93-4.41 1.59 1.59 0 0 1 1.42-.8c.69.05 1 .82 1.16 1.42a3.1 3.1 0 0 0 .76 1.47 16.51 16.51 0 0 0 2 1 3.1 3.1 0 0 1 1.26 1.87 2.28 2.28 0 0 0 1.25 1.7 5.06 5.06 0 0 1 1.75 1.75 4 4 0 0 1 .66 2.21 19.1 19.1 0 0 1 0 2.83 33 33 0 0 1-1.34 6.81 103.5 103.5 0 0 1-4.1 10.68c-3.47 8.06-3.79 9.71-7.07 16.38-1.69 3.21-1.72 4.59-6.06 6.99Z",
    style: {
      fill: "#b16668",
      transformOrigin: "278.816px 135.42px"
    },
    id: "eljtskmrsrpxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 115.48c2 2.18 3.11 4.79 2.48 7.27 1.4-2.55.51-6.19-2.48-7.27Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "298.684px 119.115px"
    },
    id: "elhswf44ptzda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 149c1.6-.11 8.22-.82 12.14-1.52 6.56-1.16 12.07-2.65 12.07-2.65a18 18 0 0 0 1.91 16.72s-21.79 7.81-24.85 11.59a35 35 0 0 1-4.37-10.93 15.61 15.61 0 0 1 3.1-13.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "259.423px 158.985px"
    },
    id: "el6jmksmyzwn6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 153.68s-5.6 10.89-5.95 18c-.57 12-.32 28.18 2.77 43.44 11.39 7.19 42.12.82 46.39-13.48 0 0-3.27-6.52-4.21-11.11.13-6.64.77-19 .6-23.39-.43-11-7-17.61-9.5-18.2a94.14 94.14 0 0 0-14.35 1c-2.7.4-6.33 1.12-15.75 3.74Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.509px 183.516px"
    },
    id: "elbpbyh4fxkxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13 105.93c-11.37-.81-18.35 3.47-19.66 11.3-2.2 2.11-3.53 5.92-1.89 11.15s6.54 9.66 8.31 14.24l27-18.53c1.21-8.81-2.83-17.38-13.76-18.16Z",
    style: {
      fill: "#263238",
      transformOrigin: "234.973px 124.226px"
    },
    id: "elhbot9p3li15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.92 131.48c-1.31.42-2-1.87-3-2.88a4.16 4.16 0 0 0-6.25 1.14c-2.16 3.14.49 8.11 2.91 9.18 3.55 1.57 5.06-2 5.06-2l.64 15.13s1.66 2.65 7 4.14c4.8 1.36 12.49-1.11 7.87-5.48v-3.55a16.07 16.07 0 0 0 6.86-.49c2.07-.78 3.35-1.93 4.35-5.61 1.95-7.19 1.23-17.9-1.3-24.21-4.85 4.3-13 4.21-18.49 2.81a7.68 7.68 0 0 1-4.12 5.88c.02 4.03-.05 5.46-1.53 5.94Z",
    style: {
      fill: "#b16668",
      transformOrigin: "235.173px 136.707px"
    },
    id: "eloxu0b3yhbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.5 138.49 4.86 1a2.39 2.39 0 0 1-2.86 1.95 2.62 2.62 0 0 1-2-2.95Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "241.915px 139.992px"
    },
    id: "elt3n1d9rzq2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.43 139.45a2.32 2.32 0 0 0-.87.17 2.6 2.6 0 0 0 1.94 1.86 2.37 2.37 0 0 0 1.35-.11 2.49 2.49 0 0 0-2.42-1.92Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "241.205px 140.491px"
    },
    id: "el9urrmh8nu5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07 147.15s-5.94-.84-9.07-2.91a9.77 9.77 0 0 1-3.83-3.9 9.48 9.48 0 0 0 2.19 4.33c3 3 10.73 4.25 10.73 4.25Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "234.63px 144.63px"
    },
    id: "elbisroygj5t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13 129.84a1.43 1.43 0 1 1-1.46-1.46 1.45 1.45 0 0 1 1.46 1.46Z",
    style: {
      fill: "#263238",
      transformOrigin: "237.7px 129.81px"
    },
    id: "elr0sp4thi7cp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.52 125.26-3.09 1.64a1.84 1.84 0 0 1 .75-2.43 1.71 1.71 0 0 1 2.34.79Z",
    style: {
      fill: "#263238",
      transformOrigin: "235.878px 125.588px"
    },
    id: "eltz69421c8ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.33 125.4-3.4-.92a1.68 1.68 0 0 1 2.1-1.27 1.84 1.84 0 0 1 1.3 2.19Z",
    style: {
      fill: "#263238",
      transformOrigin: "249.654px 124.273px"
    },
    id: "elok8ya0afx7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46 128.66a1.45 1.45 0 0 1-1.4 1.51 1.49 1.49 0 1 1 1.4-1.51Z",
    style: {
      fill: "#263238",
      transformOrigin: "248.971px 128.683px"
    },
    id: "el08spr6u73a5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a4a4d",
      transformOrigin: "245.665px 131.69px"
    },
    id: "elo99cgyhblqq",
    className: "animable",
    d: "m244.36 136.48 4.41-2.19-6.21-7.39 1.8 9.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.78 226.49c-.38-.21-.76-.43-1.12-.67a9 9 0 0 1-2.09-1.81 48.34 48.34 0 0 1-5.15-7c-3.06-4.73-6-9.54-8.86-14.4l9.72-20c5.3-9.87 4.6-21.92.84-28.7-9.26 2.53-11 4.28-15.06 14.35s-10.52 27.69-11.66 31.11c-1.49 4.44-1.17 6.3 2.33 10.64s16.66 17.37 18.82 20.08c.64.81.92 1.73 1.47 2.57a10.79 10.79 0 0 0 2.12 2.15 19.85 19.85 0 0 0 5.37 2.92c.52.22 1 .48 1.53.69.8.33 1.48.55 1.87 1.38a29 29 0 0 1 1.61 4.65 13.45 13.45 0 0 1 .23 2.84c0 .73.14 1.93.89 2.32s1.15-.65 1.39-1.14a2.64 2.64 0 0 1 .71-1.18 4.17 4.17 0 0 1 .94-.23 1.87 1.87 0 0 0 1.29-1.32c.32-.71 1.11-.89 1.59-1.46a4.91 4.91 0 0 0 .67-1.79 27.31 27.31 0 0 0 .59-3.25 9 9 0 0 0 .16-3.73 7.29 7.29 0 0 0-1.37-2.22 19.86 19.86 0 0 0-1.32-1.59c-.65-.74-1.31-1.59-2-2.32a5.42 5.42 0 0 0-2.18-1.51 35.27 35.27 0 0 1-3.33-1.38Z",
    style: {
      fill: "#b16668",
      transformOrigin: "212.831px 201.803px"
    },
    id: "elbyolxq4guac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56 202.57c-1.66-1.65-7.71-2.73-10.41-2.39a14.91 14.91 0 0 1 11.07 1Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "202.685px 201.06px"
    },
    id: "el1qd0y46iu7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64 153.53c-2.6.61-7.48 1.5-10.37 4.56s-4.11 6.27-6.78 13-5 13-5 13 .95 3.4 7.67 6.29 9 1.85 9 1.85 6.81-13.53 7.75-17.36 1.82-14.73-2.27-21.34Z",
    style: {
      fill: "#455a64",
      transformOrigin: "209.095px 172.971px"
    },
    id: "elk7sdsodlci",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistory);
export default __webpack_public_path__ + "static/media/noHistory.690c6035d6e72a02ac50960b95689b52.svg";
export { ForwardRef as ReactComponent };